import { jsx as Co } from "react/jsx-runtime";
import "./alert.js";
import { c as So, d as xo, b as Pa, e as Cl, O as Sl } from "./button.js";
import * as a from "react";
import oe, { useState as dn, useRef as et, useEffect as Rn, useMemo as kt, useContext as xl, forwardRef as Da, useImperativeHandle as Ta, useCallback as $n } from "react";
import "./text.js";
import "./modal.js";
import "./form.js";
import "./passwordInput.js";
import "./chatLayout.styles.js";
import "../theme/index.js";
import { B as El } from "./barsLoader.js";
import "./react-toastify.esm.js";
import "./card.js";
import "../theme/antd/index.js";
import "./status.js";
import { n as wl } from "./emotion-styled.browser.esm.js";
import { P as Pt, n as Q, q as St, d as ce, _ as F, v as yt, O as $l, z as Fr, c as K, w as Qe, R as _e, M as Nl, k as Mt, a as Ma, b as _a, h as en, a3 as Wr, Q as ka, ao as Eo, j as Mn, $ as cn, g as pn, m as tn, E as rr, C as Gt, o as zt, A as Zn, u as U, l as Ol, D as Pn, B as Il, af as Rl, K as wo, T as $o, ae as qr, y as Pl, I as Dl, J as Tl, am as Xe, ab as Ml, p as _l } from "./CSSMotionList.js";
import { _ as kl, D as Xr, e as Kl, i as Vn, g as Ur, l as Bl } from "./index.js";
import No, { flushSync as Oo, unstable_batchedUpdates as zl } from "react-dom";
import { _ as Pe } from "./extends.js";
import { R as Wn } from "./index5.js";
import { i as Ll } from "./index3.js";
import { u as Hl, g as Io, a as Ro } from "./Portal.js";
import { p as nn } from "./pickAttrs.js";
import { t as An, u as jl, a as _n, F as Gr, i as Vl } from "./ContextIsolator.js";
import { b as Al, u as Fl, R as Wl } from "./useIcons.js";
import { o as qn } from "./omit.js";
import { u as un, a as or } from "./useSize.js";
import { d as rn } from "./warning.js";
import { W as Ka, T as Ba, B as Po } from "./button2.js";
import { u as ql } from "./useId.js";
import { u as ar } from "./useLocale.js";
import { u as za, a as Xl } from "./useBreakpoint.js";
import { I as qt } from "./AntdIcon.js";
import { K as Ie } from "./KeyCode.js";
import { T as Ul, i as Gl } from "./roundedArrow.js";
import { F as Yl, s as Jl, a as Ql, b as Zl, c as es, i as Do, d as To } from "./Overflow.js";
import { g as ts, a as ns } from "./zoom.js";
import { g as rs } from "./PurePanel.js";
import { c as os, g as as, a as is, i as ls, k as ss, l as cs, m as ds, n as us } from "./index4.js";
import { u as fs } from "./useVariants.js";
import { g as vs } from "./compact-item.js";
import { c as wr } from "./reactNode.js";
import { K as Yr } from "./Keyframes.js";
import { m as La } from "./rootProvider.js";
import { g as ps } from "./collapse.js";
import { R as ms } from "./LoadingOutlined.js";
import { R as gs } from "./SearchOutlined.js";
import { I as hs } from "./TextArea.js";
import { T as Mo } from "./index6.js";
function $r(e) {
  return e != null && e === e.window;
}
const bs = (e) => {
  var t, r;
  if (typeof window > "u")
    return 0;
  let n = 0;
  return $r(e) ? n = e.pageYOffset : e instanceof Document ? n = e.documentElement.scrollTop : (e instanceof HTMLElement || e) && (n = e.scrollTop), e && !$r(e) && typeof n != "number" && (n = (r = ((t = e.ownerDocument) !== null && t !== void 0 ? t : e).documentElement) === null || r === void 0 ? void 0 : r.scrollTop), n;
};
function ys(e, t, r, n) {
  const o = r - t;
  return e /= n / 2, e < 1 ? o / 2 * e * e * e + t : o / 2 * ((e -= 2) * e * e + 2) + t;
}
function Cs(e, t = {}) {
  const {
    getContainer: r = () => window,
    callback: n,
    duration: o = 450
  } = t, i = r(), c = bs(i), l = Date.now(), d = () => {
    const v = Date.now() - l, f = ys(v > o ? o : v, c, e, o);
    $r(i) ? i.scrollTo(window.pageXOffset, f) : i instanceof Document || i.constructor.name === "HTMLDocument" ? i.documentElement.scrollTop = f : i.scrollTop = f, v < o ? Pt(d) : typeof n == "function" && n();
  };
  Pt(d);
}
var ir = function(t) {
  var r = t.className, n = t.customizeIcon, o = t.customizeIconProps, i = t.children, c = t.onMouseDown, l = t.onClick, d = typeof n == "function" ? n(o) : n;
  return /* @__PURE__ */ a.createElement("span", {
    className: r,
    onMouseDown: function(v) {
      v.preventDefault(), c == null || c(v);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: l,
    "aria-hidden": !0
  }, d !== void 0 ? d : /* @__PURE__ */ a.createElement("span", {
    className: Q(r.split(/\s+/).map(function(s) {
      return "".concat(s, "-icon");
    }))
  }, i));
}, Ss = function(t, r, n, o, i) {
  var c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, l = arguments.length > 6 ? arguments[6] : void 0, d = arguments.length > 7 ? arguments[7] : void 0, s = oe.useMemo(function() {
    if (St(o) === "object")
      return o.clearIcon;
    if (i)
      return i;
  }, [o, i]), v = oe.useMemo(function() {
    return !!(!c && o && (n.length || l) && !(d === "combobox" && l === ""));
  }, [o, c, n.length, l, d]);
  return {
    allowClear: v,
    clearIcon: /* @__PURE__ */ oe.createElement(ir, {
      className: "".concat(t, "-clear"),
      onMouseDown: r,
      customizeIcon: s
    }, "×")
  };
}, Ha = /* @__PURE__ */ a.createContext(null);
function xs() {
  return a.useContext(Ha);
}
function Es() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = a.useState(!1), r = ce(t, 2), n = r[0], o = r[1], i = a.useRef(null), c = function() {
    window.clearTimeout(i.current);
  };
  a.useEffect(function() {
    return c;
  }, []);
  var l = function(s, v) {
    c(), i.current = window.setTimeout(function() {
      o(s), v && v();
    }, e);
  };
  return [n, l, c];
}
function ja() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = a.useRef(null), r = a.useRef(null);
  a.useEffect(function() {
    return function() {
      window.clearTimeout(r.current);
    };
  }, []);
  function n(o) {
    (o || t.current === null) && (t.current = o), window.clearTimeout(r.current), r.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, n];
}
function ws(e, t, r, n) {
  var o = a.useRef(null);
  o.current = {
    open: t,
    triggerOpen: r,
    customizedTrigger: n
  }, a.useEffect(function() {
    function i(c) {
      var l;
      if (!((l = o.current) !== null && l !== void 0 && l.customizedTrigger)) {
        var d = c.target;
        d.shadowRoot && c.composed && (d = c.composedPath()[0] || d), o.current.open && e().filter(function(s) {
          return s;
        }).every(function(s) {
          return !s.contains(d) && s !== d;
        }) && o.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", i), function() {
      return window.removeEventListener("mousedown", i);
    };
  }, []);
}
function $s(e) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    e && // Other keys
    ![
      // System function button
      Ie.ESC,
      Ie.SHIFT,
      Ie.BACKSPACE,
      Ie.TAB,
      Ie.WIN_KEY,
      Ie.ALT,
      Ie.META,
      Ie.WIN_KEY_RIGHT,
      Ie.CTRL,
      Ie.SEMICOLON,
      Ie.EQUALS,
      Ie.CAPS_LOCK,
      Ie.CONTEXT_MENU,
      // F1-F12
      Ie.F1,
      Ie.F2,
      Ie.F3,
      Ie.F4,
      Ie.F5,
      Ie.F6,
      Ie.F7,
      Ie.F8,
      Ie.F9,
      Ie.F10,
      Ie.F11,
      Ie.F12
    ].includes(e)
  );
}
function Ns(e, t, r) {
  var n = F(F({}, e), t);
  return Object.keys(t).forEach(function(o) {
    var i = t[o];
    typeof i == "function" && (n[o] = function() {
      for (var c, l = arguments.length, d = new Array(l), s = 0; s < l; s++)
        d[s] = arguments[s];
      return i.apply(void 0, d), (c = e[o]) === null || c === void 0 ? void 0 : c.call.apply(c, [e].concat(d));
    });
  }), n;
}
var Os = ["prefixCls", "id", "inputElement", "autoFocus", "autoComplete", "editable", "activeDescendantId", "value", "open", "attrs"], Is = function(t, r) {
  var n = t.prefixCls, o = t.id, i = t.inputElement, c = t.autoFocus, l = t.autoComplete, d = t.editable, s = t.activeDescendantId, v = t.value, f = t.open, p = t.attrs, u = yt(t, Os), g = i || /* @__PURE__ */ a.createElement("input", null), b = g, m = b.ref, h = b.props;
  return $l(!("maxLength" in g.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), g = /* @__PURE__ */ a.cloneElement(g, F(F(F({
    type: "search"
  }, Ns(u, h)), {}, {
    // Override over origin props
    id: o,
    ref: Fr(r, m),
    autoComplete: l || "off",
    autoFocus: c,
    className: Q("".concat(n, "-selection-search-input"), h == null ? void 0 : h.className),
    role: "combobox",
    "aria-expanded": f || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(o, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(o, "_list"),
    "aria-activedescendant": f ? s : void 0
  }, p), {}, {
    value: d ? v : "",
    readOnly: !d,
    unselectable: d ? null : "on",
    style: F(F({}, h.style), {}, {
      opacity: d ? null : 0
    })
  })), g;
}, Jr = /* @__PURE__ */ a.forwardRef(Is);
process.env.NODE_ENV !== "production" && (Jr.displayName = "Input");
function Qr(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var Rs = typeof window < "u" && window.document && window.document.documentElement, Ps = process.env.NODE_ENV !== "test" && Rs;
function Ds(e) {
  return e != null;
}
function Ts(e) {
  return !e && e !== 0;
}
function _o(e) {
  return ["string", "number"].includes(St(e));
}
function Va(e) {
  var t = void 0;
  return e && (_o(e.title) ? t = e.title.toString() : _o(e.label) && (t = e.label.toString())), t;
}
function Ms(e, t) {
  Ps ? a.useLayoutEffect(e, t) : a.useEffect(e, t);
}
function _s(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var ko = function(t) {
  t.preventDefault(), t.stopPropagation();
}, ks = function(t) {
  var r = t.id, n = t.prefixCls, o = t.values, i = t.open, c = t.searchValue, l = t.autoClearSearchValue, d = t.inputRef, s = t.placeholder, v = t.disabled, f = t.mode, p = t.showSearch, u = t.autoFocus, g = t.autoComplete, b = t.activeDescendantId, m = t.tabIndex, h = t.removeIcon, C = t.maxTagCount, S = t.maxTagTextLength, E = t.maxTagPlaceholder, x = E === void 0 ? function(q) {
    return "+ ".concat(q.length, " ...");
  } : E, w = t.tagRender, N = t.onToggleOpen, I = t.onRemove, y = t.onInputChange, M = t.onInputPaste, T = t.onInputKeyDown, O = t.onInputMouseDown, R = t.onInputCompositionStart, P = t.onInputCompositionEnd, $ = t.onInputBlur, D = a.useRef(null), _ = dn(0), z = ce(_, 2), B = z[0], W = z[1], X = dn(!1), Y = ce(X, 2), ee = Y[0], ie = Y[1], ue = "".concat(n, "-selection"), xe = i || f === "multiple" && l === !1 || f === "tags" ? c : "", Z = f === "tags" || f === "multiple" && l === !1 || p && (i || ee);
  Ms(function() {
    W(D.current.scrollWidth);
  }, [xe]);
  var ae = function(A, j, fe, te, Ne) {
    return /* @__PURE__ */ a.createElement("span", {
      title: Va(A),
      className: Q("".concat(ue, "-item"), K({}, "".concat(ue, "-item-disabled"), fe))
    }, /* @__PURE__ */ a.createElement("span", {
      className: "".concat(ue, "-item-content")
    }, j), te && /* @__PURE__ */ a.createElement(ir, {
      className: "".concat(ue, "-item-remove"),
      onMouseDown: ko,
      onClick: Ne,
      customizeIcon: h
    }, "×"));
  }, me = function(A, j, fe, te, Ne, Ee) {
    var V = function(Ce) {
      ko(Ce), N(!i);
    };
    return /* @__PURE__ */ a.createElement("span", {
      onMouseDown: V
    }, w({
      label: j,
      value: A,
      disabled: fe,
      closable: te,
      onClose: Ne,
      isMaxTag: !!Ee
    }));
  }, ye = function(A) {
    var j = A.disabled, fe = A.label, te = A.value, Ne = !v && !j, Ee = fe;
    if (typeof S == "number" && (typeof fe == "string" || typeof fe == "number")) {
      var V = String(Ee);
      V.length > S && (Ee = "".concat(V.slice(0, S), "..."));
    }
    var G = function(be) {
      be && be.stopPropagation(), I(A);
    };
    return typeof w == "function" ? me(te, Ee, j, Ne, G) : ae(A, Ee, j, Ne, G);
  }, L = function(A) {
    if (!o.length)
      return null;
    var j = typeof x == "function" ? x(A) : x;
    return typeof w == "function" ? me(void 0, j, !1, !1, void 0, !0) : ae({
      title: j
    }, j, !1);
  }, k = /* @__PURE__ */ a.createElement("div", {
    className: "".concat(ue, "-search"),
    style: {
      width: B
    },
    onFocus: function() {
      ie(!0);
    },
    onBlur: function() {
      ie(!1);
    }
  }, /* @__PURE__ */ a.createElement(Jr, {
    ref: d,
    open: i,
    prefixCls: n,
    id: r,
    inputElement: null,
    disabled: v,
    autoFocus: u,
    autoComplete: g,
    editable: Z,
    activeDescendantId: b,
    value: xe,
    onKeyDown: T,
    onMouseDown: O,
    onChange: y,
    onPaste: M,
    onCompositionStart: R,
    onCompositionEnd: P,
    onBlur: $,
    tabIndex: m,
    attrs: nn(t, !0)
  }), /* @__PURE__ */ a.createElement("span", {
    ref: D,
    className: "".concat(ue, "-search-mirror"),
    "aria-hidden": !0
  }, xe, " ")), H = /* @__PURE__ */ a.createElement(Yl, {
    prefixCls: "".concat(ue, "-overflow"),
    data: o,
    renderItem: ye,
    renderRest: L,
    suffix: k,
    itemKey: _s,
    maxCount: C
  });
  return /* @__PURE__ */ a.createElement("span", {
    className: "".concat(ue, "-wrap")
  }, H, !o.length && !xe && /* @__PURE__ */ a.createElement("span", {
    className: "".concat(ue, "-placeholder")
  }, s));
}, Ks = function(t) {
  var r = t.inputElement, n = t.prefixCls, o = t.id, i = t.inputRef, c = t.disabled, l = t.autoFocus, d = t.autoComplete, s = t.activeDescendantId, v = t.mode, f = t.open, p = t.values, u = t.placeholder, g = t.tabIndex, b = t.showSearch, m = t.searchValue, h = t.activeValue, C = t.maxLength, S = t.onInputKeyDown, E = t.onInputMouseDown, x = t.onInputChange, w = t.onInputPaste, N = t.onInputCompositionStart, I = t.onInputCompositionEnd, y = t.onInputBlur, M = t.title, T = a.useState(!1), O = ce(T, 2), R = O[0], P = O[1], $ = v === "combobox", D = $ || b, _ = p[0], z = m || "";
  $ && h && !R && (z = h), a.useEffect(function() {
    $ && P(!1);
  }, [$, h]);
  var B = v !== "combobox" && !f && !b ? !1 : !!z, W = M === void 0 ? Va(_) : M, X = a.useMemo(function() {
    return _ ? null : /* @__PURE__ */ a.createElement("span", {
      className: "".concat(n, "-selection-placeholder"),
      style: B ? {
        visibility: "hidden"
      } : void 0
    }, u);
  }, [_, B, u, n]);
  return /* @__PURE__ */ a.createElement("span", {
    className: "".concat(n, "-selection-wrap")
  }, /* @__PURE__ */ a.createElement("span", {
    className: "".concat(n, "-selection-search")
  }, /* @__PURE__ */ a.createElement(Jr, {
    ref: i,
    prefixCls: n,
    id: o,
    open: f,
    inputElement: r,
    disabled: c,
    autoFocus: l,
    autoComplete: d,
    editable: D,
    activeDescendantId: s,
    value: z,
    onKeyDown: S,
    onMouseDown: E,
    onChange: function(ee) {
      P(!0), x(ee);
    },
    onPaste: w,
    onCompositionStart: N,
    onCompositionEnd: I,
    onBlur: y,
    tabIndex: g,
    attrs: nn(t, !0),
    maxLength: $ ? C : void 0
  })), !$ && _ ? /* @__PURE__ */ a.createElement("span", {
    className: "".concat(n, "-selection-item"),
    title: W,
    style: B ? {
      visibility: "hidden"
    } : void 0
  }, _.label) : null, X);
}, Bs = function(t, r) {
  var n = et(null), o = et(!1), i = t.prefixCls, c = t.open, l = t.mode, d = t.showSearch, s = t.tokenWithEnter, v = t.disabled, f = t.prefix, p = t.autoClearSearchValue, u = t.onSearch, g = t.onSearchSubmit, b = t.onToggleOpen, m = t.onInputKeyDown, h = t.onInputBlur, C = t.domRef;
  a.useImperativeHandle(r, function() {
    return {
      focus: function(W) {
        n.current.focus(W);
      },
      blur: function() {
        n.current.blur();
      }
    };
  });
  var S = ja(0), E = ce(S, 2), x = E[0], w = E[1], N = function(W) {
    var X = W.which, Y = n.current instanceof HTMLTextAreaElement;
    !Y && c && (X === Ie.UP || X === Ie.DOWN) && W.preventDefault(), m && m(W), X === Ie.ENTER && l === "tags" && !o.current && !c && (g == null || g(W.target.value)), !(Y && !c && ~[Ie.UP, Ie.DOWN, Ie.LEFT, Ie.RIGHT].indexOf(X)) && $s(X) && b(!0);
  }, I = function() {
    w(!0);
  }, y = et(null), M = function(W) {
    u(W, !0, o.current) !== !1 && b(!0);
  }, T = function() {
    o.current = !0;
  }, O = function(W) {
    o.current = !1, l !== "combobox" && M(W.target.value);
  }, R = function(W) {
    var X = W.target.value;
    if (s && y.current && /[\r\n]/.test(y.current)) {
      var Y = y.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      X = X.replace(Y, y.current);
    }
    y.current = null, M(X);
  }, P = function(W) {
    var X = W.clipboardData, Y = X == null ? void 0 : X.getData("text");
    y.current = Y || "";
  }, $ = function(W) {
    var X = W.target;
    if (X !== n.current) {
      var Y = document.body.style.msTouchAction !== void 0;
      Y ? setTimeout(function() {
        n.current.focus();
      }) : n.current.focus();
    }
  }, D = function(W) {
    var X = x();
    W.target !== n.current && !X && !(l === "combobox" && v) && W.preventDefault(), (l !== "combobox" && (!d || !X) || !c) && (c && p !== !1 && u("", !0, !1), b());
  }, _ = {
    inputRef: n,
    onInputKeyDown: N,
    onInputMouseDown: I,
    onInputChange: R,
    onInputPaste: P,
    onInputCompositionStart: T,
    onInputCompositionEnd: O,
    onInputBlur: h
  }, z = l === "multiple" || l === "tags" ? /* @__PURE__ */ a.createElement(ks, Pe({}, t, _)) : /* @__PURE__ */ a.createElement(Ks, Pe({}, t, _));
  return /* @__PURE__ */ a.createElement("div", {
    ref: C,
    className: "".concat(i, "-selector"),
    onClick: $,
    onMouseDown: D
  }, f && /* @__PURE__ */ a.createElement("div", {
    className: "".concat(i, "-prefix")
  }, f), z);
}, Aa = /* @__PURE__ */ a.forwardRef(Bs);
process.env.NODE_ENV !== "production" && (Aa.displayName = "Selector");
var zs = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], Ls = function(t) {
  var r = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, Hs = function(t, r) {
  var n = t.prefixCls;
  t.disabled;
  var o = t.visible, i = t.children, c = t.popupElement, l = t.animation, d = t.transitionName, s = t.dropdownStyle, v = t.dropdownClassName, f = t.direction, p = f === void 0 ? "ltr" : f, u = t.placement, g = t.builtinPlacements, b = t.dropdownMatchSelectWidth, m = t.dropdownRender, h = t.dropdownAlign, C = t.getPopupContainer, S = t.empty, E = t.getTriggerDOMNode, x = t.onPopupVisibleChange, w = t.onPopupMouseEnter, N = yt(t, zs), I = "".concat(n, "-dropdown"), y = c;
  m && (y = m(c));
  var M = a.useMemo(function() {
    return g || Ls(b);
  }, [g, b]), T = l ? "".concat(I, "-").concat(l) : d, O = typeof b == "number", R = a.useMemo(function() {
    return O ? null : b === !1 ? "minWidth" : "width";
  }, [b, O]), P = s;
  O && (P = F(F({}, P), {}, {
    width: b
  }));
  var $ = a.useRef(null);
  return a.useImperativeHandle(r, function() {
    return {
      getPopupElement: function() {
        var _;
        return (_ = $.current) === null || _ === void 0 ? void 0 : _.popupElement;
      }
    };
  }), /* @__PURE__ */ a.createElement(Ul, Pe({}, N, {
    showAction: x ? ["click"] : [],
    hideAction: x ? ["click"] : [],
    popupPlacement: u || (p === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: M,
    prefixCls: I,
    popupTransitionName: T,
    popup: /* @__PURE__ */ a.createElement("div", {
      onMouseEnter: w
    }, y),
    ref: $,
    stretch: R,
    popupAlign: h,
    popupVisible: o,
    getPopupContainer: C,
    popupClassName: Q(v, K({}, "".concat(I, "-empty"), S)),
    popupStyle: P,
    getTriggerDOMNode: E,
    onPopupVisibleChange: x
  }), i);
}, Fa = /* @__PURE__ */ a.forwardRef(Hs);
process.env.NODE_ENV !== "production" && (Fa.displayName = "SelectTrigger");
function Ko(e, t) {
  var r = e.key, n;
  return "value" in e && (n = e.value), r ?? (n !== void 0 ? n : "rc-index-key-".concat(t));
}
function Nr(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function Wa(e, t) {
  var r = e || {}, n = r.label, o = r.value, i = r.options, c = r.groupLabel, l = n || (t ? "children" : "label");
  return {
    label: l,
    value: o || "value",
    options: i || "options",
    groupLabel: c || l
  };
}
function js(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.fieldNames, n = t.childrenAsData, o = [], i = Wa(r, !1), c = i.label, l = i.value, d = i.options, s = i.groupLabel;
  function v(f, p) {
    Array.isArray(f) && f.forEach(function(u) {
      if (p || !(d in u)) {
        var g = u[l];
        o.push({
          key: Ko(u, o.length),
          groupOption: p,
          data: u,
          label: u[c],
          value: g
        });
      } else {
        var b = u[s];
        b === void 0 && n && (b = u.label), o.push({
          key: Ko(u, o.length),
          group: !0,
          data: u,
          label: b
        }), v(u[d], !0);
      }
    });
  }
  return v(e, !1), o;
}
function Or(e) {
  var t = F({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return Qe(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var Vs = function(t, r, n) {
  if (!r || !r.length)
    return null;
  var o = !1, i = function l(d, s) {
    var v = kl(s), f = v[0], p = v.slice(1);
    if (!f)
      return [d];
    var u = d.split(f);
    return o = o || u.length > 1, u.reduce(function(g, b) {
      return [].concat(_e(g), _e(l(b, p)));
    }, []).filter(Boolean);
  }, c = i(t, r);
  return o ? typeof n < "u" ? c.slice(0, n) : c : null;
}, Zr = /* @__PURE__ */ a.createContext(null);
function As(e) {
  var t = e.visible, r = e.values;
  if (!t)
    return null;
  var n = 50;
  return /* @__PURE__ */ a.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(r.slice(0, n).map(function(o) {
    var i = o.label, c = o.value;
    return ["number", "string"].includes(St(i)) ? i : c;
  }).join(", ")), r.length > n ? ", ..." : null);
}
var Fs = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], Ws = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], er = function(t) {
  return t === "tags" || t === "multiple";
}, qa = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r, n = e.id, o = e.prefixCls, i = e.className, c = e.showSearch, l = e.tagRender, d = e.direction, s = e.omitDomProps, v = e.displayValues, f = e.onDisplayValuesChange, p = e.emptyOptions, u = e.notFoundContent, g = u === void 0 ? "Not Found" : u, b = e.onClear, m = e.mode, h = e.disabled, C = e.loading, S = e.getInputElement, E = e.getRawInputElement, x = e.open, w = e.defaultOpen, N = e.onDropdownVisibleChange, I = e.activeValue, y = e.onActiveValueChange, M = e.activeDescendantId, T = e.searchValue, O = e.autoClearSearchValue, R = e.onSearch, P = e.onSearchSplit, $ = e.tokenSeparators, D = e.allowClear, _ = e.prefix, z = e.suffixIcon, B = e.clearIcon, W = e.OptionList, X = e.animation, Y = e.transitionName, ee = e.dropdownStyle, ie = e.dropdownClassName, ue = e.dropdownMatchSelectWidth, xe = e.dropdownRender, Z = e.dropdownAlign, ae = e.placement, me = e.builtinPlacements, ye = e.getPopupContainer, L = e.showAction, k = L === void 0 ? [] : L, H = e.onFocus, q = e.onBlur, A = e.onKeyUp, j = e.onKeyDown, fe = e.onMouseDown, te = yt(e, Fs), Ne = er(m), Ee = (c !== void 0 ? c : Ne) || m === "combobox", V = F({}, te);
  Ws.forEach(function(Je) {
    delete V[Je];
  }), s == null || s.forEach(function(Je) {
    delete V[Je];
  });
  var G = a.useState(!1), Ce = ce(G, 2), be = Ce[0], $e = Ce[1];
  a.useEffect(function() {
    $e(Gl());
  }, []);
  var qe = a.useRef(null), Oe = a.useRef(null), He = a.useRef(null), Se = a.useRef(null), he = a.useRef(null), ne = a.useRef(!1), J = Es(), ke = ce(J, 3), Te = ke[0], ve = ke[1], tt = ke[2];
  a.useImperativeHandle(t, function() {
    var Je, Ve;
    return {
      focus: (Je = Se.current) === null || Je === void 0 ? void 0 : Je.focus,
      blur: (Ve = Se.current) === null || Ve === void 0 ? void 0 : Ve.blur,
      scrollTo: function(Ot) {
        var gt;
        return (gt = he.current) === null || gt === void 0 ? void 0 : gt.scrollTo(Ot);
      },
      nativeElement: qe.current || Oe.current
    };
  });
  var De = a.useMemo(function() {
    var Je;
    if (m !== "combobox")
      return T;
    var Ve = (Je = v[0]) === null || Je === void 0 ? void 0 : Je.value;
    return typeof Ve == "string" || typeof Ve == "number" ? String(Ve) : "";
  }, [T, m, v]), at = m === "combobox" && typeof S == "function" && S() || null, je = typeof E == "function" && E(), dt = Nl(Oe, je == null || (r = je.props) === null || r === void 0 ? void 0 : r.ref), ut = a.useState(!1), xt = ce(ut, 2), Ue = xt[0], Tt = xt[1];
  Mt(function() {
    Tt(!0);
  }, []);
  var it = un(!1, {
    defaultValue: w,
    value: x
  }), lt = ce(it, 2), ft = lt[0], ot = lt[1], Ae = Ue ? ft : !1, vt = !g && p;
  (h || vt && Ae && m === "combobox") && (Ae = !1);
  var pt = vt ? !1 : Ae, le = a.useCallback(function(Je) {
    var Ve = Je !== void 0 ? Je : !Ae;
    h || (ot(Ve), Ae !== Ve && (N == null || N(Ve)));
  }, [h, Ae, ot, N]), re = a.useMemo(function() {
    return ($ || []).some(function(Je) {
      return [`
`, `\r
`].includes(Je);
    });
  }, [$]), se = a.useContext(Zr) || {}, de = se.maxCount, Le = se.rawValues, Ge = function(Ve, Nt, Ot) {
    if (!(Ne && Nr(de) && (Le == null ? void 0 : Le.size) >= de)) {
      var gt = !0, Ct = Ve;
      y == null || y(null);
      var jt = Vs(Ve, $, Nr(de) ? de - Le.size : void 0), Vt = Ot ? null : jt;
      return m !== "combobox" && Vt && (Ct = "", P == null || P(Vt), le(!1), gt = !1), R && De !== Ct && R(Ct, {
        source: Nt ? "typing" : "effect"
      }), gt;
    }
  }, mt = function(Ve) {
    !Ve || !Ve.trim() || R(Ve, {
      source: "submit"
    });
  };
  a.useEffect(function() {
    !Ae && !Ne && m !== "combobox" && Ge("", !1, !1);
  }, [Ae]), a.useEffect(function() {
    ft && h && ot(!1), h && !ne.current && ve(!1);
  }, [h]);
  var ge = ja(), Me = ce(ge, 2), Be = Me[0], We = Me[1], nt = a.useRef(!1), ht = function(Ve) {
    var Nt = Be(), Ot = Ve.key, gt = Ot === "Enter";
    if (gt && (m !== "combobox" && Ve.preventDefault(), Ae || le(!0)), We(!!De), Ot === "Backspace" && !Nt && Ne && !De && v.length) {
      for (var Ct = _e(v), jt = null, Vt = Ct.length - 1; Vt >= 0; Vt -= 1) {
        var Xt = Ct[Vt];
        if (!Xt.disabled) {
          Ct.splice(Vt, 1), jt = Xt;
          break;
        }
      }
      jt && f(Ct, {
        type: "remove",
        values: [jt]
      });
    }
    for (var an = arguments.length, ln = new Array(an > 1 ? an - 1 : 0), ze = 1; ze < an; ze++)
      ln[ze - 1] = arguments[ze];
    if (Ae && (!gt || !nt.current)) {
      var Fe;
      gt && (nt.current = !0), (Fe = he.current) === null || Fe === void 0 || Fe.onKeyDown.apply(Fe, [Ve].concat(ln));
    }
    j == null || j.apply(void 0, [Ve].concat(ln));
  }, Et = function(Ve) {
    for (var Nt = arguments.length, Ot = new Array(Nt > 1 ? Nt - 1 : 0), gt = 1; gt < Nt; gt++)
      Ot[gt - 1] = arguments[gt];
    if (Ae) {
      var Ct;
      (Ct = he.current) === null || Ct === void 0 || Ct.onKeyUp.apply(Ct, [Ve].concat(Ot));
    }
    Ve.key === "Enter" && (nt.current = !1), A == null || A.apply(void 0, [Ve].concat(Ot));
  }, rt = function(Ve) {
    var Nt = v.filter(function(Ot) {
      return Ot !== Ve;
    });
    f(Nt, {
      type: "remove",
      values: [Ve]
    });
  }, wt = function() {
    nt.current = !1;
  }, we = a.useRef(!1), pe = function() {
    ve(!0), h || (H && !we.current && H.apply(void 0, arguments), k.includes("focus") && le(!0)), we.current = !0;
  }, Ke = function() {
    ne.current = !0, ve(!1, function() {
      we.current = !1, ne.current = !1, le(!1);
    }), !h && (De && (m === "tags" ? R(De, {
      source: "submit"
    }) : m === "multiple" && R("", {
      source: "blur"
    })), q && q.apply(void 0, arguments));
  }, Ze = [];
  a.useEffect(function() {
    return function() {
      Ze.forEach(function(Je) {
        return clearTimeout(Je);
      }), Ze.splice(0, Ze.length);
    };
  }, []);
  var st = function(Ve) {
    var Nt, Ot = Ve.target, gt = (Nt = He.current) === null || Nt === void 0 ? void 0 : Nt.getPopupElement();
    if (gt && gt.contains(Ot)) {
      var Ct = setTimeout(function() {
        var an = Ze.indexOf(Ct);
        if (an !== -1 && Ze.splice(an, 1), tt(), !be && !gt.contains(document.activeElement)) {
          var ln;
          (ln = Se.current) === null || ln === void 0 || ln.focus();
        }
      });
      Ze.push(Ct);
    }
    for (var jt = arguments.length, Vt = new Array(jt > 1 ? jt - 1 : 0), Xt = 1; Xt < jt; Xt++)
      Vt[Xt - 1] = arguments[Xt];
    fe == null || fe.apply(void 0, [Ve].concat(Vt));
  }, At = a.useState({}), $t = ce(At, 2), Lt = $t[1];
  function Yt() {
    Lt({});
  }
  var Ft;
  je && (Ft = function(Ve) {
    le(Ve);
  }), ws(function() {
    var Je;
    return [qe.current, (Je = He.current) === null || Je === void 0 ? void 0 : Je.getPopupElement()];
  }, pt, le, !!je);
  var Re = a.useMemo(function() {
    return F(F({}, e), {}, {
      notFoundContent: g,
      open: Ae,
      triggerOpen: pt,
      id: n,
      showSearch: Ee,
      multiple: Ne,
      toggleOpen: le
    });
  }, [e, g, pt, Ae, n, Ee, Ne, le]), Ye = !!z || C, ct;
  Ye && (ct = /* @__PURE__ */ a.createElement(ir, {
    className: Q("".concat(o, "-arrow"), K({}, "".concat(o, "-arrow-loading"), C)),
    customizeIcon: z,
    customizeIconProps: {
      loading: C,
      searchValue: De,
      open: Ae,
      focused: Te,
      showSearch: Ee
    }
  }));
  var Ht = function() {
    var Ve;
    b == null || b(), (Ve = Se.current) === null || Ve === void 0 || Ve.focus(), f([], {
      type: "clear",
      values: v
    }), Ge("", !1, !1);
  }, on = Ss(o, Ht, v, D, B, h, De, m), ur = on.allowClear, fr = on.clearIcon, Yn = /* @__PURE__ */ a.createElement(W, {
    ref: he
  }), xn = Q(o, i, K(K(K(K(K(K(K(K(K(K({}, "".concat(o, "-focused"), Te), "".concat(o, "-multiple"), Ne), "".concat(o, "-single"), !Ne), "".concat(o, "-allow-clear"), D), "".concat(o, "-show-arrow"), Ye), "".concat(o, "-disabled"), h), "".concat(o, "-loading"), C), "".concat(o, "-open"), Ae), "".concat(o, "-customize-input"), at), "".concat(o, "-show-search"), Ee)), En = /* @__PURE__ */ a.createElement(Fa, {
    ref: He,
    disabled: h,
    prefixCls: o,
    visible: pt,
    popupElement: Yn,
    animation: X,
    transitionName: Y,
    dropdownStyle: ee,
    dropdownClassName: ie,
    direction: d,
    dropdownMatchSelectWidth: ue,
    dropdownRender: xe,
    dropdownAlign: Z,
    placement: ae,
    builtinPlacements: me,
    getPopupContainer: ye,
    empty: p,
    getTriggerDOMNode: function(Ve) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Oe.current || Ve
      );
    },
    onPopupVisibleChange: Ft,
    onPopupMouseEnter: Yt
  }, je ? /* @__PURE__ */ a.cloneElement(je, {
    ref: dt
  }) : /* @__PURE__ */ a.createElement(Aa, Pe({}, e, {
    domRef: Oe,
    prefixCls: o,
    inputElement: at,
    ref: Se,
    id: n,
    prefix: _,
    showSearch: Ee,
    autoClearSearchValue: O,
    mode: m,
    activeDescendantId: M,
    tagRender: l,
    values: v,
    open: Ae,
    onToggleOpen: le,
    activeValue: I,
    searchValue: De,
    onSearch: Ge,
    onSearchSubmit: mt,
    onRemove: rt,
    tokenWithEnter: re,
    onInputBlur: wt
  }))), mn;
  return je ? mn = En : mn = /* @__PURE__ */ a.createElement("div", Pe({
    className: xn
  }, V, {
    ref: qe,
    onMouseDown: st,
    onKeyDown: ht,
    onKeyUp: Et,
    onFocus: pe,
    onBlur: Ke
  }), /* @__PURE__ */ a.createElement(As, {
    visible: Te && !Ae,
    values: v
  }), En, ct, ur && fr), /* @__PURE__ */ a.createElement(Ha.Provider, {
    value: Re
  }, mn);
});
process.env.NODE_ENV !== "production" && (qa.displayName = "BaseSelect");
var eo = function() {
  return null;
};
eo.isSelectOptGroup = !0;
var to = function() {
  return null;
};
to.isSelectOption = !0;
var Xa = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.height, n = e.offsetY, o = e.offsetX, i = e.children, c = e.prefixCls, l = e.onInnerResize, d = e.innerProps, s = e.rtl, v = e.extra, f = {}, p = {
    display: "flex",
    flexDirection: "column"
  };
  return n !== void 0 && (f = {
    height: r,
    position: "relative",
    overflow: "hidden"
  }, p = F(F({}, p), {}, K(K(K(K(K({
    transform: "translateY(".concat(n, "px)")
  }, s ? "marginRight" : "marginLeft", -o), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ a.createElement("div", {
    style: f
  }, /* @__PURE__ */ a.createElement(Wn, {
    onResize: function(g) {
      var b = g.offsetHeight;
      b && l && l();
    }
  }, /* @__PURE__ */ a.createElement("div", Pe({
    style: p,
    className: Q(K({}, "".concat(c, "-holder-inner"), c)),
    ref: t
  }, d), i, v)));
});
Xa.displayName = "Filler";
function qs(e) {
  var t = e.children, r = e.setRef, n = a.useCallback(function(o) {
    r(o);
  }, []);
  return /* @__PURE__ */ a.cloneElement(t, {
    ref: n
  });
}
function Xs(e, t, r, n, o, i, c, l) {
  var d = l.getKey;
  return e.slice(t, r + 1).map(function(s, v) {
    var f = t + v, p = c(s, f, {
      style: {
        width: n
      },
      offsetX: o
    }), u = d(s);
    return /* @__PURE__ */ a.createElement(qs, {
      key: u,
      setRef: function(b) {
        return i(s, b);
      }
    }, p);
  });
}
function Us(e, t, r) {
  var n = e.length, o = t.length, i, c;
  if (n === 0 && o === 0)
    return null;
  n < o ? (i = e, c = t) : (i = t, c = e);
  var l = {
    __EMPTY_ITEM__: !0
  };
  function d(g) {
    return g !== void 0 ? r(g) : l;
  }
  for (var s = null, v = Math.abs(n - o) !== 1, f = 0; f < c.length; f += 1) {
    var p = d(i[f]), u = d(c[f]);
    if (p !== u) {
      s = f, v = v || p !== d(c[f + 1]);
      break;
    }
  }
  return s === null ? null : {
    index: s,
    multiple: v
  };
}
function Gs(e, t, r) {
  var n = a.useState(e), o = ce(n, 2), i = o[0], c = o[1], l = a.useState(null), d = ce(l, 2), s = d[0], v = d[1];
  return a.useEffect(function() {
    var f = Us(i || [], e || [], t);
    (f == null ? void 0 : f.index) !== void 0 && v(e[f.index]), c(e);
  }, [e]), [s];
}
var Bo = (typeof navigator > "u" ? "undefined" : St(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const Ua = function(e, t, r, n) {
  var o = et(!1), i = et(null);
  function c() {
    clearTimeout(i.current), o.current = !0, i.current = setTimeout(function() {
      o.current = !1;
    }, 50);
  }
  var l = et({
    top: e,
    bottom: t,
    left: r,
    right: n
  });
  return l.current.top = e, l.current.bottom = t, l.current.left = r, l.current.right = n, function(d, s) {
    var v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, f = d ? (
      // Pass origin wheel when on the left
      s < 0 && l.current.left || // Pass origin wheel when on the right
      s > 0 && l.current.right
    ) : s < 0 && l.current.top || // Pass origin wheel when on the bottom
    s > 0 && l.current.bottom;
    return v && f ? (clearTimeout(i.current), o.current = !1) : (!f || o.current) && c(), !o.current && f;
  };
};
function Ys(e, t, r, n, o, i, c) {
  var l = et(0), d = et(null), s = et(null), v = et(!1), f = Ua(t, r, n, o);
  function p(C, S) {
    if (Pt.cancel(d.current), !f(!1, S)) {
      var E = C;
      if (!E._virtualHandled)
        E._virtualHandled = !0;
      else
        return;
      l.current += S, s.current = S, Bo || E.preventDefault(), d.current = Pt(function() {
        var x = v.current ? 10 : 1;
        c(l.current * x, !1), l.current = 0;
      });
    }
  }
  function u(C, S) {
    c(S, !0), Bo || C.preventDefault();
  }
  var g = et(null), b = et(null);
  function m(C) {
    if (e) {
      Pt.cancel(b.current), b.current = Pt(function() {
        g.current = null;
      }, 2);
      var S = C.deltaX, E = C.deltaY, x = C.shiftKey, w = S, N = E;
      (g.current === "sx" || !g.current && x && E && !S) && (w = E, N = 0, g.current = "sx");
      var I = Math.abs(w), y = Math.abs(N);
      g.current === null && (g.current = i && I > y ? "x" : "y"), g.current === "y" ? p(C, N) : u(C, w);
    }
  }
  function h(C) {
    e && (v.current = C.detail === s.current);
  }
  return [m, h];
}
function Js(e, t, r, n) {
  var o = a.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, r.id, n]), i = ce(o, 2), c = i[0], l = i[1], d = function(v) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : v, p = c.get(v), u = c.get(f);
    if (p === void 0 || u === void 0)
      for (var g = e.length, b = l.length; b < g; b += 1) {
        var m, h = e[b], C = t(h);
        c.set(C, b);
        var S = (m = r.get(C)) !== null && m !== void 0 ? m : n;
        if (l[b] = (l[b - 1] || 0) + S, C === v && (p = b), C === f && (u = b), p !== void 0 && u !== void 0)
          break;
      }
    return {
      top: l[p - 1] || 0,
      bottom: l[u]
    };
  };
  return d;
}
var Qs = /* @__PURE__ */ function() {
  function e() {
    _a(this, e), K(this, "maps", void 0), K(this, "id", 0), K(this, "diffRecords", /* @__PURE__ */ new Map()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Ma(e, [{
    key: "set",
    value: function(r, n) {
      this.diffRecords.set(r, this.maps[r]), this.maps[r] = n, this.id += 1;
    }
  }, {
    key: "get",
    value: function(r) {
      return this.maps[r];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffRecords;
    }
  }]), e;
}();
function zo(e) {
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}
function Zs(e, t, r) {
  var n = a.useState(0), o = ce(n, 2), i = o[0], c = o[1], l = et(/* @__PURE__ */ new Map()), d = et(new Qs()), s = et(0);
  function v() {
    s.current += 1;
  }
  function f() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    v();
    var g = function() {
      var h = !1;
      l.current.forEach(function(C, S) {
        if (C && C.offsetParent) {
          var E = C.offsetHeight, x = getComputedStyle(C), w = x.marginTop, N = x.marginBottom, I = zo(w), y = zo(N), M = E + I + y;
          d.current.get(S) !== M && (d.current.set(S, M), h = !0);
        }
      }), h && c(function(C) {
        return C + 1;
      });
    };
    if (u)
      g();
    else {
      s.current += 1;
      var b = s.current;
      Promise.resolve().then(function() {
        b === s.current && g();
      });
    }
  }
  function p(u, g) {
    var b = e(u);
    l.current.get(b), g ? (l.current.set(b, g), f()) : l.current.delete(b);
  }
  return Rn(function() {
    return v;
  }, []), [p, f, d.current, i];
}
var Lo = 14 / 15;
function ec(e, t, r) {
  var n = et(!1), o = et(0), i = et(0), c = et(null), l = et(null), d, s = function(u) {
    if (n.current) {
      var g = Math.ceil(u.touches[0].pageX), b = Math.ceil(u.touches[0].pageY), m = o.current - g, h = i.current - b, C = Math.abs(m) > Math.abs(h);
      C ? o.current = g : i.current = b;
      var S = r(C, C ? m : h, !1, u);
      S && u.preventDefault(), clearInterval(l.current), S && (l.current = setInterval(function() {
        C ? m *= Lo : h *= Lo;
        var E = Math.floor(C ? m : h);
        (!r(C, E, !0) || Math.abs(E) <= 0.1) && clearInterval(l.current);
      }, 16));
    }
  }, v = function() {
    n.current = !1, d();
  }, f = function(u) {
    d(), u.touches.length === 1 && !n.current && (n.current = !0, o.current = Math.ceil(u.touches[0].pageX), i.current = Math.ceil(u.touches[0].pageY), c.current = u.target, c.current.addEventListener("touchmove", s, {
      passive: !1
    }), c.current.addEventListener("touchend", v, {
      passive: !0
    }));
  };
  d = function() {
    c.current && (c.current.removeEventListener("touchmove", s), c.current.removeEventListener("touchend", v));
  }, Mt(function() {
    return e && t.current.addEventListener("touchstart", f, {
      passive: !0
    }), function() {
      var p;
      (p = t.current) === null || p === void 0 || p.removeEventListener("touchstart", f), d(), clearInterval(l.current);
    };
  }, [e]);
}
function Ho(e) {
  return Math.floor(Math.pow(e, 0.5));
}
function Ir(e, t) {
  var r = "touches" in e ? e.touches[0] : e;
  return r[t ? "pageX" : "pageY"] - window[t ? "scrollX" : "scrollY"];
}
function tc(e, t, r) {
  a.useEffect(function() {
    var n = t.current;
    if (e && n) {
      var o = !1, i, c, l = function() {
        Pt.cancel(i);
      }, d = function p() {
        l(), i = Pt(function() {
          r(c), p();
        });
      }, s = function(u) {
        if (!(u.target.draggable || u.button !== 0)) {
          var g = u;
          g._virtualHandled || (g._virtualHandled = !0, o = !0);
        }
      }, v = function() {
        o = !1, l();
      }, f = function(u) {
        if (o) {
          var g = Ir(u, !1), b = n.getBoundingClientRect(), m = b.top, h = b.bottom;
          if (g <= m) {
            var C = m - g;
            c = -Ho(C), d();
          } else if (g >= h) {
            var S = g - h;
            c = Ho(S), d();
          } else
            l();
        }
      };
      return n.addEventListener("mousedown", s), n.ownerDocument.addEventListener("mouseup", v), n.ownerDocument.addEventListener("mousemove", f), function() {
        n.removeEventListener("mousedown", s), n.ownerDocument.removeEventListener("mouseup", v), n.ownerDocument.removeEventListener("mousemove", f), l();
      };
    }
  }, [e]);
}
var jo = 10;
function nc(e, t, r, n, o, i, c, l) {
  var d = a.useRef(), s = a.useState(null), v = ce(s, 2), f = v[0], p = v[1];
  return Mt(function() {
    if (f && f.times < jo) {
      if (!e.current) {
        p(function(B) {
          return F({}, B);
        });
        return;
      }
      i();
      var u = f.targetAlign, g = f.originAlign, b = f.index, m = f.offset, h = e.current.clientHeight, C = !1, S = u, E = null;
      if (h) {
        for (var x = u || g, w = 0, N = 0, I = 0, y = Math.min(t.length - 1, b), M = 0; M <= y; M += 1) {
          var T = o(t[M]);
          N = w;
          var O = r.get(T);
          I = N + (O === void 0 ? n : O), w = I;
        }
        for (var R = x === "top" ? m : h - m, P = y; P >= 0; P -= 1) {
          var $ = o(t[P]), D = r.get($);
          if (D === void 0) {
            C = !0;
            break;
          }
          if (R -= D, R <= 0)
            break;
        }
        switch (x) {
          case "top":
            E = N - m;
            break;
          case "bottom":
            E = I - h + m;
            break;
          default: {
            var _ = e.current.scrollTop, z = _ + h;
            N < _ ? S = "top" : I > z && (S = "bottom");
          }
        }
        E !== null && c(E), E !== f.lastTop && (C = !0);
      }
      C && p(F(F({}, f), {}, {
        times: f.times + 1,
        targetAlign: S,
        lastTop: E
      }));
    } else process.env.NODE_ENV !== "production" && (f == null ? void 0 : f.times) === jo && Qe(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [f, e.current]), function(u) {
    if (u == null) {
      l();
      return;
    }
    if (Pt.cancel(d.current), typeof u == "number")
      c(u);
    else if (u && St(u) === "object") {
      var g, b = u.align;
      "index" in u ? g = u.index : g = t.findIndex(function(C) {
        return o(C) === u.key;
      });
      var m = u.offset, h = m === void 0 ? 0 : m;
      p({
        times: 0,
        index: g,
        offset: h,
        originAlign: b
      });
    }
  };
}
var Rr = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.rtl, o = e.scrollOffset, i = e.scrollRange, c = e.onStartMove, l = e.onStopMove, d = e.onScroll, s = e.horizontal, v = e.spinSize, f = e.containerSize, p = e.style, u = e.thumbStyle, g = e.showScrollBar, b = a.useState(!1), m = ce(b, 2), h = m[0], C = m[1], S = a.useState(null), E = ce(S, 2), x = E[0], w = E[1], N = a.useState(null), I = ce(N, 2), y = I[0], M = I[1], T = !n, O = a.useRef(), R = a.useRef(), P = a.useState(g), $ = ce(P, 2), D = $[0], _ = $[1], z = a.useRef(), B = function() {
    g === !0 || g === !1 || (clearTimeout(z.current), _(!0), z.current = setTimeout(function() {
      _(!1);
    }, 3e3));
  }, W = i - f || 0, X = f - v || 0, Y = a.useMemo(function() {
    if (o === 0 || W === 0)
      return 0;
    var L = o / W;
    return L * X;
  }, [o, W, X]), ee = function(k) {
    k.stopPropagation(), k.preventDefault();
  }, ie = a.useRef({
    top: Y,
    dragging: h,
    pageY: x,
    startTop: y
  });
  ie.current = {
    top: Y,
    dragging: h,
    pageY: x,
    startTop: y
  };
  var ue = function(k) {
    C(!0), w(Ir(k, s)), M(ie.current.top), c(), k.stopPropagation(), k.preventDefault();
  };
  a.useEffect(function() {
    var L = function(A) {
      A.preventDefault();
    }, k = O.current, H = R.current;
    return k.addEventListener("touchstart", L, {
      passive: !1
    }), H.addEventListener("touchstart", ue, {
      passive: !1
    }), function() {
      k.removeEventListener("touchstart", L), H.removeEventListener("touchstart", ue);
    };
  }, []);
  var xe = a.useRef();
  xe.current = W;
  var Z = a.useRef();
  Z.current = X, a.useEffect(function() {
    if (h) {
      var L, k = function(A) {
        var j = ie.current, fe = j.dragging, te = j.pageY, Ne = j.startTop;
        Pt.cancel(L);
        var Ee = O.current.getBoundingClientRect(), V = f / (s ? Ee.width : Ee.height);
        if (fe) {
          var G = (Ir(A, s) - te) * V, Ce = Ne;
          !T && s ? Ce -= G : Ce += G;
          var be = xe.current, $e = Z.current, qe = $e ? Ce / $e : 0, Oe = Math.ceil(qe * be);
          Oe = Math.max(Oe, 0), Oe = Math.min(Oe, be), L = Pt(function() {
            d(Oe, s);
          });
        }
      }, H = function() {
        C(!1), l();
      };
      return window.addEventListener("mousemove", k, {
        passive: !0
      }), window.addEventListener("touchmove", k, {
        passive: !0
      }), window.addEventListener("mouseup", H, {
        passive: !0
      }), window.addEventListener("touchend", H, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", k), window.removeEventListener("touchmove", k), window.removeEventListener("mouseup", H), window.removeEventListener("touchend", H), Pt.cancel(L);
      };
    }
  }, [h]), a.useEffect(function() {
    return B(), function() {
      clearTimeout(z.current);
    };
  }, [o]), a.useImperativeHandle(t, function() {
    return {
      delayHidden: B
    };
  });
  var ae = "".concat(r, "-scrollbar"), me = {
    position: "absolute",
    visibility: D ? null : "hidden"
  }, ye = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return s ? (me.height = 8, me.left = 0, me.right = 0, me.bottom = 0, ye.height = "100%", ye.width = v, T ? ye.left = Y : ye.right = Y) : (me.width = 8, me.top = 0, me.bottom = 0, T ? me.right = 0 : me.left = 0, ye.width = "100%", ye.height = v, ye.top = Y), /* @__PURE__ */ a.createElement("div", {
    ref: O,
    className: Q(ae, K(K(K({}, "".concat(ae, "-horizontal"), s), "".concat(ae, "-vertical"), !s), "".concat(ae, "-visible"), D)),
    style: F(F({}, me), p),
    onMouseDown: ee,
    onMouseMove: B
  }, /* @__PURE__ */ a.createElement("div", {
    ref: R,
    className: Q("".concat(ae, "-thumb"), K({}, "".concat(ae, "-thumb-moving"), h)),
    style: F(F({}, ye), u),
    onMouseDown: ue
  }));
});
process.env.NODE_ENV !== "production" && (Rr.displayName = "ScrollBar");
var rc = 20;
function Vo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = e / t * e;
  return isNaN(r) && (r = 0), r = Math.max(r, rc), Math.floor(r);
}
var oc = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], ac = [], ic = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function lc(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-virtual-list" : r, o = e.className, i = e.height, c = e.itemHeight, l = e.fullHeight, d = l === void 0 ? !0 : l, s = e.style, v = e.data, f = e.children, p = e.itemKey, u = e.virtual, g = e.direction, b = e.scrollWidth, m = e.component, h = m === void 0 ? "div" : m, C = e.onScroll, S = e.onVirtualScroll, E = e.onVisibleChange, x = e.innerProps, w = e.extraRender, N = e.styles, I = e.showScrollBar, y = I === void 0 ? "optional" : I, M = yt(e, oc), T = a.useCallback(function(we) {
    return typeof p == "function" ? p(we) : we == null ? void 0 : we[p];
  }, [p]), O = Zs(T), R = ce(O, 4), P = R[0], $ = R[1], D = R[2], _ = R[3], z = !!(u !== !1 && i && c), B = a.useMemo(function() {
    return Object.values(D.maps).reduce(function(we, pe) {
      return we + pe;
    }, 0);
  }, [D.id, D.maps]), W = z && v && (Math.max(c * v.length, B) > i || !!b), X = g === "rtl", Y = Q(n, K({}, "".concat(n, "-rtl"), X), o), ee = v || ac, ie = et(), ue = et(), xe = et(), Z = dn(0), ae = ce(Z, 2), me = ae[0], ye = ae[1], L = dn(0), k = ce(L, 2), H = k[0], q = k[1], A = dn(!1), j = ce(A, 2), fe = j[0], te = j[1], Ne = function() {
    te(!0);
  }, Ee = function() {
    te(!1);
  }, V = {
    getKey: T
  };
  function G(we) {
    ye(function(pe) {
      var Ke;
      typeof we == "function" ? Ke = we(pe) : Ke = we;
      var Ze = Tt(Ke);
      return ie.current.scrollTop = Ze, Ze;
    });
  }
  var Ce = et({
    start: 0,
    end: ee.length
  }), be = et(), $e = Gs(ee, T), qe = ce($e, 1), Oe = qe[0];
  be.current = Oe;
  var He = a.useMemo(function() {
    if (!z)
      return {
        scrollHeight: void 0,
        start: 0,
        end: ee.length - 1,
        offset: void 0
      };
    if (!W) {
      var we;
      return {
        scrollHeight: ((we = ue.current) === null || we === void 0 ? void 0 : we.offsetHeight) || 0,
        start: 0,
        end: ee.length - 1,
        offset: void 0
      };
    }
    for (var pe = 0, Ke, Ze, st, At = ee.length, $t = 0; $t < At; $t += 1) {
      var Lt = ee[$t], Yt = T(Lt), Ft = D.get(Yt), Re = pe + (Ft === void 0 ? c : Ft);
      Re >= me && Ke === void 0 && (Ke = $t, Ze = pe), Re > me + i && st === void 0 && (st = $t), pe = Re;
    }
    return Ke === void 0 && (Ke = 0, Ze = 0, st = Math.ceil(i / c)), st === void 0 && (st = ee.length - 1), st = Math.min(st + 1, ee.length - 1), {
      scrollHeight: pe,
      start: Ke,
      end: st,
      offset: Ze
    };
  }, [W, z, me, ee, _, i]), Se = He.scrollHeight, he = He.start, ne = He.end, J = He.offset;
  Ce.current.start = he, Ce.current.end = ne, a.useLayoutEffect(function() {
    var we = D.getRecord();
    if (we.size === 1) {
      var pe = Array.from(we.keys())[0], Ke = we.get(pe), Ze = ee[he];
      if (Ze && Ke === void 0) {
        var st = T(Ze);
        if (st === pe) {
          var At = D.get(pe), $t = At - c;
          G(function(Lt) {
            return Lt + $t;
          });
        }
      }
    }
    D.resetRecord();
  }, [Se]);
  var ke = a.useState({
    width: 0,
    height: i
  }), Te = ce(ke, 2), ve = Te[0], tt = Te[1], De = function(pe) {
    tt({
      width: pe.offsetWidth,
      height: pe.offsetHeight
    });
  }, at = et(), je = et(), dt = a.useMemo(function() {
    return Vo(ve.width, b);
  }, [ve.width, b]), ut = a.useMemo(function() {
    return Vo(ve.height, Se);
  }, [ve.height, Se]), xt = Se - i, Ue = et(xt);
  Ue.current = xt;
  function Tt(we) {
    var pe = we;
    return Number.isNaN(Ue.current) || (pe = Math.min(pe, Ue.current)), pe = Math.max(pe, 0), pe;
  }
  var it = me <= 0, lt = me >= xt, ft = H <= 0, ot = H >= b, Ae = Ua(it, lt, ft, ot), vt = function() {
    return {
      x: X ? -H : H,
      y: me
    };
  }, pt = et(vt()), le = en(function(we) {
    if (S) {
      var pe = F(F({}, vt()), we);
      (pt.current.x !== pe.x || pt.current.y !== pe.y) && (S(pe), pt.current = pe);
    }
  });
  function re(we, pe) {
    var Ke = we;
    pe ? (Oo(function() {
      q(Ke);
    }), le()) : G(Ke);
  }
  function se(we) {
    var pe = we.currentTarget.scrollTop;
    pe !== me && G(pe), C == null || C(we), le();
  }
  var de = function(pe) {
    var Ke = pe, Ze = b ? b - ve.width : 0;
    return Ke = Math.max(Ke, 0), Ke = Math.min(Ke, Ze), Ke;
  }, Le = en(function(we, pe) {
    pe ? (Oo(function() {
      q(function(Ke) {
        var Ze = Ke + (X ? -we : we);
        return de(Ze);
      });
    }), le()) : G(function(Ke) {
      var Ze = Ke + we;
      return Ze;
    });
  }), Ge = Ys(z, it, lt, ft, ot, !!b, Le), mt = ce(Ge, 2), ge = mt[0], Me = mt[1];
  ec(z, ie, function(we, pe, Ke, Ze) {
    var st = Ze;
    return Ae(we, pe, Ke) ? !1 : !st || !st._virtualHandled ? (st && (st._virtualHandled = !0), ge({
      preventDefault: function() {
      },
      deltaX: we ? pe : 0,
      deltaY: we ? 0 : pe
    }), !0) : !1;
  }), tc(W, ie, function(we) {
    G(function(pe) {
      return pe + we;
    });
  }), Mt(function() {
    function we(Ke) {
      var Ze = it && Ke.detail < 0, st = lt && Ke.detail > 0;
      z && !Ze && !st && Ke.preventDefault();
    }
    var pe = ie.current;
    return pe.addEventListener("wheel", ge, {
      passive: !1
    }), pe.addEventListener("DOMMouseScroll", Me, {
      passive: !0
    }), pe.addEventListener("MozMousePixelScroll", we, {
      passive: !1
    }), function() {
      pe.removeEventListener("wheel", ge), pe.removeEventListener("DOMMouseScroll", Me), pe.removeEventListener("MozMousePixelScroll", we);
    };
  }, [z, it, lt]), Mt(function() {
    if (b) {
      var we = de(H);
      q(we), le({
        x: we
      });
    }
  }, [ve.width, b]);
  var Be = function() {
    var pe, Ke;
    (pe = at.current) === null || pe === void 0 || pe.delayHidden(), (Ke = je.current) === null || Ke === void 0 || Ke.delayHidden();
  }, We = nc(ie, ee, D, c, T, function() {
    return $(!0);
  }, G, Be);
  a.useImperativeHandle(t, function() {
    return {
      nativeElement: xe.current,
      getScrollInfo: vt,
      scrollTo: function(pe) {
        function Ke(Ze) {
          return Ze && St(Ze) === "object" && ("left" in Ze || "top" in Ze);
        }
        Ke(pe) ? (pe.left !== void 0 && q(de(pe.left)), We(pe.top)) : We(pe);
      }
    };
  }), Mt(function() {
    if (E) {
      var we = ee.slice(he, ne + 1);
      E(we, ee);
    }
  }, [he, ne, ee]);
  var nt = Js(ee, T, D, c), ht = w == null ? void 0 : w({
    start: he,
    end: ne,
    virtual: W,
    offsetX: H,
    offsetY: J,
    rtl: X,
    getSize: nt
  }), Et = Xs(ee, he, ne, b, H, P, f, V), rt = null;
  i && (rt = F(K({}, d ? "height" : "maxHeight", i), ic), z && (rt.overflowY = "hidden", b && (rt.overflowX = "hidden"), fe && (rt.pointerEvents = "none")));
  var wt = {};
  return X && (wt.dir = "rtl"), /* @__PURE__ */ a.createElement("div", Pe({
    ref: xe,
    style: F(F({}, s), {}, {
      position: "relative"
    }),
    className: Y
  }, wt, M), /* @__PURE__ */ a.createElement(Wn, {
    onResize: De
  }, /* @__PURE__ */ a.createElement(h, {
    className: "".concat(n, "-holder"),
    style: rt,
    ref: ie,
    onScroll: se,
    onMouseEnter: Be
  }, /* @__PURE__ */ a.createElement(Xa, {
    prefixCls: n,
    height: Se,
    offsetX: H,
    offsetY: J,
    scrollWidth: b,
    onInnerResize: $,
    ref: ue,
    innerProps: x,
    rtl: X,
    extra: ht
  }, Et))), W && Se > i && /* @__PURE__ */ a.createElement(Rr, {
    ref: at,
    prefixCls: n,
    scrollOffset: me,
    scrollRange: Se,
    rtl: X,
    onScroll: re,
    onStartMove: Ne,
    onStopMove: Ee,
    spinSize: ut,
    containerSize: ve.height,
    style: N == null ? void 0 : N.verticalScrollBar,
    thumbStyle: N == null ? void 0 : N.verticalScrollBarThumb,
    showScrollBar: y
  }), W && b > ve.width && /* @__PURE__ */ a.createElement(Rr, {
    ref: je,
    prefixCls: n,
    scrollOffset: H,
    scrollRange: b,
    rtl: X,
    onScroll: re,
    onStartMove: Ne,
    onStopMove: Ee,
    spinSize: dt,
    containerSize: ve.width,
    horizontal: !0,
    style: N == null ? void 0 : N.horizontalScrollBar,
    thumbStyle: N == null ? void 0 : N.horizontalScrollBarThumb,
    showScrollBar: y
  }));
}
var lr = /* @__PURE__ */ a.forwardRef(lc);
lr.displayName = "List";
function sc() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var cc = ["disabled", "title", "children", "style", "className"];
function Ao(e) {
  return typeof e == "string" || typeof e == "number";
}
var dc = function(t, r) {
  var n = xs(), o = n.prefixCls, i = n.id, c = n.open, l = n.multiple, d = n.mode, s = n.searchValue, v = n.toggleOpen, f = n.notFoundContent, p = n.onPopupScroll, u = a.useContext(Zr), g = u.maxCount, b = u.flattenOptions, m = u.onActiveValue, h = u.defaultActiveFirstOption, C = u.onSelect, S = u.menuItemSelectedIcon, E = u.rawValues, x = u.fieldNames, w = u.virtual, N = u.direction, I = u.listHeight, y = u.listItemHeight, M = u.optionRender, T = "".concat(o, "-item"), O = Wr(function() {
    return b;
  }, [c, b], function(L, k) {
    return k[0] && L[1] !== k[1];
  }), R = a.useRef(null), P = a.useMemo(function() {
    return l && Nr(g) && (E == null ? void 0 : E.size) >= g;
  }, [l, g, E == null ? void 0 : E.size]), $ = function(k) {
    k.preventDefault();
  }, D = function(k) {
    var H;
    (H = R.current) === null || H === void 0 || H.scrollTo(typeof k == "number" ? {
      index: k
    } : k);
  }, _ = a.useCallback(function(L) {
    return d === "combobox" ? !1 : E.has(L);
  }, [d, _e(E).toString(), E.size]), z = function(k) {
    for (var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, q = O.length, A = 0; A < q; A += 1) {
      var j = (k + A * H + q) % q, fe = O[j] || {}, te = fe.group, Ne = fe.data;
      if (!te && !(Ne != null && Ne.disabled) && (_(Ne.value) || !P))
        return j;
    }
    return -1;
  }, B = a.useState(function() {
    return z(0);
  }), W = ce(B, 2), X = W[0], Y = W[1], ee = function(k) {
    var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    Y(k);
    var q = {
      source: H ? "keyboard" : "mouse"
    }, A = O[k];
    if (!A) {
      m(null, -1, q);
      return;
    }
    m(A.value, k, q);
  };
  Rn(function() {
    ee(h !== !1 ? z(0) : -1);
  }, [O.length, s]);
  var ie = a.useCallback(function(L) {
    return d === "combobox" ? String(L).toLowerCase() === s.toLowerCase() : E.has(L);
  }, [d, s, _e(E).toString(), E.size]);
  Rn(function() {
    var L = setTimeout(function() {
      if (!l && c && E.size === 1) {
        var H = Array.from(E)[0], q = O.findIndex(function(A) {
          var j = A.data;
          return s ? String(j.value).startsWith(s) : j.value === H;
        });
        q !== -1 && (ee(q), D(q));
      }
    });
    if (c) {
      var k;
      (k = R.current) === null || k === void 0 || k.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(L);
    };
  }, [c, s]);
  var ue = function(k) {
    k !== void 0 && C(k, {
      selected: !E.has(k)
    }), l || v(!1);
  };
  if (a.useImperativeHandle(r, function() {
    return {
      onKeyDown: function(k) {
        var H = k.which, q = k.ctrlKey;
        switch (H) {
          case Ie.N:
          case Ie.P:
          case Ie.UP:
          case Ie.DOWN: {
            var A = 0;
            if (H === Ie.UP ? A = -1 : H === Ie.DOWN ? A = 1 : sc() && q && (H === Ie.N ? A = 1 : H === Ie.P && (A = -1)), A !== 0) {
              var j = z(X + A, A);
              D(j), ee(j, !0);
            }
            break;
          }
          case Ie.TAB:
          case Ie.ENTER: {
            var fe, te = O[X];
            te && !(te != null && (fe = te.data) !== null && fe !== void 0 && fe.disabled) && !P ? ue(te.value) : ue(void 0), c && k.preventDefault();
            break;
          }
          case Ie.ESC:
            v(!1), c && k.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(k) {
        D(k);
      }
    };
  }), O.length === 0)
    return /* @__PURE__ */ a.createElement("div", {
      role: "listbox",
      id: "".concat(i, "_list"),
      className: "".concat(T, "-empty"),
      onMouseDown: $
    }, f);
  var xe = Object.keys(x).map(function(L) {
    return x[L];
  }), Z = function(k) {
    return k.label;
  };
  function ae(L, k) {
    var H = L.group;
    return {
      role: H ? "presentation" : "option",
      id: "".concat(i, "_list_").concat(k)
    };
  }
  var me = function(k) {
    var H = O[k];
    if (!H)
      return null;
    var q = H.data || {}, A = q.value, j = H.group, fe = nn(q, !0), te = Z(H);
    return H ? /* @__PURE__ */ a.createElement("div", Pe({
      "aria-label": typeof te == "string" && !j ? te : null
    }, fe, {
      key: k
    }, ae(H, k), {
      "aria-selected": ie(A)
    }), A) : null;
  }, ye = {
    role: "listbox",
    id: "".concat(i, "_list")
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, w && /* @__PURE__ */ a.createElement("div", Pe({}, ye, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), me(X - 1), me(X), me(X + 1)), /* @__PURE__ */ a.createElement(lr, {
    itemKey: "key",
    ref: R,
    data: O,
    height: I,
    itemHeight: y,
    fullHeight: !1,
    onMouseDown: $,
    onScroll: p,
    virtual: w,
    direction: N,
    innerProps: w ? null : ye
  }, function(L, k) {
    var H = L.group, q = L.groupOption, A = L.data, j = L.label, fe = L.value, te = A.key;
    if (H) {
      var Ne, Ee = (Ne = A.title) !== null && Ne !== void 0 ? Ne : Ao(j) ? j.toString() : void 0;
      return /* @__PURE__ */ a.createElement("div", {
        className: Q(T, "".concat(T, "-group"), A.className),
        title: Ee
      }, j !== void 0 ? j : te);
    }
    var V = A.disabled, G = A.title;
    A.children;
    var Ce = A.style, be = A.className, $e = yt(A, cc), qe = qn($e, xe), Oe = _(fe), He = V || !Oe && P, Se = "".concat(T, "-option"), he = Q(T, Se, be, K(K(K(K({}, "".concat(Se, "-grouped"), q), "".concat(Se, "-active"), X === k && !He), "".concat(Se, "-disabled"), He), "".concat(Se, "-selected"), Oe)), ne = Z(L), J = !S || typeof S == "function" || Oe, ke = typeof ne == "number" ? ne : ne || fe, Te = Ao(ke) ? ke.toString() : void 0;
    return G !== void 0 && (Te = G), /* @__PURE__ */ a.createElement("div", Pe({}, nn(qe), w ? {} : ae(L, k), {
      "aria-selected": ie(fe),
      className: he,
      title: Te,
      onMouseMove: function() {
        X === k || He || ee(k);
      },
      onClick: function() {
        He || ue(fe);
      },
      style: Ce
    }), /* @__PURE__ */ a.createElement("div", {
      className: "".concat(Se, "-content")
    }, typeof M == "function" ? M(L, {
      index: k
    }) : ke), /* @__PURE__ */ a.isValidElement(S) || Oe, J && /* @__PURE__ */ a.createElement(ir, {
      className: "".concat(T, "-option-state"),
      customizeIcon: S,
      customizeIconProps: {
        value: fe,
        disabled: He,
        isSelected: Oe
      }
    }, Oe ? "✓" : null));
  }));
}, Ga = /* @__PURE__ */ a.forwardRef(dc);
process.env.NODE_ENV !== "production" && (Ga.displayName = "OptionList");
const uc = function(e, t) {
  var r = a.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), n = a.useMemo(function() {
    var i = r.current, c = i.values, l = i.options, d = e.map(function(f) {
      if (f.label === void 0) {
        var p;
        return F(F({}, f), {}, {
          label: (p = c.get(f.value)) === null || p === void 0 ? void 0 : p.label
        });
      }
      return f;
    }), s = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map();
    return d.forEach(function(f) {
      s.set(f.value, f), v.set(f.value, t.get(f.value) || l.get(f.value));
    }), r.current.values = s, r.current.options = v, d;
  }, [e, t]), o = a.useCallback(function(i) {
    return t.get(i) || r.current.options.get(i);
  }, [t]);
  return [n, o];
};
function pr(e, t) {
  return Qr(e).join("").toUpperCase().includes(t);
}
const fc = function(e, t, r, n, o) {
  return a.useMemo(function() {
    if (!r || n === !1)
      return e;
    var i = t.options, c = t.label, l = t.value, d = [], s = typeof n == "function", v = r.toUpperCase(), f = s ? n : function(u, g) {
      return o ? pr(g[o], v) : g[i] ? pr(g[c !== "children" ? c : "label"], v) : pr(g[l], v);
    }, p = s ? function(u) {
      return Or(u);
    } : function(u) {
      return u;
    };
    return e.forEach(function(u) {
      if (u[i]) {
        var g = f(r, p(u));
        if (g)
          d.push(u);
        else {
          var b = u[i].filter(function(m) {
            return f(r, p(m));
          });
          b.length && d.push(F(F({}, u), {}, K({}, i, b)));
        }
        return;
      }
      f(r, p(u)) && d.push(u);
    }), d;
  }, [e, n, o, r, t]);
};
var Fo = 0, vc = process.env.NODE_ENV !== "test" && ka();
function pc() {
  var e;
  return vc ? (e = Fo, Fo += 1) : e = "TEST_OR_SSR", e;
}
function mc(e) {
  var t = a.useState(), r = ce(t, 2), n = r[0], o = r[1];
  return a.useEffect(function() {
    o("rc_select_".concat(pc()));
  }, []), e || n;
}
var gc = ["children", "value"], hc = ["children"];
function bc(e) {
  var t = e, r = t.key, n = t.props, o = n.children, i = n.value, c = yt(n, gc);
  return F({
    key: r,
    value: i !== void 0 ? i : r,
    children: o
  }, c);
}
function no(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return An(e).map(function(r, n) {
    if (!/* @__PURE__ */ a.isValidElement(r) || !r.type)
      return null;
    var o = r, i = o.type.isSelectOptGroup, c = o.key, l = o.props, d = l.children, s = yt(l, hc);
    return t || !i ? bc(r) : F(F({
      key: "__RC_SELECT_GRP__".concat(c === null ? n : c, "__"),
      label: c
    }, s), {}, {
      options: no(d)
    });
  }).filter(function(r) {
    return r;
  });
}
var yc = function(t, r, n, o, i) {
  return a.useMemo(function() {
    var c = t, l = !t;
    l && (c = no(r));
    var d = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), v = function(u, g, b) {
      b && typeof b == "string" && u.set(g[b], g);
    }, f = function p(u) {
      for (var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, b = 0; b < u.length; b += 1) {
        var m = u[b];
        !m[n.options] || g ? (d.set(m[n.value], m), v(s, m, n.label), v(s, m, o), v(s, m, i)) : p(m[n.options], !0);
      }
    };
    return f(c), {
      options: c,
      valueOptions: d,
      labelOptions: s
    };
  }, [t, r, n, o, i]);
};
function Wo(e) {
  var t = a.useRef();
  t.current = e;
  var r = a.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return r;
}
function Cc(e) {
  var t = e.mode, r = e.options, n = e.children, o = e.backfill, i = e.allowClear, c = e.placeholder, l = e.getInputElement, d = e.showSearch, s = e.onSearch, v = e.defaultOpen, f = e.autoFocus, p = e.labelInValue, u = e.value, g = e.inputValue, b = e.optionLabelProp, m = er(t), h = d !== void 0 ? d : m || t === "combobox", C = r || no(n);
  if (Qe(t !== "tags" || C.every(function(w) {
    return !w.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var S = C.some(function(w) {
      return w.options ? w.options.some(function(N) {
        return typeof ("value" in N ? N.value : N.key) == "number";
      }) : typeof ("value" in w ? w.value : w.key) == "number";
    });
    Qe(!S, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (Qe(t !== "combobox" || !b, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), Qe(t === "combobox" || !o, "`backfill` only works with `combobox` mode."), Qe(t === "combobox" || !l, "`getInputElement` only work with `combobox` mode."), Eo(t !== "combobox" || !l || !i || !c, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), s && !h && t !== "combobox" && t !== "tags" && Qe(!1, "`onSearch` should work with `showSearch` instead of use alone."), Eo(!v || f, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), u != null) {
    var E = Qr(u);
    Qe(!p || E.every(function(w) {
      return St(w) === "object" && ("key" in w || "value" in w);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), Qe(!m || Array.isArray(u), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (n) {
    var x = null;
    An(n).some(function(w) {
      if (!/* @__PURE__ */ a.isValidElement(w) || !w.type)
        return !1;
      var N = w, I = N.type;
      if (I.isSelectOption)
        return !1;
      if (I.isSelectOptGroup) {
        var y = An(w.props.children).every(function(M) {
          return !/* @__PURE__ */ a.isValidElement(M) || !w.type || M.type.isSelectOption ? !0 : (x = M.type, !1);
        });
        return !y;
      }
      return x = I, !0;
    }), x && Qe(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(x.displayName || x.name || x, "`.")), Qe(g === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function Sc(e, t) {
  if (e) {
    var r = function n(o) {
      for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = 0; c < o.length; c++) {
        var l = o[c];
        if (l[t == null ? void 0 : t.value] === null)
          return Qe(!1, "`value` in Select options should not be `null`."), !0;
        if (!i && Array.isArray(l[t == null ? void 0 : t.options]) && n(l[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    r(e);
  }
}
var xc = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], Ec = ["inputValue"];
function wc(e) {
  return !e || St(e) !== "object";
}
var Ya = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.id, n = e.mode, o = e.prefixCls, i = o === void 0 ? "rc-select" : o, c = e.backfill, l = e.fieldNames, d = e.inputValue, s = e.searchValue, v = e.onSearch, f = e.autoClearSearchValue, p = f === void 0 ? !0 : f, u = e.onSelect, g = e.onDeselect, b = e.dropdownMatchSelectWidth, m = b === void 0 ? !0 : b, h = e.filterOption, C = e.filterSort, S = e.optionFilterProp, E = e.optionLabelProp, x = e.options, w = e.optionRender, N = e.children, I = e.defaultActiveFirstOption, y = e.menuItemSelectedIcon, M = e.virtual, T = e.direction, O = e.listHeight, R = O === void 0 ? 200 : O, P = e.listItemHeight, $ = P === void 0 ? 20 : P, D = e.labelRender, _ = e.value, z = e.defaultValue, B = e.labelInValue, W = e.onChange, X = e.maxCount, Y = yt(e, xc), ee = mc(r), ie = er(n), ue = !!(!x && N), xe = a.useMemo(function() {
    return h === void 0 && n === "combobox" ? !1 : h;
  }, [h, n]), Z = a.useMemo(
    function() {
      return Wa(l, ue);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(l),
      ue
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), ae = un("", {
    value: s !== void 0 ? s : d,
    postState: function(re) {
      return re || "";
    }
  }), me = ce(ae, 2), ye = me[0], L = me[1], k = yc(x, N, Z, S, E), H = k.valueOptions, q = k.labelOptions, A = k.options, j = a.useCallback(function(le) {
    var re = Qr(le);
    return re.map(function(se) {
      var de, Le, Ge, mt, ge;
      if (wc(se))
        de = se;
      else {
        var Me;
        Ge = se.key, Le = se.label, de = (Me = se.value) !== null && Me !== void 0 ? Me : Ge;
      }
      var Be = H.get(de);
      if (Be) {
        var We;
        if (Le === void 0 && (Le = Be == null ? void 0 : Be[E || Z.label]), Ge === void 0 && (Ge = (We = Be == null ? void 0 : Be.key) !== null && We !== void 0 ? We : de), mt = Be == null ? void 0 : Be.disabled, ge = Be == null ? void 0 : Be.title, process.env.NODE_ENV !== "production" && !E) {
          var nt = Be == null ? void 0 : Be[Z.label];
          nt !== void 0 && !/* @__PURE__ */ a.isValidElement(nt) && !/* @__PURE__ */ a.isValidElement(Le) && nt !== Le && Qe(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: Le,
        value: de,
        key: Ge,
        disabled: mt,
        title: ge
      };
    });
  }, [Z, E, H]), fe = un(z, {
    value: _
  }), te = ce(fe, 2), Ne = te[0], Ee = te[1], V = a.useMemo(function() {
    var le, re = ie && Ne === null ? [] : Ne, se = j(re);
    return n === "combobox" && Ts((le = se[0]) === null || le === void 0 ? void 0 : le.value) ? [] : se;
  }, [Ne, j, n, ie]), G = uc(V, H), Ce = ce(G, 2), be = Ce[0], $e = Ce[1], qe = a.useMemo(function() {
    if (!n && be.length === 1) {
      var le = be[0];
      if (le.value === null && (le.label === null || le.label === void 0))
        return [];
    }
    return be.map(function(re) {
      var se;
      return F(F({}, re), {}, {
        label: (se = typeof D == "function" ? D(re) : re.label) !== null && se !== void 0 ? se : re.value
      });
    });
  }, [n, be, D]), Oe = a.useMemo(function() {
    return new Set(be.map(function(le) {
      return le.value;
    }));
  }, [be]);
  a.useEffect(function() {
    if (n === "combobox") {
      var le, re = (le = be[0]) === null || le === void 0 ? void 0 : le.value;
      L(Ds(re) ? String(re) : "");
    }
  }, [be]);
  var He = Wo(function(le, re) {
    var se = re ?? le;
    return K(K({}, Z.value, le), Z.label, se);
  }), Se = a.useMemo(function() {
    if (n !== "tags")
      return A;
    var le = _e(A), re = function(de) {
      return H.has(de);
    };
    return _e(be).sort(function(se, de) {
      return se.value < de.value ? -1 : 1;
    }).forEach(function(se) {
      var de = se.value;
      re(de) || le.push(He(de, se.label));
    }), le;
  }, [He, A, H, be, n]), he = fc(Se, Z, ye, xe, S), ne = a.useMemo(function() {
    return n !== "tags" || !ye || he.some(function(le) {
      return le[S || "value"] === ye;
    }) || he.some(function(le) {
      return le[Z.value] === ye;
    }) ? he : [He(ye)].concat(_e(he));
  }, [He, S, n, he, ye, Z]), J = function le(re) {
    var se = _e(re).sort(function(de, Le) {
      return C(de, Le, {
        searchValue: ye
      });
    });
    return se.map(function(de) {
      return Array.isArray(de.options) ? F(F({}, de), {}, {
        options: de.options.length > 0 ? le(de.options) : de.options
      }) : de;
    });
  }, ke = a.useMemo(function() {
    return C ? J(ne) : ne;
  }, [ne, C, ye]), Te = a.useMemo(function() {
    return js(ke, {
      fieldNames: Z,
      childrenAsData: ue
    });
  }, [ke, Z, ue]), ve = function(re) {
    var se = j(re);
    if (Ee(se), W && // Trigger event only when value changed
    (se.length !== be.length || se.some(function(Ge, mt) {
      var ge;
      return ((ge = be[mt]) === null || ge === void 0 ? void 0 : ge.value) !== (Ge == null ? void 0 : Ge.value);
    }))) {
      var de = B ? se : se.map(function(Ge) {
        return Ge.value;
      }), Le = se.map(function(Ge) {
        return Or($e(Ge.value));
      });
      W(
        // Value
        ie ? de : de[0],
        // Option
        ie ? Le : Le[0]
      );
    }
  }, tt = a.useState(null), De = ce(tt, 2), at = De[0], je = De[1], dt = a.useState(0), ut = ce(dt, 2), xt = ut[0], Ue = ut[1], Tt = I !== void 0 ? I : n !== "combobox", it = a.useCallback(function(le, re) {
    var se = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, de = se.source, Le = de === void 0 ? "keyboard" : de;
    Ue(re), c && n === "combobox" && le !== null && Le === "keyboard" && je(String(le));
  }, [c, n]), lt = function(re, se, de) {
    var Le = function() {
      var rt, wt = $e(re);
      return [B ? {
        label: wt == null ? void 0 : wt[Z.label],
        value: re,
        key: (rt = wt == null ? void 0 : wt.key) !== null && rt !== void 0 ? rt : re
      } : re, Or(wt)];
    };
    if (se && u) {
      var Ge = Le(), mt = ce(Ge, 2), ge = mt[0], Me = mt[1];
      u(ge, Me);
    } else if (!se && g && de !== "clear") {
      var Be = Le(), We = ce(Be, 2), nt = We[0], ht = We[1];
      g(nt, ht);
    }
  }, ft = Wo(function(le, re) {
    var se, de = ie ? re.selected : !0;
    de ? se = ie ? [].concat(_e(be), [le]) : [le] : se = be.filter(function(Le) {
      return Le.value !== le;
    }), ve(se), lt(le, de), n === "combobox" ? je("") : (!er || p) && (L(""), je(""));
  }), ot = function(re, se) {
    ve(re);
    var de = se.type, Le = se.values;
    (de === "remove" || de === "clear") && Le.forEach(function(Ge) {
      lt(Ge.value, !1, de);
    });
  }, Ae = function(re, se) {
    if (L(re), je(null), se.source === "submit") {
      var de = (re || "").trim();
      if (de) {
        var Le = Array.from(new Set([].concat(_e(Oe), [de])));
        ve(Le), lt(de, !0), L("");
      }
      return;
    }
    se.source !== "blur" && (n === "combobox" && ve(re), v == null || v(re));
  }, vt = function(re) {
    var se = re;
    n !== "tags" && (se = re.map(function(Le) {
      var Ge = q.get(Le);
      return Ge == null ? void 0 : Ge.value;
    }).filter(function(Le) {
      return Le !== void 0;
    }));
    var de = Array.from(new Set([].concat(_e(Oe), _e(se))));
    ve(de), de.forEach(function(Le) {
      lt(Le, !0);
    });
  }, pt = a.useMemo(function() {
    var le = M !== !1 && m !== !1;
    return F(F({}, k), {}, {
      flattenOptions: Te,
      onActiveValue: it,
      defaultActiveFirstOption: Tt,
      onSelect: ft,
      menuItemSelectedIcon: y,
      rawValues: Oe,
      fieldNames: Z,
      virtual: le,
      direction: T,
      listHeight: R,
      listItemHeight: $,
      childrenAsData: ue,
      maxCount: X,
      optionRender: w
    });
  }, [X, k, Te, it, Tt, ft, y, Oe, Z, M, m, T, R, $, ue, w]);
  return process.env.NODE_ENV !== "production" && (Cc(e), Sc(A, Z)), /* @__PURE__ */ a.createElement(Zr.Provider, {
    value: pt
  }, /* @__PURE__ */ a.createElement(qa, Pe({}, Y, {
    // >>> MISC
    id: ee,
    prefixCls: i,
    ref: t,
    omitDomProps: Ec,
    mode: n,
    displayValues: qe,
    onDisplayValuesChange: ot,
    direction: T,
    searchValue: ye,
    onSearch: Ae,
    autoClearSearchValue: p,
    onSearchSplit: vt,
    dropdownMatchSelectWidth: m,
    OptionList: Ga,
    emptyOptions: !Te.length,
    activeValue: at,
    activeDescendantId: "".concat(ee, "_list_").concat(xt)
  })));
});
process.env.NODE_ENV !== "production" && (Ya.displayName = "Select");
var ro = Ya;
ro.Option = to;
ro.OptGroup = eo;
const Ja = () => {
  const [, e] = Mn(), [t] = ar("Empty"), n = new cn(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ a.createElement("svg", {
    style: n,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ a.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ a.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ a.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ a.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ a.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ a.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ a.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (Ja.displayName = "EmptyImage");
const Qa = () => {
  const [, e] = Mn(), [t] = ar("Empty"), {
    colorFill: r,
    colorFillTertiary: n,
    colorFillQuaternary: o,
    colorBgContainer: i
  } = e, {
    borderColor: c,
    shadowColor: l,
    contentColor: d
  } = kt(() => ({
    borderColor: new cn(r).onBackground(i).toHexString(),
    shadowColor: new cn(n).onBackground(i).toHexString(),
    contentColor: new cn(o).onBackground(i).toHexString()
  }), [r, n, o, i]);
  return /* @__PURE__ */ a.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ a.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ a.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ a.createElement("ellipse", {
    fill: l,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ a.createElement("g", {
    fillRule: "nonzero",
    stroke: c
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: d
  }))));
};
process.env.NODE_ENV !== "production" && (Qa.displayName = "SimpleImage");
const $c = (e) => {
  const {
    componentCls: t,
    margin: r,
    marginXS: n,
    marginXL: o,
    fontSize: i,
    lineHeight: c
  } = e;
  return {
    [t]: {
      marginInline: n,
      fontSize: i,
      lineHeight: c,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: n,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-footer`]: {
        marginTop: r
      },
      "&-normal": {
        marginBlock: o,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: n,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, Nc = pn("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: r,
    calc: n
  } = e, o = tn(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: n(r).mul(2.5).equal(),
    emptyImgHeightMD: r,
    emptyImgHeightSM: n(r).mul(0.875).equal()
  });
  return [$c(o)];
});
var Oc = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Za = /* @__PURE__ */ a.createElement(Ja, null), ei = /* @__PURE__ */ a.createElement(Qa, null), Zt = (e) => {
  const {
    className: t,
    rootClassName: r,
    prefixCls: n,
    image: o = Za,
    description: i,
    children: c,
    imageStyle: l,
    style: d,
    classNames: s,
    styles: v
  } = e, f = Oc(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style", "classNames", "styles"]), {
    getPrefixCls: p,
    direction: u,
    className: g,
    style: b,
    classNames: m,
    styles: h
  } = rr("empty"), C = p("empty", n), [S, E, x] = Nc(C), [w] = ar("Empty"), N = typeof i < "u" ? i : w == null ? void 0 : w.description, I = typeof N == "string" ? N : "empty";
  let y = null;
  if (typeof o == "string" ? y = /* @__PURE__ */ a.createElement("img", {
    alt: I,
    src: o
  }) : y = o, process.env.NODE_ENV !== "production") {
    const M = rn("Empty");
    [["imageStyle", "styles: { image: {} }"]].forEach(([T, O]) => {
      M.deprecated(!(T in e), T, O);
    });
  }
  return S(/* @__PURE__ */ a.createElement("div", Object.assign({
    className: Q(E, x, C, g, {
      [`${C}-normal`]: o === ei,
      [`${C}-rtl`]: u === "rtl"
    }, t, r, m.root, s == null ? void 0 : s.root),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, h.root), b), v == null ? void 0 : v.root), d)
  }, f), /* @__PURE__ */ a.createElement("div", {
    className: Q(`${C}-image`, m.image, s == null ? void 0 : s.image),
    style: Object.assign(Object.assign(Object.assign({}, l), h.image), v == null ? void 0 : v.image)
  }, y), N && /* @__PURE__ */ a.createElement("div", {
    className: Q(`${C}-description`, m.description, s == null ? void 0 : s.description),
    style: Object.assign(Object.assign({}, h.description), v == null ? void 0 : v.description)
  }, N), c && /* @__PURE__ */ a.createElement("div", {
    className: Q(`${C}-footer`, m.footer, s == null ? void 0 : s.footer),
    style: Object.assign(Object.assign({}, h.footer), v == null ? void 0 : v.footer)
  }, c)));
};
Zt.PRESENTED_IMAGE_DEFAULT = Za;
Zt.PRESENTED_IMAGE_SIMPLE = ei;
process.env.NODE_ENV !== "production" && (Zt.displayName = "Empty");
const ti = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: r
  } = xl(Gt), n = r("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ oe.createElement(Zt, {
        image: Zt.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ oe.createElement(Zt, {
        image: Zt.PRESENTED_IMAGE_SIMPLE,
        className: `${n}-small`
      });
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ oe.createElement(Zt, null);
  }
}, Ic = (e) => {
  const r = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, r), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, r), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, r), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, r), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function Rc(e, t) {
  return e || Ic(t);
}
const qo = (e) => {
  const {
    optionHeight: t,
    optionFontSize: r,
    optionLineHeight: n,
    optionPadding: o
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: o,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: r,
    lineHeight: n,
    boxSizing: "border-box"
  };
}, Pc = (e) => {
  const {
    antCls: t,
    componentCls: r
  } = e, n = `${r}-item`, o = `&${t}-slide-up-enter${t}-slide-up-enter-active`, i = `&${t}-slide-up-appear${t}-slide-up-appear-active`, c = `&${t}-slide-up-leave${t}-slide-up-leave-active`, l = `${r}-dropdown-placement-`, d = `${n}-option-selected`;
  return [
    {
      [`${r}-dropdown`]: Object.assign(Object.assign({}, zt(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${o}${l}bottomLeft,
          ${i}${l}bottomLeft
        `]: {
          animationName: Jl
        },
        [`
          ${o}${l}topLeft,
          ${i}${l}topLeft,
          ${o}${l}topRight,
          ${i}${l}topRight
        `]: {
          animationName: Ql
        },
        [`${c}${l}bottomLeft`]: {
          animationName: Zl
        },
        [`
          ${c}${l}topLeft,
          ${c}${l}topRight
        `]: {
          animationName: es
        },
        "&-hidden": {
          display: "none"
        },
        [n]: Object.assign(Object.assign({}, qo(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, Zn),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${n}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${n}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${n}-option-state`]: {
                color: e.colorPrimary
              }
            },
            "&-disabled": {
              [`&${n}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, qo(e)), {
            color: e.colorTextDisabled
          })
        }),
        // https://github.com/ant-design/ant-design/pull/46646
        [`${d}:has(+ ${d})`]: {
          borderEndStartRadius: 0,
          borderEndEndRadius: 0,
          [`& + ${d}`]: {
            borderStartStartRadius: 0,
            borderStartEndRadius: 0
          }
        },
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    Do(e, "slide-up"),
    Do(e, "slide-down"),
    To(e, "move-up"),
    To(e, "move-down")
  ];
};
function mr(e, t) {
  const {
    componentCls: r,
    inputPaddingHorizontalBase: n,
    borderRadius: o
  } = e, i = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), c = t ? `${r}-${t}` : "";
  return {
    [`${r}-single${c}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${r}-selector`]: Object.assign(Object.assign({}, zt(e, !0)), {
        display: "flex",
        borderRadius: o,
        flex: "1 1 auto",
        [`${r}-selection-wrap:after`]: {
          lineHeight: U(i)
        },
        [`${r}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${r}-selection-item,
          ${r}-selection-placeholder
        `]: {
          display: "block",
          padding: 0,
          lineHeight: U(i),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${r}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${r}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${r}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${r}-show-arrow ${r}-selection-item,
        &${r}-show-arrow ${r}-selection-search,
        &${r}-show-arrow ${r}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${r}-open ${r}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${r}-customize-input)`]: {
        [`${r}-selector`]: {
          width: "100%",
          height: "100%",
          alignItems: "center",
          padding: `0 ${U(n)}`,
          [`${r}-selection-search-input`]: {
            height: i,
            fontSize: e.fontSize
          },
          "&:after": {
            lineHeight: U(i)
          }
        }
      },
      [`&${r}-customize-input`]: {
        [`${r}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${r}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${r}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${U(n)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function Dc(e) {
  const {
    componentCls: t
  } = e, r = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    mr(e),
    // ======================== Small ========================
    // Shared
    mr(tn(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selector`]: {
            padding: `0 ${U(r)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(r).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    mr(tn(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const Tc = (e) => {
  const {
    fontSize: t,
    lineHeight: r,
    lineWidth: n,
    controlHeight: o,
    controlHeightSM: i,
    controlHeightLG: c,
    paddingXXS: l,
    controlPaddingHorizontal: d,
    zIndexPopupBase: s,
    colorText: v,
    fontWeightStrong: f,
    controlItemBgActive: p,
    controlItemBgHover: u,
    colorBgContainer: g,
    colorFillSecondary: b,
    colorBgContainerDisabled: m,
    colorTextDisabled: h,
    colorPrimaryHover: C,
    colorPrimary: S,
    controlOutline: E
  } = e, x = l * 2, w = n * 2, N = Math.min(o - x, o - w), I = Math.min(i - x, i - w), y = Math.min(c - x, c - w);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(l / 2),
    zIndexPopup: s + 50,
    optionSelectedColor: v,
    optionSelectedFontWeight: f,
    optionSelectedBg: p,
    optionActiveBg: u,
    optionPadding: `${(o - t * r) / 2}px ${d}px`,
    optionFontSize: t,
    optionLineHeight: r,
    optionHeight: o,
    selectorBg: g,
    clearBg: g,
    singleItemHeightLG: c,
    multipleItemBg: b,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: N,
    multipleItemHeightSM: I,
    multipleItemHeightLG: y,
    multipleSelectorBgDisabled: m,
    multipleItemColorDisabled: h,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25),
    hoverBorderColor: C,
    activeBorderColor: S,
    activeOutlineColor: E,
    selectAffixPadding: l
  };
}, ni = (e, t) => {
  const {
    componentCls: r,
    antCls: n,
    controlOutlineWidth: o
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      border: `${U(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${n}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${r}-focused& ${r}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${U(o)} ${t.activeOutlineColor}`,
        outline: 0
      },
      [`${r}-prefix`]: {
        color: t.color
      }
    }
  };
}, Xo = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, ni(e, t))
}), Mc = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, ni(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor,
    color: e.colorText
  })), Xo(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline,
    color: e.colorError
  })), Xo(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${U(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), ri = (e, t) => {
  const {
    componentCls: r,
    antCls: n
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      background: t.bg,
      border: `${U(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${n}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        background: t.hoverBg
      },
      [`${r}-focused& ${r}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, Uo = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, ri(e, t))
}), _c = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, ri(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor,
    color: e.colorText
  })), Uo(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), Uo(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${U(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), kc = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      border: `${U(e.lineWidth)} ${e.lineType} transparent`
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${U(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    },
    // Status
    [`&${e.componentCls}-status-error`]: {
      [`${e.componentCls}-prefix, ${e.componentCls}-selection-item`]: {
        color: e.colorError
      }
    },
    [`&${e.componentCls}-status-warning`]: {
      [`${e.componentCls}-prefix, ${e.componentCls}-selection-item`]: {
        color: e.colorWarning
      }
    }
  }
}), oi = (e, t) => {
  const {
    componentCls: r,
    antCls: n
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      borderWidth: `0 0 ${U(e.lineWidth)} 0`,
      borderStyle: `none none ${e.lineType} none`,
      borderColor: t.borderColor,
      background: e.selectorBg,
      borderRadius: 0
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${n}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${r}-focused& ${r}-selector`]: {
        borderColor: t.activeBorderColor,
        outline: 0
      },
      [`${r}-prefix`]: {
        color: t.color
      }
    }
  };
}, Go = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, oi(e, t))
}), Kc = (e) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign({}, oi(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor,
    color: e.colorText
  })), Go(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline,
    color: e.colorError
  })), Go(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${U(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), Bc = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, Mc(e)), _c(e)), kc(e)), Kc(e))
}), zc = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, Lc = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        appearance: "none"
      }
    }
  };
}, Hc = (e) => {
  const {
    antCls: t,
    componentCls: r,
    inputPaddingHorizontalBase: n,
    iconCls: o
  } = e, i = {
    [`${r}-clear`]: {
      opacity: 1,
      background: e.colorBgBase,
      borderRadius: "50%"
    }
  };
  return {
    [r]: Object.assign(Object.assign({}, zt(e)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${r}-customize-input) ${r}-selector`]: Object.assign(Object.assign({}, zc(e)), Lc(e)),
      // ======================== Selection ========================
      [`${r}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, Zn), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${r}-selection-placeholder`]: Object.assign(Object.assign({}, Zn), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${r}-arrow`]: Object.assign(Object.assign({}, Ol()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [o]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${r}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${r}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Wrap ===========================
      [`${r}-selection-wrap`]: {
        display: "flex",
        width: "100%",
        position: "relative",
        minWidth: 0,
        // https://github.com/ant-design/ant-design/issues/51669
        "&:after": {
          content: '"\\a0"',
          width: 0,
          overflow: "hidden"
        }
      },
      // ========================= Prefix ==========================
      [`${r}-prefix`]: {
        flex: "none",
        marginInlineEnd: e.selectAffixPadding
      },
      // ========================== Clear ==========================
      [`${r}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: n,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorIcon
        }
      },
      "@media(hover:none)": i,
      "&:hover": i
    }),
    // ========================= Feedback ==========================
    [`${r}-status`]: {
      "&-error, &-warning, &-success, &-validating": {
        [`&${r}-has-feedback`]: {
          [`${r}-clear`]: {
            insetInlineEnd: e.calc(n).add(e.fontSize).add(e.paddingXS).equal()
          }
        }
      }
    }
  };
}, jc = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    Hc(e),
    // Single
    Dc(e),
    // Multiple
    Al(e),
    // Dropdown
    Pc(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    vs(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, Vc = pn("Select", (e, {
  rootPrefixCls: t
}) => {
  const r = tn(e, {
    rootPrefixCls: t,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [jc(r), Bc(r)];
}, Tc, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
function Ac(e, t) {
  return t !== void 0 ? t : e !== null;
}
var Fc = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const ai = "SECRET_COMBOBOX_MODE_DO_NOT_USE", ii = (e, t) => {
  var r, n, o, i, c;
  const {
    prefixCls: l,
    bordered: d,
    className: s,
    rootClassName: v,
    getPopupContainer: f,
    popupClassName: p,
    dropdownClassName: u,
    listHeight: g = 256,
    placement: b,
    listItemHeight: m,
    size: h,
    disabled: C,
    notFoundContent: S,
    status: E,
    builtinPlacements: x,
    dropdownMatchSelectWidth: w,
    popupMatchSelectWidth: N,
    direction: I,
    style: y,
    allowClear: M,
    variant: T,
    dropdownStyle: O,
    transitionName: R,
    tagRender: P,
    maxCount: $,
    prefix: D,
    dropdownRender: _,
    popupRender: z,
    onDropdownVisibleChange: B,
    onOpenChange: W,
    styles: X,
    classNames: Y
  } = e, ee = Fc(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "styles", "classNames"]), {
    getPopupContainer: ie,
    getPrefixCls: ue,
    renderEmpty: xe,
    direction: Z,
    virtual: ae,
    popupMatchSelectWidth: me,
    popupOverflow: ye
  } = a.useContext(Gt), {
    showSearch: L,
    style: k,
    styles: H,
    className: q,
    classNames: A
  } = rr("select"), [, j] = Mn(), fe = m ?? (j == null ? void 0 : j.controlHeight), te = ue("select", l), Ne = ue(), Ee = I ?? Z, {
    compactSize: V,
    compactItemClassnames: G
  } = jl(te, Ee), [Ce, be] = fs("select", T, d), $e = _n(te), [qe, Oe, He] = Vc(te, $e), Se = a.useMemo(() => {
    const {
      mode: de
    } = e;
    if (de !== "combobox")
      return de === ai ? "combobox" : de;
  }, [e.mode]), he = Se === "multiple" || Se === "tags", ne = Ac(e.suffixIcon, e.showArrow), J = (r = N ?? w) !== null && r !== void 0 ? r : me, ke = ((n = X == null ? void 0 : X.popup) === null || n === void 0 ? void 0 : n.root) || ((o = H.popup) === null || o === void 0 ? void 0 : o.root) || O, Te = z || _, ve = W || B, {
    status: tt,
    hasFeedback: De,
    isFormItemInput: at,
    feedbackIcon: je
  } = a.useContext(Gr), dt = as(tt, E);
  let ut;
  S !== void 0 ? ut = S : Se === "combobox" ? ut = null : ut = (xe == null ? void 0 : xe("Select")) || /* @__PURE__ */ a.createElement(ti, {
    componentName: "Select"
  });
  const {
    suffixIcon: xt,
    itemIcon: Ue,
    removeIcon: Tt,
    clearIcon: it
  } = Fl(Object.assign(Object.assign({}, ee), {
    multiple: he,
    hasFeedback: De,
    feedbackIcon: je,
    showSuffixIcon: ne,
    prefixCls: te,
    componentName: "Select"
  })), lt = M === !0 ? {
    clearIcon: it
  } : M, ft = qn(ee, ["suffixIcon", "itemIcon"]), ot = Q(((i = Y == null ? void 0 : Y.popup) === null || i === void 0 ? void 0 : i.root) || ((c = A == null ? void 0 : A.popup) === null || c === void 0 ? void 0 : c.root) || p || u, {
    [`${te}-dropdown-${Ee}`]: Ee === "rtl"
  }, v, A.root, Y == null ? void 0 : Y.root, He, $e, Oe), Ae = or((de) => {
    var Le;
    return (Le = h ?? V) !== null && Le !== void 0 ? Le : de;
  }), vt = a.useContext(Xr), pt = C ?? vt, le = Q({
    [`${te}-lg`]: Ae === "large",
    [`${te}-sm`]: Ae === "small",
    [`${te}-rtl`]: Ee === "rtl",
    [`${te}-${Ce}`]: be,
    [`${te}-in-form-item`]: at
  }, os(te, dt, De), G, q, s, A.root, Y == null ? void 0 : Y.root, v, He, $e, Oe), re = a.useMemo(() => b !== void 0 ? b : Ee === "rtl" ? "bottomRight" : "bottomLeft", [b, Ee]);
  if (process.env.NODE_ENV !== "production") {
    const de = rn("Select");
    Object.entries({
      dropdownMatchSelectWidth: "popupMatchSelectWidth",
      dropdownStyle: "styles.popup.root",
      dropdownClassName: "classNames.popup.root",
      popupClassName: "classNames.popup.root",
      dropdownRender: "popupRender",
      onDropdownVisibleChange: "onOpenChange",
      bordered: "variant"
    }).forEach(([Ge, mt]) => {
      de.deprecated(!(Ge in e), Ge, mt);
    }), process.env.NODE_ENV !== "production" && de(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), process.env.NODE_ENV !== "production" && de(!(typeof $ < "u" && !he), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [se] = Hl("SelectLike", ke == null ? void 0 : ke.zIndex);
  return qe(/* @__PURE__ */ a.createElement(ro, Object.assign({
    ref: t,
    virtual: ae,
    showSearch: L
  }, ft, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, H.root), X == null ? void 0 : X.root), k), y),
    dropdownMatchSelectWidth: J,
    transitionName: ts(Ne, "slide-up", R),
    builtinPlacements: Rc(x, ye),
    listHeight: g,
    listItemHeight: fe,
    mode: Se,
    prefixCls: te,
    placement: re,
    direction: Ee,
    prefix: D,
    suffixIcon: xt,
    menuItemSelectedIcon: Ue,
    removeIcon: Tt,
    allowClear: lt,
    notFoundContent: ut,
    className: le,
    getPopupContainer: f || ie,
    dropdownClassName: ot,
    disabled: pt,
    dropdownStyle: Object.assign(Object.assign({}, ke), {
      zIndex: se
    }),
    maxCount: he ? $ : void 0,
    tagRender: he ? P : void 0,
    dropdownRender: Te,
    onDropdownVisibleChange: ve
  })));
};
process.env.NODE_ENV !== "production" && (ii.displayName = "Select");
const Sn = /* @__PURE__ */ a.forwardRef(ii), Wc = rs(Sn, "dropdownAlign");
Sn.SECRET_COMBOBOX_MODE_DO_NOT_USE = ai;
Sn.Option = to;
Sn.OptGroup = eo;
Sn._InternalPanelDoNotUseOrYouWillBeFired = Wc;
process.env.NODE_ENV !== "production" && (Sn.displayName = "Select");
const li = /* @__PURE__ */ a.createContext(null), qc = li.Provider, si = /* @__PURE__ */ a.createContext(null), Xc = si.Provider;
var Uc = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], ci = /* @__PURE__ */ Da(function(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-checkbox" : r, o = e.className, i = e.style, c = e.checked, l = e.disabled, d = e.defaultChecked, s = d === void 0 ? !1 : d, v = e.type, f = v === void 0 ? "checkbox" : v, p = e.title, u = e.onChange, g = yt(e, Uc), b = et(null), m = et(null), h = un(s, {
    value: c
  }), C = ce(h, 2), S = C[0], E = C[1];
  Ta(t, function() {
    return {
      focus: function(I) {
        var y;
        (y = b.current) === null || y === void 0 || y.focus(I);
      },
      blur: function() {
        var I;
        (I = b.current) === null || I === void 0 || I.blur();
      },
      input: b.current,
      nativeElement: m.current
    };
  });
  var x = Q(n, o, K(K({}, "".concat(n, "-checked"), S), "".concat(n, "-disabled"), l)), w = function(I) {
    l || ("checked" in e || E(I.target.checked), u == null || u({
      target: F(F({}, e), {}, {
        type: f,
        checked: I.target.checked
      }),
      stopPropagation: function() {
        I.stopPropagation();
      },
      preventDefault: function() {
        I.preventDefault();
      },
      nativeEvent: I.nativeEvent
    }));
  };
  return /* @__PURE__ */ a.createElement("span", {
    className: x,
    title: p,
    style: i,
    ref: m
  }, /* @__PURE__ */ a.createElement("input", Pe({}, g, {
    className: "".concat(n, "-input"),
    ref: b,
    onChange: w,
    disabled: l,
    checked: !!S,
    type: f
  })), /* @__PURE__ */ a.createElement("span", {
    className: "".concat(n, "-inner")
  }));
});
function di(e) {
  const t = oe.useRef(null), r = () => {
    Pt.cancel(t.current), t.current = null;
  };
  return [() => {
    r(), t.current = Pt(() => {
      t.current = null;
    });
  }, (i) => {
    t.current && (i.stopPropagation(), r()), e == null || e(i);
  }];
}
const Gc = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, n = `${t}-group`;
  return {
    [n]: Object.assign(Object.assign({}, zt(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${n}-rtl`]: {
        direction: "rtl"
      },
      [`&${n}-block`]: {
        display: "flex"
      },
      [`${r}-badge ${r}-badge-count`]: {
        zIndex: 1
      },
      [`> ${r}-badge:not(:first-child) > ${r}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, Yc = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: r,
    colorPrimary: n,
    radioSize: o,
    motionDurationSlow: i,
    motionDurationMid: c,
    motionEaseInOutCirc: l,
    colorBgContainer: d,
    colorBorder: s,
    lineWidth: v,
    colorBgContainerDisabled: f,
    colorTextDisabled: p,
    paddingXS: u,
    dotColorDisabled: g,
    lineType: b,
    radioColor: m,
    radioBgColor: h,
    calc: C
  } = e, S = `${t}-inner`, x = C(o).sub(C(4).mul(2)), w = C(1).mul(o).equal({
    unit: !0
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, zt(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: r,
      cursor: "pointer",
      "&:last-child": {
        marginInlineEnd: 0
      },
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      "&-block": {
        flex: 1,
        justifyContent: "center"
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${U(v)} ${b} ${n}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, zt(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${S}`]: {
        borderColor: n
      },
      [`${t}-input:focus-visible + ${S}`]: Object.assign({}, Pn(e)),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: w,
          height: w,
          marginBlockStart: C(1).mul(o).div(-2).equal({
            unit: !0
          }),
          marginInlineStart: C(1).mul(o).div(-2).equal({
            unit: !0
          }),
          backgroundColor: m,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: w,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${i} ${l}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: w,
        height: w,
        backgroundColor: d,
        borderColor: s,
        borderStyle: "solid",
        borderWidth: v,
        borderRadius: "50%",
        transition: `all ${c}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [S]: {
          borderColor: n,
          backgroundColor: h,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(o).equal()})`,
            opacity: 1,
            transition: `all ${i} ${l}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [S]: {
          backgroundColor: f,
          borderColor: s,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: g
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: p,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [S]: {
            "&::after": {
              transform: `scale(${C(x).div(o).equal()})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: u,
        paddingInlineEnd: u
      }
    })
  };
}, Jc = (e) => {
  const {
    buttonColor: t,
    controlHeight: r,
    componentCls: n,
    lineWidth: o,
    lineType: i,
    colorBorder: c,
    motionDurationSlow: l,
    motionDurationMid: d,
    buttonPaddingInline: s,
    fontSize: v,
    buttonBg: f,
    fontSizeLG: p,
    controlHeightLG: u,
    controlHeightSM: g,
    paddingXS: b,
    borderRadius: m,
    borderRadiusSM: h,
    borderRadiusLG: C,
    buttonCheckedBg: S,
    buttonSolidCheckedColor: E,
    colorTextDisabled: x,
    colorBgContainerDisabled: w,
    buttonCheckedBgDisabled: N,
    buttonCheckedColorDisabled: I,
    colorPrimary: y,
    colorPrimaryHover: M,
    colorPrimaryActive: T,
    buttonSolidCheckedBg: O,
    buttonSolidCheckedHoverBg: R,
    buttonSolidCheckedActiveBg: P,
    calc: $
  } = e;
  return {
    [`${n}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: r,
      margin: 0,
      paddingInline: s,
      paddingBlock: 0,
      color: t,
      fontSize: v,
      lineHeight: U($(r).sub($(o).mul(2)).equal()),
      background: f,
      border: `${U(o)} ${i} ${c}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: $(o).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: o,
      cursor: "pointer",
      transition: [`color ${d}`, `background ${d}`, `box-shadow ${d}`].join(","),
      a: {
        color: t
      },
      [`> ${n}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: $(o).mul(-1).equal(),
          insetInlineStart: $(o).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: o,
          paddingInline: 0,
          backgroundColor: c,
          transition: `background-color ${l}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${U(o)} ${i} ${c}`,
        borderStartStartRadius: m,
        borderEndStartRadius: m
      },
      "&:last-child": {
        borderStartEndRadius: m,
        borderEndEndRadius: m
      },
      "&:first-child:last-child": {
        borderRadius: m
      },
      [`${n}-group-large &`]: {
        height: u,
        fontSize: p,
        lineHeight: U($(u).sub($(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: C,
          borderEndStartRadius: C
        },
        "&:last-child": {
          borderStartEndRadius: C,
          borderEndEndRadius: C
        }
      },
      [`${n}-group-small &`]: {
        height: g,
        paddingInline: $(b).sub(o).equal(),
        paddingBlock: 0,
        lineHeight: U($(g).sub($(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: h,
          borderEndStartRadius: h
        },
        "&:last-child": {
          borderStartEndRadius: h,
          borderEndEndRadius: h
        }
      },
      "&:hover": {
        position: "relative",
        color: y
      },
      "&:has(:focus-visible)": Object.assign({}, Pn(e)),
      [`${n}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${n}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: y,
        background: S,
        borderColor: y,
        "&::before": {
          backgroundColor: y
        },
        "&:first-child": {
          borderColor: y
        },
        "&:hover": {
          color: M,
          borderColor: M,
          "&::before": {
            backgroundColor: M
          }
        },
        "&:active": {
          color: T,
          borderColor: T,
          "&::before": {
            backgroundColor: T
          }
        }
      },
      [`${n}-group-solid &-checked:not(${n}-button-wrapper-disabled)`]: {
        color: E,
        background: O,
        borderColor: O,
        "&:hover": {
          color: E,
          background: R,
          borderColor: R
        },
        "&:active": {
          color: E,
          background: P,
          borderColor: P
        }
      },
      "&-disabled": {
        color: x,
        backgroundColor: w,
        borderColor: c,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: x,
          backgroundColor: w,
          borderColor: c
        }
      },
      [`&-disabled${n}-button-wrapper-checked`]: {
        color: I,
        backgroundColor: N,
        borderColor: c,
        boxShadow: "none"
      },
      "&-block": {
        flex: 1,
        textAlign: "center"
      }
    }
  };
}, Qc = (e) => {
  const {
    wireframe: t,
    padding: r,
    marginXS: n,
    lineWidth: o,
    fontSizeLG: i,
    colorText: c,
    colorBgContainer: l,
    colorTextDisabled: d,
    controlItemBgActiveDisabled: s,
    colorTextLightSolid: v,
    colorPrimary: f,
    colorPrimaryHover: p,
    colorPrimaryActive: u,
    colorWhite: g
  } = e, b = 4, m = i, h = t ? m - b * 2 : m - (b + o) * 2;
  return {
    // Radio
    radioSize: m,
    dotSize: h,
    dotColorDisabled: d,
    // Radio buttons
    buttonSolidCheckedColor: v,
    buttonSolidCheckedBg: f,
    buttonSolidCheckedHoverBg: p,
    buttonSolidCheckedActiveBg: u,
    buttonBg: l,
    buttonCheckedBg: l,
    buttonColor: c,
    buttonCheckedBgDisabled: s,
    buttonCheckedColorDisabled: d,
    buttonPaddingInline: r - o,
    wrapperMarginInlineEnd: n,
    // internal
    radioColor: t ? f : g,
    radioBgColor: t ? l : f
  };
}, ui = pn("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: r
  } = e, n = `0 0 0 ${U(r)} ${t}`, i = tn(e, {
    radioFocusShadow: n,
    radioButtonFocusShadow: n
  });
  return [Gc(i), Yc(i), Jc(i)];
}, Qc, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var Zc = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const ed = (e, t) => {
  var r, n;
  const o = a.useContext(li), i = a.useContext(si), {
    getPrefixCls: c,
    direction: l,
    radio: d
  } = a.useContext(Gt), s = a.useRef(null), v = Fr(t, s), {
    isFormItemInput: f
  } = a.useContext(Gr);
  if (process.env.NODE_ENV !== "production") {
    const D = rn("Radio");
    process.env.NODE_ENV !== "production" && D(!("optionType" in e), "usage", "`optionType` is only support in Radio.Group.");
  }
  const p = (D) => {
    var _, z;
    (_ = e.onChange) === null || _ === void 0 || _.call(e, D), (z = o == null ? void 0 : o.onChange) === null || z === void 0 || z.call(o, D);
  }, {
    prefixCls: u,
    className: g,
    rootClassName: b,
    children: m,
    style: h,
    title: C
  } = e, S = Zc(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), E = c("radio", u), x = ((o == null ? void 0 : o.optionType) || i) === "button", w = x ? `${E}-button` : E, N = _n(E), [I, y, M] = ui(E, N), T = Object.assign({}, S), O = a.useContext(Xr);
  o && (T.name = o.name, T.onChange = p, T.checked = e.value === o.value, T.disabled = (r = T.disabled) !== null && r !== void 0 ? r : o.disabled), T.disabled = (n = T.disabled) !== null && n !== void 0 ? n : O;
  const R = Q(`${w}-wrapper`, {
    [`${w}-wrapper-checked`]: T.checked,
    [`${w}-wrapper-disabled`]: T.disabled,
    [`${w}-wrapper-rtl`]: l === "rtl",
    [`${w}-wrapper-in-form-item`]: f,
    [`${w}-wrapper-block`]: !!(o != null && o.block)
  }, d == null ? void 0 : d.className, g, b, y, M, N), [P, $] = di(T.onClick);
  return I(/* @__PURE__ */ a.createElement(Ka, {
    component: "Radio",
    disabled: T.disabled
  }, /* @__PURE__ */ a.createElement("label", {
    className: R,
    style: Object.assign(Object.assign({}, d == null ? void 0 : d.style), h),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: C,
    onClick: P
  }, /* @__PURE__ */ a.createElement(ci, Object.assign({}, T, {
    className: Q(T.className, {
      [Ba]: !x
    }),
    type: "radio",
    prefixCls: w,
    ref: v,
    onClick: $
  })), m !== void 0 ? /* @__PURE__ */ a.createElement("span", {
    className: `${w}-label`
  }, m) : null)));
}, Fn = /* @__PURE__ */ a.forwardRef(ed);
process.env.NODE_ENV !== "production" && (Fn.displayName = "Radio");
const td = /* @__PURE__ */ a.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: n
  } = a.useContext(Gt), o = ql(), {
    prefixCls: i,
    className: c,
    rootClassName: l,
    options: d,
    buttonStyle: s = "outline",
    disabled: v,
    children: f,
    size: p,
    style: u,
    id: g,
    optionType: b,
    name: m = o,
    defaultValue: h,
    value: C,
    block: S = !1,
    onChange: E,
    onMouseEnter: x,
    onMouseLeave: w,
    onFocus: N,
    onBlur: I
  } = e, [y, M] = un(h, {
    value: C
  }), T = a.useCallback((Y) => {
    const ee = y, ie = Y.target.value;
    "value" in e || M(ie), ie !== ee && (E == null || E(Y));
  }, [y, M, E]), O = r("radio", i), R = `${O}-group`, P = _n(O), [$, D, _] = ui(O, P);
  let z = f;
  d && d.length > 0 && (z = d.map((Y) => typeof Y == "string" || typeof Y == "number" ? /* @__PURE__ */ a.createElement(Fn, {
    key: Y.toString(),
    prefixCls: O,
    disabled: v,
    value: Y,
    checked: y === Y
  }, Y) : /* @__PURE__ */ a.createElement(Fn, {
    key: `radio-group-value-options-${Y.value}`,
    prefixCls: O,
    disabled: Y.disabled || v,
    value: Y.value,
    checked: y === Y.value,
    title: Y.title,
    style: Y.style,
    className: Y.className,
    id: Y.id,
    required: Y.required
  }, Y.label)));
  const B = or(p), W = Q(R, `${R}-${s}`, {
    [`${R}-${B}`]: B,
    [`${R}-rtl`]: n === "rtl",
    [`${R}-block`]: S
  }, c, l, D, _, P), X = a.useMemo(() => ({
    onChange: T,
    value: y,
    disabled: v,
    name: m,
    optionType: b,
    block: S
  }), [T, y, v, m, b, S]);
  return $(/* @__PURE__ */ a.createElement("div", Object.assign({}, nn(e, {
    aria: !0,
    data: !0
  }), {
    className: W,
    style: u,
    onMouseEnter: x,
    onMouseLeave: w,
    onFocus: N,
    onBlur: I,
    id: g,
    ref: t
  }), /* @__PURE__ */ a.createElement(qc, {
    value: X
  }, z)));
}), nd = /* @__PURE__ */ a.memo(td);
var rd = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const od = (e, t) => {
  const {
    getPrefixCls: r
  } = a.useContext(Gt), {
    prefixCls: n
  } = e, o = rd(e, ["prefixCls"]), i = r("radio", n);
  return /* @__PURE__ */ a.createElement(Xc, {
    value: "button"
  }, /* @__PURE__ */ a.createElement(Fn, Object.assign({
    prefixCls: i
  }, o, {
    type: "radio",
    ref: t
  })));
}, ad = /* @__PURE__ */ a.forwardRef(od), Xn = Fn;
Xn.Button = ad;
Xn.Group = nd;
Xn.__ANT_RADIO = !0;
function id(e, t, r) {
  var n = r || {}, o = n.noTrailing, i = o === void 0 ? !1 : o, c = n.noLeading, l = c === void 0 ? !1 : c, d = n.debounceMode, s = d === void 0 ? void 0 : d, v, f = !1, p = 0;
  function u() {
    v && clearTimeout(v);
  }
  function g(m) {
    var h = m || {}, C = h.upcomingOnly, S = C === void 0 ? !1 : C;
    u(), f = !S;
  }
  function b() {
    for (var m = arguments.length, h = new Array(m), C = 0; C < m; C++)
      h[C] = arguments[C];
    var S = this, E = Date.now() - p;
    if (f)
      return;
    function x() {
      p = Date.now(), t.apply(S, h);
    }
    function w() {
      v = void 0;
    }
    !l && s && !v && x(), u(), s === void 0 && E > e ? l ? (p = Date.now(), i || (v = setTimeout(s ? w : x, e))) : x() : i !== !0 && (v = setTimeout(s ? w : x, s === void 0 ? e - E : e));
  }
  return b.cancel = g, b;
}
function ld(e, t, r) {
  var n = {}, o = n.atBegin, i = o === void 0 ? !1 : o;
  return id(e, t, {
    debounceMode: i !== !1
  });
}
function Kt(e, t) {
  return e[t];
}
var sd = ["children"];
function fi(e, t) {
  return "".concat(e, "-").concat(t);
}
function cd(e) {
  return e && e.type && e.type.isTreeNode;
}
function Un(e, t) {
  return e ?? t;
}
function Dn(e) {
  var t = e || {}, r = t.title, n = t._title, o = t.key, i = t.children, c = r || "title";
  return {
    title: c,
    _title: n || [c],
    key: o || "key",
    children: i || "children"
  };
}
function dd(e, t) {
  var r = /* @__PURE__ */ new Map();
  function n(o) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (o || []).forEach(function(c) {
      var l = c[t.key], d = c[t.children];
      Qe(l != null, "Tree node must have a certain key: [".concat(i).concat(l, "]"));
      var s = String(l);
      Qe(!r.has(s) || l === null || l === void 0, "Same 'key' exist in the Tree: ".concat(s)), r.set(s, !0), n(d, "".concat(i).concat(s, " > "));
    });
  }
  n(e);
}
function vi(e) {
  function t(r) {
    var n = An(r);
    return n.map(function(o) {
      if (!cd(o))
        return Qe(!o, "Tree/TreeNode can only accept TreeNode as children."), null;
      var i = o.key, c = o.props, l = c.children, d = yt(c, sd), s = F({
        key: i
      }, d), v = t(l);
      return v.length && (s.children = v), s;
    }).filter(function(o) {
      return o;
    });
  }
  return t(e);
}
function gr(e, t, r) {
  var n = Dn(r), o = n._title, i = n.key, c = n.children, l = new Set(t === !0 ? [] : t), d = [];
  function s(v) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return v.map(function(p, u) {
      for (var g = fi(f ? f.pos : "0", u), b = Un(p[i], g), m, h = 0; h < o.length; h += 1) {
        var C = o[h];
        if (p[C] !== void 0) {
          m = p[C];
          break;
        }
      }
      var S = Object.assign(qn(p, [].concat(_e(o), [i, c])), {
        title: m,
        key: b,
        parent: f,
        pos: g,
        children: null,
        data: p,
        isStart: [].concat(_e(f ? f.isStart : []), [u === 0]),
        isEnd: [].concat(_e(f ? f.isEnd : []), [u === v.length - 1])
      });
      return d.push(S), t === !0 || l.has(b) ? S.children = s(p[c] || [], S) : S.children = [], S;
    });
  }
  return s(e), d;
}
function ud(e, t, r) {
  var n = {};
  St(r) === "object" ? n = r : n = {
    externalGetKey: r
  }, n = n || {};
  var o = n, i = o.childrenPropName, c = o.externalGetKey, l = o.fieldNames, d = Dn(l), s = d.key, v = d.children, f = i || v, p;
  c ? typeof c == "string" ? p = function(b) {
    return b[c];
  } : typeof c == "function" && (p = function(b) {
    return c(b);
  }) : p = function(b, m) {
    return Un(b[s], m);
  };
  function u(g, b, m, h) {
    var C = g ? g[f] : e, S = g ? fi(m.pos, b) : "0", E = g ? [].concat(_e(h), [g]) : [];
    if (g) {
      var x = p(g, S), w = {
        node: g,
        index: b,
        pos: S,
        key: x,
        parentPos: m.node ? m.pos : null,
        level: m.level + 1,
        nodes: E
      };
      t(w);
    }
    C && C.forEach(function(N, I) {
      u(N, I, {
        node: g,
        pos: S,
        level: m ? m.level + 1 : -1
      }, E);
    });
  }
  u(null);
}
function oo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.initWrapper, n = t.processEntity, o = t.onProcessFinished, i = t.externalGetKey, c = t.childrenPropName, l = t.fieldNames, d = arguments.length > 2 ? arguments[2] : void 0, s = i || d, v = {}, f = {}, p = {
    posEntities: v,
    keyEntities: f
  };
  return r && (p = r(p) || p), ud(e, function(u) {
    var g = u.node, b = u.index, m = u.pos, h = u.key, C = u.parentPos, S = u.level, E = u.nodes, x = {
      node: g,
      nodes: E,
      index: b,
      key: h,
      pos: m,
      level: S
    }, w = Un(h, m);
    v[m] = x, f[w] = x, x.parent = v[C], x.parent && (x.parent.children = x.parent.children || [], x.parent.children.push(x)), n && n(x, p);
  }, {
    externalGetKey: s,
    childrenPropName: c,
    fieldNames: l
  }), o && o(p), p;
}
function Hn(e, t) {
  var r = t.expandedKeys, n = t.selectedKeys, o = t.loadedKeys, i = t.loadingKeys, c = t.checkedKeys, l = t.halfCheckedKeys, d = t.dragOverNodeKey, s = t.dropPosition, v = t.keyEntities, f = Kt(v, e), p = {
    eventKey: e,
    expanded: r.indexOf(e) !== -1,
    selected: n.indexOf(e) !== -1,
    loaded: o.indexOf(e) !== -1,
    loading: i.indexOf(e) !== -1,
    checked: c.indexOf(e) !== -1,
    halfChecked: l.indexOf(e) !== -1,
    pos: String(f ? f.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: d === e && s === 0,
    dragOverGapTop: d === e && s === -1,
    dragOverGapBottom: d === e && s === 1
  };
  return p;
}
function bt(e) {
  var t = e.data, r = e.expanded, n = e.selected, o = e.checked, i = e.loaded, c = e.loading, l = e.halfChecked, d = e.dragOver, s = e.dragOverGapTop, v = e.dragOverGapBottom, f = e.pos, p = e.active, u = e.eventKey, g = F(F({}, t), {}, {
    expanded: r,
    selected: n,
    checked: o,
    loaded: i,
    loading: c,
    halfChecked: l,
    dragOver: d,
    dragOverGapTop: s,
    dragOverGapBottom: v,
    pos: f,
    active: p,
    key: u
  });
  return "props" in g || Object.defineProperty(g, "props", {
    get: function() {
      return Qe(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), e;
    }
  }), g;
}
function pi(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    t.has(n) || r.add(n);
  }), r;
}
function fd(e) {
  var t = e || {}, r = t.disabled, n = t.disableCheckbox, o = t.checkable;
  return !!(r || n) || o === !1;
}
function vd(e, t, r, n) {
  for (var o = new Set(e), i = /* @__PURE__ */ new Set(), c = 0; c <= r; c += 1) {
    var l = t.get(c) || /* @__PURE__ */ new Set();
    l.forEach(function(f) {
      var p = f.key, u = f.node, g = f.children, b = g === void 0 ? [] : g;
      o.has(p) && !n(u) && b.filter(function(m) {
        return !n(m.node);
      }).forEach(function(m) {
        o.add(m.key);
      });
    });
  }
  for (var d = /* @__PURE__ */ new Set(), s = r; s >= 0; s -= 1) {
    var v = t.get(s) || /* @__PURE__ */ new Set();
    v.forEach(function(f) {
      var p = f.parent, u = f.node;
      if (!(n(u) || !f.parent || d.has(f.parent.key))) {
        if (n(f.parent.node)) {
          d.add(p.key);
          return;
        }
        var g = !0, b = !1;
        (p.children || []).filter(function(m) {
          return !n(m.node);
        }).forEach(function(m) {
          var h = m.key, C = o.has(h);
          g && !C && (g = !1), !b && (C || i.has(h)) && (b = !0);
        }), g && o.add(p.key), b && i.add(p.key), d.add(p.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(o),
    halfCheckedKeys: Array.from(pi(i, o))
  };
}
function pd(e, t, r, n, o) {
  for (var i = new Set(e), c = new Set(t), l = 0; l <= n; l += 1) {
    var d = r.get(l) || /* @__PURE__ */ new Set();
    d.forEach(function(p) {
      var u = p.key, g = p.node, b = p.children, m = b === void 0 ? [] : b;
      !i.has(u) && !c.has(u) && !o(g) && m.filter(function(h) {
        return !o(h.node);
      }).forEach(function(h) {
        i.delete(h.key);
      });
    });
  }
  c = /* @__PURE__ */ new Set();
  for (var s = /* @__PURE__ */ new Set(), v = n; v >= 0; v -= 1) {
    var f = r.get(v) || /* @__PURE__ */ new Set();
    f.forEach(function(p) {
      var u = p.parent, g = p.node;
      if (!(o(g) || !p.parent || s.has(p.parent.key))) {
        if (o(p.parent.node)) {
          s.add(u.key);
          return;
        }
        var b = !0, m = !1;
        (u.children || []).filter(function(h) {
          return !o(h.node);
        }).forEach(function(h) {
          var C = h.key, S = i.has(C);
          b && !S && (b = !1), !m && (S || c.has(C)) && (m = !0);
        }), b || i.delete(u.key), m && c.add(u.key), s.add(u.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(i),
    halfCheckedKeys: Array.from(pi(c, i))
  };
}
function On(e, t, r, n) {
  var o = [], i;
  n ? i = n : i = fd;
  var c = new Set(e.filter(function(v) {
    var f = !!Kt(r, v);
    return f || o.push(v), f;
  })), l = /* @__PURE__ */ new Map(), d = 0;
  Object.keys(r).forEach(function(v) {
    var f = r[v], p = f.level, u = l.get(p);
    u || (u = /* @__PURE__ */ new Set(), l.set(p, u)), u.add(f), d = Math.max(d, p);
  }), Qe(!o.length, "Tree missing follow keys: ".concat(o.slice(0, 100).map(function(v) {
    return "'".concat(v, "'");
  }).join(", ")));
  var s;
  return t === !0 ? s = vd(c, l, d, i) : s = pd(c, t.halfCheckedKeys, l, d, i), s;
}
const md = (e) => {
  const {
    checkboxCls: t
  } = e, r = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: Object.assign(Object.assign({}, zt(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [r]: Object.assign(Object.assign({}, zt(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${r}`]: {
          marginInlineStart: 0
        },
        [`&${r}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: Object.assign(Object.assign({}, zt(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: e.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: Object.assign({}, Pn(e))
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${U(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: e.calc(e.checkboxSize).div(14).mul(5).equal(),
            height: e.calc(e.checkboxSize).div(14).mul(8).equal(),
            border: `${U(e.lineWidthBold)} solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${r}:not(${r}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${r}:not(${r}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        }
      },
      [`
        ${r}-checked:not(${r}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          "&": {
            // Wrapper > Checkbox > inner
            [`${t}-inner`]: {
              backgroundColor: `${e.colorBgContainer}`,
              borderColor: `${e.colorBorder}`,
              "&:after": {
                top: "50%",
                insetInlineStart: "50%",
                width: e.calc(e.fontSizeLG).div(2).equal(),
                height: e.calc(e.fontSizeLG).div(2).equal(),
                backgroundColor: e.colorPrimary,
                border: 0,
                transform: "translate(-50%, -50%) scale(1)",
                opacity: 1,
                content: '""'
              }
            },
            // https://github.com/ant-design/ant-design/issues/50074
            [`&:hover ${t}-inner`]: {
              backgroundColor: `${e.colorBgContainer}`,
              borderColor: `${e.colorPrimary}`
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${r}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function mi(e, t) {
  const r = tn(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return [md(r)];
}
const gi = pn("Checkbox", (e, {
  prefixCls: t
}) => [mi(t, e)]), hi = /* @__PURE__ */ oe.createContext(null);
var gd = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const hd = (e, t) => {
  var r;
  const {
    prefixCls: n,
    className: o,
    rootClassName: i,
    children: c,
    indeterminate: l = !1,
    style: d,
    onMouseEnter: s,
    onMouseLeave: v,
    skipGroup: f = !1,
    disabled: p
  } = e, u = gd(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: g,
    direction: b,
    checkbox: m
  } = a.useContext(Gt), h = a.useContext(hi), {
    isFormItemInput: C
  } = a.useContext(Gr), S = a.useContext(Xr), E = (r = (h == null ? void 0 : h.disabled) || p) !== null && r !== void 0 ? r : S, x = a.useRef(u.value), w = a.useRef(null), N = Fr(t, w);
  if (process.env.NODE_ENV !== "production") {
    const z = rn("Checkbox");
    process.env.NODE_ENV !== "production" && z("checked" in u || !!h || !("value" in u), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  a.useEffect(() => {
    h == null || h.registerValue(u.value);
  }, []), a.useEffect(() => {
    if (!f)
      return u.value !== x.current && (h == null || h.cancelValue(x.current), h == null || h.registerValue(u.value), x.current = u.value), () => h == null ? void 0 : h.cancelValue(u.value);
  }, [u.value]), a.useEffect(() => {
    var z;
    !((z = w.current) === null || z === void 0) && z.input && (w.current.input.indeterminate = l);
  }, [l]);
  const I = g("checkbox", n), y = _n(I), [M, T, O] = gi(I, y), R = Object.assign({}, u);
  h && !f && (R.onChange = (...z) => {
    u.onChange && u.onChange.apply(u, z), h.toggleOption && h.toggleOption({
      label: c,
      value: u.value
    });
  }, R.name = h.name, R.checked = h.value.includes(u.value));
  const P = Q(`${I}-wrapper`, {
    [`${I}-rtl`]: b === "rtl",
    [`${I}-wrapper-checked`]: R.checked,
    [`${I}-wrapper-disabled`]: E,
    [`${I}-wrapper-in-form-item`]: C
  }, m == null ? void 0 : m.className, o, i, O, y, T), $ = Q({
    [`${I}-indeterminate`]: l
  }, Ba, T), [D, _] = di(R.onClick);
  return M(/* @__PURE__ */ a.createElement(Ka, {
    component: "Checkbox",
    disabled: E
  }, /* @__PURE__ */ a.createElement("label", {
    className: P,
    style: Object.assign(Object.assign({}, m == null ? void 0 : m.style), d),
    onMouseEnter: s,
    onMouseLeave: v,
    onClick: D
  }, /* @__PURE__ */ a.createElement(ci, Object.assign({}, R, {
    onClick: _,
    prefixCls: I,
    className: $,
    disabled: E,
    ref: N
  })), c != null && /* @__PURE__ */ a.createElement("span", {
    className: `${I}-label`
  }, c))));
}, ao = /* @__PURE__ */ a.forwardRef(hd);
process.env.NODE_ENV !== "production" && (ao.displayName = "Checkbox");
var bd = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const yd = /* @__PURE__ */ a.forwardRef((e, t) => {
  const {
    defaultValue: r,
    children: n,
    options: o = [],
    prefixCls: i,
    className: c,
    rootClassName: l,
    style: d,
    onChange: s
  } = e, v = bd(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: f,
    direction: p
  } = a.useContext(Gt), [u, g] = a.useState(v.value || r || []), [b, m] = a.useState([]);
  a.useEffect(() => {
    "value" in v && g(v.value || []);
  }, [v.value]);
  const h = a.useMemo(() => o.map(($) => typeof $ == "string" || typeof $ == "number" ? {
    label: $,
    value: $
  } : $), [o]), C = ($) => {
    m((D) => D.filter((_) => _ !== $));
  }, S = ($) => {
    m((D) => [].concat(_e(D), [$]));
  }, E = ($) => {
    const D = u.indexOf($.value), _ = _e(u);
    D === -1 ? _.push($.value) : _.splice(D, 1), "value" in v || g(_), s == null || s(_.filter((z) => b.includes(z)).sort((z, B) => {
      const W = h.findIndex((Y) => Y.value === z), X = h.findIndex((Y) => Y.value === B);
      return W - X;
    }));
  }, x = f("checkbox", i), w = `${x}-group`, N = _n(x), [I, y, M] = gi(x, N), T = qn(v, ["value", "disabled"]), O = o.length ? h.map(($) => /* @__PURE__ */ a.createElement(ao, {
    prefixCls: x,
    key: $.value.toString(),
    disabled: "disabled" in $ ? $.disabled : v.disabled,
    value: $.value,
    checked: u.includes($.value),
    onChange: $.onChange,
    className: Q(`${w}-item`, $.className),
    style: $.style,
    title: $.title,
    id: $.id,
    required: $.required
  }, $.label)) : n, R = a.useMemo(() => ({
    toggleOption: E,
    value: u,
    disabled: v.disabled,
    name: v.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: S,
    cancelValue: C
  }), [E, u, v.disabled, v.name, S, C]), P = Q(w, {
    [`${w}-rtl`]: p === "rtl"
  }, c, l, M, N, y);
  return I(/* @__PURE__ */ a.createElement("div", Object.assign({
    className: P,
    style: d
  }, T, {
    ref: t
  }), /* @__PURE__ */ a.createElement(hi.Provider, {
    value: R
  }, O)));
}), yn = ao;
yn.Group = yd;
yn.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && (yn.displayName = "Checkbox");
function Yo(e, t, r, n) {
  var o = No.unstable_batchedUpdates ? function(c) {
    No.unstable_batchedUpdates(r, c);
  } : r;
  return e != null && e.addEventListener && e.addEventListener(t, o, n), {
    remove: function() {
      e != null && e.removeEventListener && e.removeEventListener(t, o, n);
    }
  };
}
var Cd = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" }, Sd = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: Cd
  }));
}, Pr = /* @__PURE__ */ a.forwardRef(Sd);
process.env.NODE_ENV !== "production" && (Pr.displayName = "DoubleLeftOutlined");
var xd = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" }, Ed = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: xd
  }));
}, Dr = /* @__PURE__ */ a.forwardRef(Ed);
process.env.NODE_ENV !== "production" && (Dr.displayName = "DoubleRightOutlined");
var wd = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, $d = [10, 20, 50, 100], bi = function(t) {
  var r = t.pageSizeOptions, n = r === void 0 ? $d : r, o = t.locale, i = t.changeSize, c = t.pageSize, l = t.goButton, d = t.quickGo, s = t.rootPrefixCls, v = t.disabled, f = t.buildOptionText, p = t.showSizeChanger, u = t.sizeChangerRender, g = oe.useState(""), b = ce(g, 2), m = b[0], h = b[1], C = function() {
    return !m || Number.isNaN(m) ? void 0 : Number(m);
  }, S = typeof f == "function" ? f : function(O) {
    return "".concat(O, " ").concat(o.items_per_page);
  }, E = function(R) {
    h(R.target.value);
  }, x = function(R) {
    l || m === "" || (h(""), !(R.relatedTarget && (R.relatedTarget.className.indexOf("".concat(s, "-item-link")) >= 0 || R.relatedTarget.className.indexOf("".concat(s, "-item")) >= 0)) && (d == null || d(C())));
  }, w = function(R) {
    m !== "" && (R.keyCode === Ie.ENTER || R.type === "click") && (h(""), d == null || d(C()));
  }, N = function() {
    return n.some(function(R) {
      return R.toString() === c.toString();
    }) ? n : n.concat([c]).sort(function(R, P) {
      var $ = Number.isNaN(Number(R)) ? 0 : Number(R), D = Number.isNaN(Number(P)) ? 0 : Number(P);
      return $ - D;
    });
  }, I = "".concat(s, "-options");
  if (!p && !d)
    return null;
  var y = null, M = null, T = null;
  return p && u && (y = u({
    disabled: v,
    size: c,
    onSizeChange: function(R) {
      i == null || i(Number(R));
    },
    "aria-label": o.page_size,
    className: "".concat(I, "-size-changer"),
    options: N().map(function(O) {
      return {
        label: S(O),
        value: O
      };
    })
  })), d && (l && (T = typeof l == "boolean" ? /* @__PURE__ */ oe.createElement("button", {
    type: "button",
    onClick: w,
    onKeyUp: w,
    disabled: v,
    className: "".concat(I, "-quick-jumper-button")
  }, o.jump_to_confirm) : /* @__PURE__ */ oe.createElement("span", {
    onClick: w,
    onKeyUp: w
  }, l)), M = /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(I, "-quick-jumper")
  }, o.jump_to, /* @__PURE__ */ oe.createElement("input", {
    disabled: v,
    type: "text",
    value: m,
    onChange: E,
    onKeyUp: w,
    onBlur: x,
    "aria-label": o.page
  }), o.page, T)), /* @__PURE__ */ oe.createElement("li", {
    className: I
  }, y, M);
};
process.env.NODE_ENV !== "production" && (bi.displayName = "Options");
var Nn = function(t) {
  var r = t.rootPrefixCls, n = t.page, o = t.active, i = t.className, c = t.showTitle, l = t.onClick, d = t.onKeyPress, s = t.itemRender, v = "".concat(r, "-item"), f = Q(v, "".concat(v, "-").concat(n), K(K({}, "".concat(v, "-active"), o), "".concat(v, "-disabled"), !n), i), p = function() {
    l(n);
  }, u = function(m) {
    d(m, l, n);
  }, g = s(n, "page", /* @__PURE__ */ oe.createElement("a", {
    rel: "nofollow"
  }, n));
  return g ? /* @__PURE__ */ oe.createElement("li", {
    title: c ? String(n) : null,
    className: f,
    onClick: p,
    onKeyDown: u,
    tabIndex: 0
  }, g) : null;
};
process.env.NODE_ENV !== "production" && (Nn.displayName = "Pager");
var Nd = function(t, r, n) {
  return n;
};
function hr() {
}
function Jo(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function bn(e, t, r) {
  var n = typeof e > "u" ? t : e;
  return Math.floor((r - 1) / n) + 1;
}
var yi = function(t) {
  var r = t.prefixCls, n = r === void 0 ? "rc-pagination" : r, o = t.selectPrefixCls, i = o === void 0 ? "rc-select" : o, c = t.className, l = t.current, d = t.defaultCurrent, s = d === void 0 ? 1 : d, v = t.total, f = v === void 0 ? 0 : v, p = t.pageSize, u = t.defaultPageSize, g = u === void 0 ? 10 : u, b = t.onChange, m = b === void 0 ? hr : b, h = t.hideOnSinglePage, C = t.align, S = t.showPrevNextJumpers, E = S === void 0 ? !0 : S, x = t.showQuickJumper, w = t.showLessItems, N = t.showTitle, I = N === void 0 ? !0 : N, y = t.onShowSizeChange, M = y === void 0 ? hr : y, T = t.locale, O = T === void 0 ? wd : T, R = t.style, P = t.totalBoundaryShowSizeChanger, $ = P === void 0 ? 50 : P, D = t.disabled, _ = t.simple, z = t.showTotal, B = t.showSizeChanger, W = B === void 0 ? f > $ : B, X = t.sizeChangerRender, Y = t.pageSizeOptions, ee = t.itemRender, ie = ee === void 0 ? Nd : ee, ue = t.jumpPrevIcon, xe = t.jumpNextIcon, Z = t.prevIcon, ae = t.nextIcon, me = oe.useRef(null), ye = un(10, {
    value: p,
    defaultValue: g
  }), L = ce(ye, 2), k = L[0], H = L[1], q = un(1, {
    value: l,
    defaultValue: s,
    postState: function(Ye) {
      return Math.max(1, Math.min(Ye, bn(void 0, k, f)));
    }
  }), A = ce(q, 2), j = A[0], fe = A[1], te = oe.useState(j), Ne = ce(te, 2), Ee = Ne[0], V = Ne[1];
  Rn(function() {
    V(j);
  }, [j]);
  var G = m !== hr, Ce = "current" in t;
  process.env.NODE_ENV !== "production" && Qe(Ce ? G : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var be = Math.max(1, j - (w ? 3 : 5)), $e = Math.min(bn(void 0, k, f), j + (w ? 3 : 5));
  function qe(Re, Ye) {
    var ct = Re || /* @__PURE__ */ oe.createElement("button", {
      type: "button",
      "aria-label": Ye,
      className: "".concat(n, "-item-link")
    });
    return typeof Re == "function" && (ct = /* @__PURE__ */ oe.createElement(Re, F({}, t))), ct;
  }
  function Oe(Re) {
    var Ye = Re.target.value, ct = bn(void 0, k, f), Ht;
    return Ye === "" ? Ht = Ye : Number.isNaN(Number(Ye)) ? Ht = Ee : Ye >= ct ? Ht = ct : Ht = Number(Ye), Ht;
  }
  function He(Re) {
    return Jo(Re) && Re !== j && Jo(f) && f > 0;
  }
  var Se = f > k ? x : !1;
  function he(Re) {
    (Re.keyCode === Ie.UP || Re.keyCode === Ie.DOWN) && Re.preventDefault();
  }
  function ne(Re) {
    var Ye = Oe(Re);
    switch (Ye !== Ee && V(Ye), Re.keyCode) {
      case Ie.ENTER:
        Te(Ye);
        break;
      case Ie.UP:
        Te(Ye - 1);
        break;
      case Ie.DOWN:
        Te(Ye + 1);
        break;
    }
  }
  function J(Re) {
    Te(Oe(Re));
  }
  function ke(Re) {
    var Ye = bn(Re, k, f), ct = j > Ye && Ye !== 0 ? Ye : j;
    H(Re), V(ct), M == null || M(j, Re), fe(ct), m == null || m(ct, Re);
  }
  function Te(Re) {
    if (He(Re) && !D) {
      var Ye = bn(void 0, k, f), ct = Re;
      return Re > Ye ? ct = Ye : Re < 1 && (ct = 1), ct !== Ee && V(ct), fe(ct), m == null || m(ct, k), ct;
    }
    return j;
  }
  var ve = j > 1, tt = j < bn(void 0, k, f);
  function De() {
    ve && Te(j - 1);
  }
  function at() {
    tt && Te(j + 1);
  }
  function je() {
    Te(be);
  }
  function dt() {
    Te($e);
  }
  function ut(Re, Ye) {
    if (Re.key === "Enter" || Re.charCode === Ie.ENTER || Re.keyCode === Ie.ENTER) {
      for (var ct = arguments.length, Ht = new Array(ct > 2 ? ct - 2 : 0), on = 2; on < ct; on++)
        Ht[on - 2] = arguments[on];
      Ye.apply(void 0, Ht);
    }
  }
  function xt(Re) {
    ut(Re, De);
  }
  function Ue(Re) {
    ut(Re, at);
  }
  function Tt(Re) {
    ut(Re, je);
  }
  function it(Re) {
    ut(Re, dt);
  }
  function lt(Re) {
    var Ye = ie(Re, "prev", qe(Z, "prev page"));
    return /* @__PURE__ */ oe.isValidElement(Ye) ? /* @__PURE__ */ oe.cloneElement(Ye, {
      disabled: !ve
    }) : Ye;
  }
  function ft(Re) {
    var Ye = ie(Re, "next", qe(ae, "next page"));
    return /* @__PURE__ */ oe.isValidElement(Ye) ? /* @__PURE__ */ oe.cloneElement(Ye, {
      disabled: !tt
    }) : Ye;
  }
  function ot(Re) {
    (Re.type === "click" || Re.keyCode === Ie.ENTER) && Te(Ee);
  }
  var Ae = null, vt = nn(t, {
    aria: !0,
    data: !0
  }), pt = z && /* @__PURE__ */ oe.createElement("li", {
    className: "".concat(n, "-total-text")
  }, z(f, [f === 0 ? 0 : (j - 1) * k + 1, j * k > f ? f : j * k])), le = null, re = bn(void 0, k, f);
  if (h && f <= k)
    return null;
  var se = [], de = {
    rootPrefixCls: n,
    onClick: Te,
    onKeyPress: ut,
    showTitle: I,
    itemRender: ie,
    page: -1
  }, Le = j - 1 > 0 ? j - 1 : 0, Ge = j + 1 < re ? j + 1 : re, mt = x && x.goButton, ge = St(_) === "object" ? _.readOnly : !_, Me = mt, Be = null;
  _ && (mt && (typeof mt == "boolean" ? Me = /* @__PURE__ */ oe.createElement("button", {
    type: "button",
    onClick: ot,
    onKeyUp: ot
  }, O.jump_to_confirm) : Me = /* @__PURE__ */ oe.createElement("span", {
    onClick: ot,
    onKeyUp: ot
  }, mt), Me = /* @__PURE__ */ oe.createElement("li", {
    title: I ? "".concat(O.jump_to).concat(j, "/").concat(re) : null,
    className: "".concat(n, "-simple-pager")
  }, Me)), Be = /* @__PURE__ */ oe.createElement("li", {
    title: I ? "".concat(j, "/").concat(re) : null,
    className: "".concat(n, "-simple-pager")
  }, ge ? Ee : /* @__PURE__ */ oe.createElement("input", {
    type: "text",
    "aria-label": O.jump_to,
    value: Ee,
    disabled: D,
    onKeyDown: he,
    onKeyUp: ne,
    onChange: ne,
    onBlur: J,
    size: 3
  }), /* @__PURE__ */ oe.createElement("span", {
    className: "".concat(n, "-slash")
  }, "/"), re));
  var We = w ? 1 : 2;
  if (re <= 3 + We * 2) {
    re || se.push(/* @__PURE__ */ oe.createElement(Nn, Pe({}, de, {
      key: "noPager",
      page: 1,
      className: "".concat(n, "-item-disabled")
    })));
    for (var nt = 1; nt <= re; nt += 1)
      se.push(/* @__PURE__ */ oe.createElement(Nn, Pe({}, de, {
        key: nt,
        page: nt,
        active: j === nt
      })));
  } else {
    var ht = w ? O.prev_3 : O.prev_5, Et = w ? O.next_3 : O.next_5, rt = ie(be, "jump-prev", qe(ue, "prev page")), wt = ie($e, "jump-next", qe(xe, "next page"));
    E && (Ae = rt ? /* @__PURE__ */ oe.createElement("li", {
      title: I ? ht : null,
      key: "prev",
      onClick: je,
      tabIndex: 0,
      onKeyDown: Tt,
      className: Q("".concat(n, "-jump-prev"), K({}, "".concat(n, "-jump-prev-custom-icon"), !!ue))
    }, rt) : null, le = wt ? /* @__PURE__ */ oe.createElement("li", {
      title: I ? Et : null,
      key: "next",
      onClick: dt,
      tabIndex: 0,
      onKeyDown: it,
      className: Q("".concat(n, "-jump-next"), K({}, "".concat(n, "-jump-next-custom-icon"), !!xe))
    }, wt) : null);
    var we = Math.max(1, j - We), pe = Math.min(j + We, re);
    j - 1 <= We && (pe = 1 + We * 2), re - j <= We && (we = re - We * 2);
    for (var Ke = we; Ke <= pe; Ke += 1)
      se.push(/* @__PURE__ */ oe.createElement(Nn, Pe({}, de, {
        key: Ke,
        page: Ke,
        active: j === Ke
      })));
    if (j - 1 >= We * 2 && j !== 3 && (se[0] = /* @__PURE__ */ oe.cloneElement(se[0], {
      className: Q("".concat(n, "-item-after-jump-prev"), se[0].props.className)
    }), se.unshift(Ae)), re - j >= We * 2 && j !== re - 2) {
      var Ze = se[se.length - 1];
      se[se.length - 1] = /* @__PURE__ */ oe.cloneElement(Ze, {
        className: Q("".concat(n, "-item-before-jump-next"), Ze.props.className)
      }), se.push(le);
    }
    we !== 1 && se.unshift(/* @__PURE__ */ oe.createElement(Nn, Pe({}, de, {
      key: 1,
      page: 1
    }))), pe !== re && se.push(/* @__PURE__ */ oe.createElement(Nn, Pe({}, de, {
      key: re,
      page: re
    })));
  }
  var st = lt(Le);
  if (st) {
    var At = !ve || !re;
    st = /* @__PURE__ */ oe.createElement("li", {
      title: I ? O.prev_page : null,
      onClick: De,
      tabIndex: At ? null : 0,
      onKeyDown: xt,
      className: Q("".concat(n, "-prev"), K({}, "".concat(n, "-disabled"), At)),
      "aria-disabled": At
    }, st);
  }
  var $t = ft(Ge);
  if ($t) {
    var Lt, Yt;
    _ ? (Lt = !tt, Yt = ve ? 0 : null) : (Lt = !tt || !re, Yt = Lt ? null : 0), $t = /* @__PURE__ */ oe.createElement("li", {
      title: I ? O.next_page : null,
      onClick: at,
      tabIndex: Yt,
      onKeyDown: Ue,
      className: Q("".concat(n, "-next"), K({}, "".concat(n, "-disabled"), Lt)),
      "aria-disabled": Lt
    }, $t);
  }
  var Ft = Q(n, c, K(K(K(K(K({}, "".concat(n, "-start"), C === "start"), "".concat(n, "-center"), C === "center"), "".concat(n, "-end"), C === "end"), "".concat(n, "-simple"), _), "".concat(n, "-disabled"), D));
  return /* @__PURE__ */ oe.createElement("ul", Pe({
    className: Ft,
    style: R,
    ref: me
  }, vt), pt, st, _ ? Be : se, $t, /* @__PURE__ */ oe.createElement(bi, {
    locale: O,
    rootPrefixCls: n,
    disabled: D,
    selectPrefixCls: i,
    changeSize: ke,
    pageSize: k,
    pageSizeOptions: Y,
    quickGo: Se ? Te : null,
    goButton: Me,
    showSizeChanger: W,
    sizeChangerRender: X
  }));
};
process.env.NODE_ENV !== "production" && (yi.displayName = "Pagination");
const Od = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        backgroundColor: "transparent",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, Id = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: U(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: U(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: U(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: U(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: U(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.itemSizeSM,
        lineHeight: U(e.itemSizeSM),
        input: Object.assign(Object.assign({}, ss(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, Rd = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.itemSizeSM,
      lineHeight: U(e.itemSizeSM),
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.itemSizeSM,
          lineHeight: U(e.itemSizeSM)
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.itemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        padding: `0 ${U(e.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: e.itemInputBg,
        border: `${U(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${U(e.inputOutlineOffset)} 0 ${U(e.controlOutlineWidth)} ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, Pd = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: U(e.itemSize),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${U(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: U(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, cs(e)), ds(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, us(e)),
          width: e.calc(e.controlHeightLG).mul(1.25).equal(),
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, Dd = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: U(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: e.itemBg,
      border: `${U(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${U(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    }
  };
}, Td = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, zt(e)), {
      display: "flex",
      "&-start": {
        justifyContent: "start"
      },
      "&-center": {
        justifyContent: "center"
      },
      "&-end": {
        justifyContent: "end"
      },
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: U(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), Dd(e)), Pd(e)), Rd(e)), Id(e)), Od(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, Md = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, Il(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, Pn(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: Object.assign({}, Pn(e))
      }
    }
  };
}, Ci = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, is(e)), Si = (e) => tn(e, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginSM,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, ls(e)), _d = pn("Pagination", (e) => {
  const t = Si(e);
  return [Td(t), Md(t)];
}, Ci), kd = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${U(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, Kd = Rl(["Pagination", "bordered"], (e) => {
  const t = Si(e);
  return [kd(t)];
}, Ci);
function Qo(e) {
  return kt(() => typeof e == "boolean" ? [e, {}] : e && typeof e == "object" ? [!0, e] : [void 0, void 0], [e]);
}
var Bd = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const xi = (e) => {
  const {
    align: t,
    prefixCls: r,
    selectPrefixCls: n,
    className: o,
    rootClassName: i,
    style: c,
    size: l,
    locale: d,
    responsive: s,
    showSizeChanger: v,
    selectComponentClass: f,
    pageSizeOptions: p
  } = e, u = Bd(e, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "responsive", "showSizeChanger", "selectComponentClass", "pageSizeOptions"]), {
    xs: g
  } = za(s), [, b] = Mn(), {
    getPrefixCls: m,
    direction: h,
    showSizeChanger: C,
    className: S,
    style: E
  } = rr("pagination"), x = m("pagination", r), [w, N, I] = _d(x), y = or(l), M = y === "small" || !!(g && !y && s), [T] = ar("Pagination", Kl), O = Object.assign(Object.assign({}, T), d), [R, P] = Qo(v), [$, D] = Qo(C), _ = R ?? $, z = P ?? D, B = f || Sn, W = a.useMemo(() => p ? p.map((xe) => Number(xe)) : void 0, [p]), X = (xe) => {
    var Z;
    const {
      disabled: ae,
      size: me,
      onSizeChange: ye,
      "aria-label": L,
      className: k,
      options: H
    } = xe, {
      className: q,
      onChange: A
    } = z || {}, j = (Z = H.find((fe) => String(fe.value) === String(me))) === null || Z === void 0 ? void 0 : Z.value;
    return /* @__PURE__ */ a.createElement(B, Object.assign({
      disabled: ae,
      showSearch: !0,
      popupMatchSelectWidth: !1,
      getPopupContainer: (fe) => fe.parentNode,
      "aria-label": L,
      options: H
    }, z, {
      value: j,
      onChange: (fe, te) => {
        ye == null || ye(fe), A == null || A(fe, te);
      },
      size: M ? "small" : "middle",
      className: Q(k, q)
    }));
  };
  if (process.env.NODE_ENV !== "production") {
    const xe = rn("Pagination");
    process.env.NODE_ENV !== "production" && xe(!f, "usage", "`selectComponentClass` is not official api which will be removed.");
  }
  const Y = a.useMemo(() => {
    const xe = /* @__PURE__ */ a.createElement("span", {
      className: `${x}-item-ellipsis`
    }, "•••"), Z = /* @__PURE__ */ a.createElement("button", {
      className: `${x}-item-link`,
      type: "button",
      tabIndex: -1
    }, h === "rtl" ? /* @__PURE__ */ a.createElement(So, null) : /* @__PURE__ */ a.createElement(xo, null)), ae = /* @__PURE__ */ a.createElement("button", {
      className: `${x}-item-link`,
      type: "button",
      tabIndex: -1
    }, h === "rtl" ? /* @__PURE__ */ a.createElement(xo, null) : /* @__PURE__ */ a.createElement(So, null)), me = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ a.createElement("a", {
        className: `${x}-item-link`
      }, /* @__PURE__ */ a.createElement("div", {
        className: `${x}-item-container`
      }, h === "rtl" ? /* @__PURE__ */ a.createElement(Dr, {
        className: `${x}-item-link-icon`
      }) : /* @__PURE__ */ a.createElement(Pr, {
        className: `${x}-item-link-icon`
      }), xe))
    ), ye = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ a.createElement("a", {
        className: `${x}-item-link`
      }, /* @__PURE__ */ a.createElement("div", {
        className: `${x}-item-container`
      }, h === "rtl" ? /* @__PURE__ */ a.createElement(Pr, {
        className: `${x}-item-link-icon`
      }) : /* @__PURE__ */ a.createElement(Dr, {
        className: `${x}-item-link-icon`
      }), xe))
    );
    return {
      prevIcon: Z,
      nextIcon: ae,
      jumpPrevIcon: me,
      jumpNextIcon: ye
    };
  }, [h, x]), ee = m("select", n), ie = Q({
    [`${x}-${t}`]: !!t,
    [`${x}-mini`]: M,
    [`${x}-rtl`]: h === "rtl",
    [`${x}-bordered`]: b.wireframe
  }, S, o, i, N, I), ue = Object.assign(Object.assign({}, E), c);
  return w(/* @__PURE__ */ a.createElement(a.Fragment, null, b.wireframe && /* @__PURE__ */ a.createElement(Kd, {
    prefixCls: x
  }), /* @__PURE__ */ a.createElement(yi, Object.assign({}, Y, u, {
    style: ue,
    prefixCls: x,
    selectPrefixCls: ee,
    className: ie,
    locale: O,
    pageSizeOptions: W,
    showSizeChanger: _,
    sizeChangerRender: X
  }))));
};
process.env.NODE_ENV !== "production" && (xi.displayName = "Pagination");
const tr = 100, Ei = tr / 5, wi = tr / 2 - Ei / 2, br = wi * 2 * Math.PI, Zo = 50, ea = (e) => {
  const {
    dotClassName: t,
    style: r,
    hasCircleCls: n
  } = e;
  return /* @__PURE__ */ a.createElement("circle", {
    className: Q(`${t}-circle`, {
      [`${t}-circle-bg`]: n
    }),
    r: wi,
    cx: Zo,
    cy: Zo,
    strokeWidth: Ei,
    style: r
  });
}, zd = ({
  percent: e,
  prefixCls: t
}) => {
  const r = `${t}-dot`, n = `${r}-holder`, o = `${n}-hidden`, [i, c] = a.useState(!1);
  Mt(() => {
    e !== 0 && c(!0);
  }, [e !== 0]);
  const l = Math.max(Math.min(e, 100), 0);
  if (!i)
    return null;
  const d = {
    strokeDashoffset: `${br / 4}`,
    strokeDasharray: `${br * l / 100} ${br * (100 - l) / 100}`
  };
  return /* @__PURE__ */ a.createElement("span", {
    className: Q(n, `${r}-progress`, l <= 0 && o)
  }, /* @__PURE__ */ a.createElement("svg", {
    viewBox: `0 0 ${tr} ${tr}`,
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": l
  }, /* @__PURE__ */ a.createElement(ea, {
    dotClassName: r,
    hasCircleCls: !0
  }), /* @__PURE__ */ a.createElement(ea, {
    dotClassName: r,
    style: d
  })));
};
function Ld(e) {
  const {
    prefixCls: t,
    percent: r = 0
  } = e, n = `${t}-dot`, o = `${n}-holder`, i = `${o}-hidden`;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("span", {
    className: Q(o, r > 0 && i)
  }, /* @__PURE__ */ a.createElement("span", {
    className: Q(n, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((c) => /* @__PURE__ */ a.createElement("i", {
    className: `${t}-dot-item`,
    key: c
  })))), /* @__PURE__ */ a.createElement(zd, {
    prefixCls: t,
    percent: r
  }));
}
function Hd(e) {
  const {
    prefixCls: t,
    indicator: r,
    percent: n
  } = e, o = `${t}-dot`;
  return r && /* @__PURE__ */ a.isValidElement(r) ? wr(r, {
    className: Q(r.props.className, o),
    percent: n
  }) : /* @__PURE__ */ a.createElement(Ld, {
    prefixCls: t,
    percent: n
  });
}
const jd = new Yr("antSpinMove", {
  to: {
    opacity: 1
  }
}), Vd = new Yr("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), Ad = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, zt(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: r(r(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: r(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: r(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        inset: 0
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          height: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: jd,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: Vd,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((n) => `${n} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeSM
        }
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal(),
          height: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeLG
        }
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, Fd = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: r
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: r
  };
}, Wd = pn("Spin", (e) => {
  const t = tn(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [Ad(t)];
}, Fd), qd = 200, ta = [[30, 0.05], [70, 0.03], [96, 0.01]];
function Xd(e, t) {
  const [r, n] = a.useState(0), o = a.useRef(null), i = t === "auto";
  return a.useEffect(() => (i && e && (n(0), o.current = setInterval(() => {
    n((c) => {
      const l = 100 - c;
      for (let d = 0; d < ta.length; d += 1) {
        const [s, v] = ta[d];
        if (c <= s)
          return c + l * v;
      }
      return c;
    });
  }, qd)), () => {
    clearInterval(o.current);
  }), [i, e]), i ? r : t;
}
var Ud = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
let $i;
function Gd(e, t) {
  return !!e && !!t && !Number.isNaN(Number(t));
}
const io = (e) => {
  var t;
  const {
    prefixCls: r,
    spinning: n = !0,
    delay: o = 0,
    className: i,
    rootClassName: c,
    size: l = "default",
    tip: d,
    wrapperClassName: s,
    style: v,
    children: f,
    fullscreen: p = !1,
    indicator: u,
    percent: g
  } = e, b = Ud(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: m,
    direction: h,
    className: C,
    style: S,
    indicator: E
  } = rr("spin"), x = m("spin", r), [w, N, I] = Wd(x), [y, M] = a.useState(() => n && !Gd(n, o)), T = Xd(y, g);
  a.useEffect(() => {
    if (n) {
      const z = ld(o, () => {
        M(!0);
      });
      return z(), () => {
        var B;
        (B = z == null ? void 0 : z.cancel) === null || B === void 0 || B.call(z);
      };
    }
    M(!1);
  }, [o, n]);
  const O = a.useMemo(() => typeof f < "u" && !p, [f, p]);
  if (process.env.NODE_ENV !== "production") {
    const z = rn("Spin");
    process.env.NODE_ENV !== "production" && z(!d || O || p, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const R = Q(x, C, {
    [`${x}-sm`]: l === "small",
    [`${x}-lg`]: l === "large",
    [`${x}-spinning`]: y,
    [`${x}-show-text`]: !!d,
    [`${x}-rtl`]: h === "rtl"
  }, i, !p && c, N, I), P = Q(`${x}-container`, {
    [`${x}-blur`]: y
  }), $ = (t = u ?? E) !== null && t !== void 0 ? t : $i, D = Object.assign(Object.assign({}, S), v), _ = /* @__PURE__ */ a.createElement("div", Object.assign({}, b, {
    style: D,
    className: R,
    "aria-live": "polite",
    "aria-busy": y
  }), /* @__PURE__ */ a.createElement(Hd, {
    prefixCls: x,
    indicator: $,
    percent: T
  }), d && (O || p) ? /* @__PURE__ */ a.createElement("div", {
    className: `${x}-text`
  }, d) : null);
  return w(O ? /* @__PURE__ */ a.createElement("div", Object.assign({}, b, {
    className: Q(`${x}-nested-loading`, s, N, I)
  }), y && /* @__PURE__ */ a.createElement("div", {
    key: "loading"
  }, _), /* @__PURE__ */ a.createElement("div", {
    className: P,
    key: "container"
  }, f)) : p ? /* @__PURE__ */ a.createElement("div", {
    className: Q(`${x}-fullscreen`, {
      [`${x}-fullscreen-show`]: y
    }, c, N, I)
  }, _) : _);
};
io.setDefaultIndicator = (e) => {
  $i = e;
};
process.env.NODE_ENV !== "production" && (io.displayName = "Spin");
var Yd = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" }, Jd = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: Yd
  }));
}, Ni = /* @__PURE__ */ a.forwardRef(Jd);
process.env.NODE_ENV !== "production" && (Ni.displayName = "CaretDownFilled");
var Qd = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" }, Zd = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: Qd
  }));
}, Oi = /* @__PURE__ */ a.forwardRef(Zd);
process.env.NODE_ENV !== "production" && (Oi.displayName = "CaretDownOutlined");
var eu = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" }, tu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: eu
  }));
}, Ii = /* @__PURE__ */ a.forwardRef(tu);
process.env.NODE_ENV !== "production" && (Ii.displayName = "CaretUpOutlined");
var nu = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" }, ru = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: nu
  }));
}, lo = /* @__PURE__ */ a.forwardRef(ru);
process.env.NODE_ENV !== "production" && (lo.displayName = "FileOutlined");
var ou = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" }, au = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: ou
  }));
}, Ri = /* @__PURE__ */ a.forwardRef(au);
process.env.NODE_ENV !== "production" && (Ri.displayName = "FilterFilled");
var iu = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" }, lu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: iu
  }));
}, Pi = /* @__PURE__ */ a.forwardRef(lu);
process.env.NODE_ENV !== "production" && (Pi.displayName = "FolderOpenOutlined");
var su = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" }, cu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: su
  }));
}, Di = /* @__PURE__ */ a.forwardRef(cu);
process.env.NODE_ENV !== "production" && (Di.displayName = "FolderOutlined");
var du = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" }, uu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: du
  }));
}, Ti = /* @__PURE__ */ a.forwardRef(uu);
process.env.NODE_ENV !== "production" && (Ti.displayName = "HolderOutlined");
var fu = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" }, vu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: fu
  }));
}, Mi = /* @__PURE__ */ a.forwardRef(vu);
process.env.NODE_ENV !== "production" && (Mi.displayName = "MinusSquareOutlined");
var pu = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" }, mu = function(t, r) {
  return /* @__PURE__ */ a.createElement(qt, Pe({}, t, {
    ref: r,
    icon: pu
  }));
}, _i = /* @__PURE__ */ a.forwardRef(mu);
process.env.NODE_ENV !== "production" && (_i.displayName = "PlusSquareOutlined");
var Ut = {}, Gn = "rc-table-internal-hook";
function so(e) {
  var t = /* @__PURE__ */ a.createContext(void 0), r = function(o) {
    var i = o.value, c = o.children, l = a.useRef(i);
    l.current = i;
    var d = a.useState(function() {
      return {
        getValue: function() {
          return l.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), s = ce(d, 1), v = s[0];
    return Mt(function() {
      zl(function() {
        v.listeners.forEach(function(f) {
          f(i);
        });
      });
    }, [i]), /* @__PURE__ */ a.createElement(t.Provider, {
      value: v
    }, c);
  };
  return {
    Context: t,
    Provider: r,
    defaultValue: e
  };
}
function Dt(e, t) {
  var r = en(typeof t == "function" ? t : function(f) {
    if (t === void 0)
      return f;
    if (!Array.isArray(t))
      return f[t];
    var p = {};
    return t.forEach(function(u) {
      p[u] = f[u];
    }), p;
  }), n = a.useContext(e == null ? void 0 : e.Context), o = n || {}, i = o.listeners, c = o.getValue, l = a.useRef();
  l.current = r(n ? c() : e == null ? void 0 : e.defaultValue);
  var d = a.useState({}), s = ce(d, 2), v = s[1];
  return Mt(function() {
    if (!n)
      return;
    function f(p) {
      var u = r(p);
      Vn(l.current, u, !0) || v({});
    }
    return i.add(f), function() {
      i.delete(f);
    };
  }, [n]), l.current;
}
function gu() {
  var e = /* @__PURE__ */ a.createContext(null);
  function t() {
    return a.useContext(e);
  }
  function r(o, i) {
    var c = wo(o), l = function(s, v) {
      var f = c ? {
        ref: v
      } : {}, p = a.useRef(0), u = a.useRef(s), g = t();
      return g !== null ? /* @__PURE__ */ a.createElement(o, Pe({}, s, f)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!i || i(u.current, s)) && (p.current += 1), u.current = s, /* @__PURE__ */ a.createElement(e.Provider, {
          value: p.current
        }, /* @__PURE__ */ a.createElement(o, Pe({}, s, f))))
      );
    };
    return process.env.NODE_ENV !== "production" && (l.displayName = "ImmutableRoot(".concat(o.displayName || o.name, ")")), c ? /* @__PURE__ */ a.forwardRef(l) : l;
  }
  function n(o, i) {
    var c = wo(o), l = function(s, v) {
      var f = c ? {
        ref: v
      } : {};
      return t(), /* @__PURE__ */ a.createElement(o, Pe({}, s, f));
    };
    return process.env.NODE_ENV !== "production" && (l.displayName = "ImmutableResponse(".concat(o.displayName || o.name, ")")), c ? /* @__PURE__ */ a.memo(/* @__PURE__ */ a.forwardRef(l), i) : /* @__PURE__ */ a.memo(l, i);
  }
  return {
    makeImmutable: r,
    responseImmutable: n,
    useImmutableMark: t
  };
}
var co = gu(), ki = co.makeImmutable, kn = co.responseImmutable, hu = co.useImmutableMark, _t = so();
function Ki(e, t) {
  var r = a.useRef(0);
  r.current += 1;
  var n = a.useRef(e), o = [];
  Object.keys(e || {}).map(function(c) {
    var l;
    (e == null ? void 0 : e[c]) !== ((l = n.current) === null || l === void 0 ? void 0 : l[c]) && o.push(c);
  }), n.current = e;
  var i = a.useRef([]);
  return o.length && (i.current = o), a.useDebugValue(r.current), a.useDebugValue(i.current.join(", ")), t && console.log("".concat(t, ":"), r.current, i.current), r.current;
}
const fn = process.env.NODE_ENV !== "production" ? Ki : function() {
};
var bu = /* @__PURE__ */ a.memo(function() {
  var e = Ki();
  return /* @__PURE__ */ a.createElement("h1", null, "Render Times: ", e);
});
process.env.NODE_ENV !== "production" && (bu.displayName = "RenderBlock");
var Bi = /* @__PURE__ */ a.createContext({
  renderWithProps: !1
}), yu = "RC_TABLE_KEY";
function Cu(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function sr(e) {
  var t = [], r = {};
  return e.forEach(function(n) {
    for (var o = n || {}, i = o.key, c = o.dataIndex, l = i || Cu(c).join("-") || yu; r[l]; )
      l = "".concat(l, "_next");
    r[l] = !0, t.push(l);
  }), t;
}
function Tr(e) {
  return e != null;
}
function Su(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function xu(e) {
  return e && St(e) === "object" && !Array.isArray(e) && !/* @__PURE__ */ a.isValidElement(e);
}
function Eu(e, t, r, n, o, i) {
  var c = a.useContext(Bi), l = hu(), d = Wr(function() {
    if (Tr(n))
      return [n];
    var s = t == null || t === "" ? [] : Array.isArray(t) ? t : [t], v = Ur(e, s), f = v, p = void 0;
    if (o) {
      var u = o(v, e, r);
      xu(u) ? (process.env.NODE_ENV !== "production" && Qe(!1, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead."), f = u.children, p = u.props, c.renderWithProps = !0) : f = u;
    }
    return [f, p];
  }, [
    // Force update deps
    l,
    // Normal deps
    e,
    n,
    t,
    o,
    r
  ], function(s, v) {
    if (i) {
      var f = ce(s, 2), p = f[1], u = ce(v, 2), g = u[1];
      return i(g, p);
    }
    return c.renderWithProps ? !0 : !Vn(s, v, !0);
  });
  return d;
}
function wu(e, t, r, n) {
  var o = e + t - 1;
  return e <= n && o >= r;
}
function $u(e, t) {
  return Dt(_t, function(r) {
    var n = wu(e, t || 1, r.hoverStartRow, r.hoverEndRow);
    return [n, r.onHover];
  });
}
var Nu = function(t) {
  var r = t.ellipsis, n = t.rowType, o = t.children, i, c = r === !0 ? {
    showTitle: !0
  } : r;
  return c && (c.showTitle || n === "header") && (typeof o == "string" || typeof o == "number" ? i = o.toString() : /* @__PURE__ */ a.isValidElement(o) && typeof o.props.children == "string" && (i = o.props.children)), i;
};
function Ou(e) {
  var t, r, n, o, i, c, l, d;
  process.env.NODE_ENV !== "production" && fn(e);
  var s = e.component, v = e.children, f = e.ellipsis, p = e.scope, u = e.prefixCls, g = e.className, b = e.align, m = e.record, h = e.render, C = e.dataIndex, S = e.renderIndex, E = e.shouldCellUpdate, x = e.index, w = e.rowType, N = e.colSpan, I = e.rowSpan, y = e.fixLeft, M = e.fixRight, T = e.firstFixLeft, O = e.lastFixLeft, R = e.firstFixRight, P = e.lastFixRight, $ = e.appendNode, D = e.additionalProps, _ = D === void 0 ? {} : D, z = e.isSticky, B = "".concat(u, "-cell"), W = Dt(_t, ["supportSticky", "allColumnsFixedLeft", "rowHoverable"]), X = W.supportSticky, Y = W.allColumnsFixedLeft, ee = W.rowHoverable, ie = Eu(m, C, S, v, h, E), ue = ce(ie, 2), xe = ue[0], Z = ue[1], ae = {}, me = typeof y == "number" && X, ye = typeof M == "number" && X;
  me && (ae.position = "sticky", ae.left = y), ye && (ae.position = "sticky", ae.right = M);
  var L = (t = (r = (n = Z == null ? void 0 : Z.colSpan) !== null && n !== void 0 ? n : _.colSpan) !== null && r !== void 0 ? r : N) !== null && t !== void 0 ? t : 1, k = (o = (i = (c = Z == null ? void 0 : Z.rowSpan) !== null && c !== void 0 ? c : _.rowSpan) !== null && i !== void 0 ? i : I) !== null && o !== void 0 ? o : 1, H = $u(x, k), q = ce(H, 2), A = q[0], j = q[1], fe = en(function(be) {
    var $e;
    m && j(x, x + k - 1), _ == null || ($e = _.onMouseEnter) === null || $e === void 0 || $e.call(_, be);
  }), te = en(function(be) {
    var $e;
    m && j(-1, -1), _ == null || ($e = _.onMouseLeave) === null || $e === void 0 || $e.call(_, be);
  });
  if (L === 0 || k === 0)
    return null;
  var Ne = (l = _.title) !== null && l !== void 0 ? l : Nu({
    rowType: w,
    ellipsis: f,
    children: xe
  }), Ee = Q(B, g, (d = {}, K(K(K(K(K(K(K(K(K(K(d, "".concat(B, "-fix-left"), me && X), "".concat(B, "-fix-left-first"), T && X), "".concat(B, "-fix-left-last"), O && X), "".concat(B, "-fix-left-all"), O && Y && X), "".concat(B, "-fix-right"), ye && X), "".concat(B, "-fix-right-first"), R && X), "".concat(B, "-fix-right-last"), P && X), "".concat(B, "-ellipsis"), f), "".concat(B, "-with-append"), $), "".concat(B, "-fix-sticky"), (me || ye) && z && X), K(d, "".concat(B, "-row-hover"), !Z && A)), _.className, Z == null ? void 0 : Z.className), V = {};
  b && (V.textAlign = b);
  var G = F(F(F(F({}, Z == null ? void 0 : Z.style), ae), V), _.style), Ce = xe;
  return St(Ce) === "object" && !Array.isArray(Ce) && !/* @__PURE__ */ a.isValidElement(Ce) && (Ce = null), f && (O || R) && (Ce = /* @__PURE__ */ a.createElement("span", {
    className: "".concat(B, "-content")
  }, Ce)), /* @__PURE__ */ a.createElement(s, Pe({}, Z, _, {
    className: Ee,
    style: G,
    title: Ne,
    scope: p,
    onMouseEnter: ee ? fe : void 0,
    onMouseLeave: ee ? te : void 0,
    colSpan: L !== 1 ? L : null,
    rowSpan: k !== 1 ? k : null
  }), $, Ce);
}
const Kn = /* @__PURE__ */ a.memo(Ou);
function uo(e, t, r, n, o) {
  var i = r[e] || {}, c = r[t] || {}, l, d;
  i.fixed === "left" ? l = n.left[o === "rtl" ? t : e] : c.fixed === "right" && (d = n.right[o === "rtl" ? e : t]);
  var s = !1, v = !1, f = !1, p = !1, u = r[t + 1], g = r[e - 1], b = u && !u.fixed || g && !g.fixed || r.every(function(E) {
    return E.fixed === "left";
  });
  if (o === "rtl") {
    if (l !== void 0) {
      var m = g && g.fixed === "left";
      p = !m && b;
    } else if (d !== void 0) {
      var h = u && u.fixed === "right";
      f = !h && b;
    }
  } else if (l !== void 0) {
    var C = u && u.fixed === "left";
    s = !C && b;
  } else if (d !== void 0) {
    var S = g && g.fixed === "right";
    v = !S && b;
  }
  return {
    fixLeft: l,
    fixRight: d,
    lastFixLeft: s,
    firstFixRight: v,
    lastFixRight: f,
    firstFixLeft: p,
    isSticky: n.isSticky
  };
}
var zi = /* @__PURE__ */ a.createContext({});
function Iu(e) {
  var t = e.className, r = e.index, n = e.children, o = e.colSpan, i = o === void 0 ? 1 : o, c = e.rowSpan, l = e.align, d = Dt(_t, ["prefixCls", "direction"]), s = d.prefixCls, v = d.direction, f = a.useContext(zi), p = f.scrollColumnIndex, u = f.stickyOffsets, g = f.flattenColumns, b = r + i - 1, m = b + 1 === p ? i + 1 : i, h = uo(r, r + m - 1, g, u, v);
  return /* @__PURE__ */ a.createElement(Kn, Pe({
    className: t,
    index: r,
    component: "td",
    prefixCls: s,
    record: null,
    dataIndex: null,
    align: l,
    colSpan: m,
    rowSpan: c,
    render: function() {
      return n;
    }
  }, h));
}
var Ru = ["children"];
function Pu(e) {
  var t = e.children, r = yt(e, Ru);
  return /* @__PURE__ */ a.createElement("tr", r, t);
}
function cr(e) {
  var t = e.children;
  return t;
}
cr.Row = Pu;
cr.Cell = Iu;
function Du(e) {
  process.env.NODE_ENV !== "production" && fn(e);
  var t = e.children, r = e.stickyOffsets, n = e.flattenColumns, o = Dt(_t, "prefixCls"), i = n.length - 1, c = n[i], l = a.useMemo(function() {
    return {
      stickyOffsets: r,
      flattenColumns: n,
      scrollColumnIndex: c != null && c.scrollbar ? i : null
    };
  }, [c, n, i, r]);
  return /* @__PURE__ */ a.createElement(zi.Provider, {
    value: l
  }, /* @__PURE__ */ a.createElement("tfoot", {
    className: "".concat(o, "-summary")
  }, t));
}
const Jn = kn(Du);
var Li = cr;
function Tu(e) {
  return null;
}
function Mu(e) {
  return null;
}
function Hi(e, t, r, n, o, i, c) {
  e.push({
    record: t,
    indent: r,
    index: c
  });
  var l = i(t), d = o == null ? void 0 : o.has(l);
  if (t && Array.isArray(t[n]) && d)
    for (var s = 0; s < t[n].length; s += 1)
      Hi(e, t[n][s], r + 1, n, o, i, s);
}
function ji(e, t, r, n) {
  var o = a.useMemo(function() {
    if (r != null && r.size) {
      for (var i = [], c = 0; c < (e == null ? void 0 : e.length); c += 1) {
        var l = e[c];
        Hi(i, l, 0, t, r, n, c);
      }
      return i;
    }
    return e == null ? void 0 : e.map(function(d, s) {
      return {
        record: d,
        indent: 0,
        index: s
      };
    });
  }, [e, t, r, n]);
  return o;
}
function Vi(e, t, r, n) {
  var o = Dt(_t, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), i = o.flattenColumns, c = o.expandableType, l = o.expandedKeys, d = o.childrenColumnName, s = o.onTriggerExpand, v = o.rowExpandable, f = o.onRow, p = o.expandRowByClick, u = o.rowClassName, g = c === "nest", b = c === "row" && (!v || v(e)), m = b || g, h = l && l.has(t), C = d && e && e[d], S = en(s), E = f == null ? void 0 : f(e, r), x = E == null ? void 0 : E.onClick, w = function(M) {
    p && m && s(e, M);
    for (var T = arguments.length, O = new Array(T > 1 ? T - 1 : 0), R = 1; R < T; R++)
      O[R - 1] = arguments[R];
    x == null || x.apply(void 0, [M].concat(O));
  }, N;
  typeof u == "string" ? N = u : typeof u == "function" && (N = u(e, r, n));
  var I = sr(i);
  return F(F({}, o), {}, {
    columnsKey: I,
    nestExpandable: g,
    expanded: h,
    hasNestChildren: C,
    record: e,
    onTriggerExpand: S,
    rowSupportExpand: b,
    expandable: m,
    rowProps: F(F({}, E), {}, {
      className: Q(N, E == null ? void 0 : E.className),
      onClick: w
    })
  });
}
function Ai(e) {
  process.env.NODE_ENV !== "production" && fn(e);
  var t = e.prefixCls, r = e.children, n = e.component, o = e.cellComponent, i = e.className, c = e.expanded, l = e.colSpan, d = e.isEmpty, s = Dt(_t, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), v = s.scrollbarSize, f = s.fixHeader, p = s.fixColumn, u = s.componentWidth, g = s.horizonScroll, b = r;
  return (d ? g && u : p) && (b = /* @__PURE__ */ a.createElement("div", {
    style: {
      width: u - (f && !d ? v : 0),
      position: "sticky",
      left: 0,
      overflow: "hidden"
    },
    className: "".concat(t, "-expanded-row-fixed")
  }, b)), /* @__PURE__ */ a.createElement(n, {
    className: i,
    style: {
      display: c ? null : "none"
    }
  }, /* @__PURE__ */ a.createElement(Kn, {
    component: o,
    prefixCls: t,
    colSpan: l
  }, b));
}
function _u(e) {
  var t = e.prefixCls, r = e.record, n = e.onExpand, o = e.expanded, i = e.expandable, c = "".concat(t, "-row-expand-icon");
  if (!i)
    return /* @__PURE__ */ a.createElement("span", {
      className: Q(c, "".concat(t, "-row-spaced"))
    });
  var l = function(s) {
    n(r, s), s.stopPropagation();
  };
  return /* @__PURE__ */ a.createElement("span", {
    className: Q(c, K(K({}, "".concat(t, "-row-expanded"), o), "".concat(t, "-row-collapsed"), !o)),
    onClick: l
  });
}
function ku(e, t, r) {
  var n = [];
  function o(i) {
    (i || []).forEach(function(c, l) {
      n.push(t(c, l)), o(c[r]);
    });
  }
  return o(e), n;
}
function Fi(e, t, r, n) {
  return typeof e == "string" ? e : typeof e == "function" ? e(t, r, n) : "";
}
function Wi(e, t, r, n, o) {
  var i = e.record, c = e.prefixCls, l = e.columnsKey, d = e.fixedInfoList, s = e.expandIconColumnIndex, v = e.nestExpandable, f = e.indentSize, p = e.expandIcon, u = e.expanded, g = e.hasNestChildren, b = e.onTriggerExpand, m = l[r], h = d[r], C;
  r === (s || 0) && v && (C = /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("span", {
    style: {
      paddingLeft: "".concat(f * n, "px")
    },
    className: "".concat(c, "-row-indent indent-level-").concat(n)
  }), p({
    prefixCls: c,
    expanded: u,
    expandable: g,
    record: i,
    onExpand: b
  })));
  var S;
  return t.onCell && (S = t.onCell(i, o)), {
    key: m,
    fixedInfo: h,
    appendCellNode: C,
    additionalCellProps: S || {}
  };
}
function qi(e) {
  process.env.NODE_ENV !== "production" && fn(e);
  var t = e.className, r = e.style, n = e.record, o = e.index, i = e.renderIndex, c = e.rowKey, l = e.indent, d = l === void 0 ? 0 : l, s = e.rowComponent, v = e.cellComponent, f = e.scopeCellComponent, p = Vi(n, c, o, d), u = p.prefixCls, g = p.flattenColumns, b = p.expandedRowClassName, m = p.expandedRowRender, h = p.rowProps, C = p.expanded, S = p.rowSupportExpand, E = a.useRef(!1);
  E.current || (E.current = C), process.env.NODE_ENV !== "production" && fn(e);
  var x = Fi(b, n, o, d), w = /* @__PURE__ */ a.createElement(s, Pe({}, h, {
    "data-row-key": c,
    className: Q(t, "".concat(u, "-row"), "".concat(u, "-row-level-").concat(d), h == null ? void 0 : h.className, K({}, x, d >= 1)),
    style: F(F({}, r), h == null ? void 0 : h.style)
  }), g.map(function(y, M) {
    var T = y.render, O = y.dataIndex, R = y.className, P = Wi(p, y, M, d, o), $ = P.key, D = P.fixedInfo, _ = P.appendCellNode, z = P.additionalCellProps;
    return /* @__PURE__ */ a.createElement(Kn, Pe({
      className: R,
      ellipsis: y.ellipsis,
      align: y.align,
      scope: y.rowScope,
      component: y.rowScope ? f : v,
      prefixCls: u,
      key: $,
      record: n,
      index: o,
      renderIndex: i,
      dataIndex: O,
      render: T,
      shouldCellUpdate: y.shouldCellUpdate
    }, D, {
      appendNode: _,
      additionalProps: z
    }));
  })), N;
  if (S && (E.current || C)) {
    var I = m(n, o, d + 1, C);
    N = /* @__PURE__ */ a.createElement(Ai, {
      expanded: C,
      className: Q("".concat(u, "-expanded-row"), "".concat(u, "-expanded-row-level-").concat(d + 1), x),
      prefixCls: u,
      component: s,
      cellComponent: v,
      colSpan: g.length,
      isEmpty: !1
    }, I);
  }
  return /* @__PURE__ */ a.createElement(a.Fragment, null, w, N);
}
process.env.NODE_ENV !== "production" && (qi.displayName = "BodyRow");
const Ku = kn(qi);
function Bu(e) {
  var t = e.columnKey, r = e.onColumnResize, n = a.useRef();
  return Mt(function() {
    n.current && r(t, n.current.offsetWidth);
  }, []), /* @__PURE__ */ a.createElement(Wn, {
    data: t
  }, /* @__PURE__ */ a.createElement("td", {
    ref: n,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ a.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function zu(e) {
  var t = e.prefixCls, r = e.columnsKey, n = e.onColumnResize, o = a.useRef(null);
  return /* @__PURE__ */ a.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(t, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    },
    ref: o
  }, /* @__PURE__ */ a.createElement(Wn.Collection, {
    onBatchResize: function(c) {
      Vl(o.current) && c.forEach(function(l) {
        var d = l.data, s = l.size;
        n(d, s.offsetWidth);
      });
    }
  }, r.map(function(i) {
    return /* @__PURE__ */ a.createElement(Bu, {
      key: i,
      columnKey: i,
      onColumnResize: n
    });
  })));
}
function Xi(e) {
  process.env.NODE_ENV !== "production" && fn(e);
  var t = e.data, r = e.measureColumnWidth, n = Dt(_t, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode"]), o = n.prefixCls, i = n.getComponent, c = n.onColumnResize, l = n.flattenColumns, d = n.getRowKey, s = n.expandedKeys, v = n.childrenColumnName, f = n.emptyNode, p = ji(t, v, s, d), u = a.useRef({
    renderWithProps: !1
  }), g = i(["body", "wrapper"], "tbody"), b = i(["body", "row"], "tr"), m = i(["body", "cell"], "td"), h = i(["body", "cell"], "th"), C;
  t.length ? C = p.map(function(E, x) {
    var w = E.record, N = E.indent, I = E.index, y = d(w, x);
    return /* @__PURE__ */ a.createElement(Ku, {
      key: y,
      rowKey: y,
      record: w,
      index: x,
      renderIndex: I,
      rowComponent: b,
      cellComponent: m,
      scopeCellComponent: h,
      indent: N
    });
  }) : C = /* @__PURE__ */ a.createElement(Ai, {
    expanded: !0,
    className: "".concat(o, "-placeholder"),
    prefixCls: o,
    component: b,
    cellComponent: m,
    colSpan: l.length,
    isEmpty: !0
  }, f);
  var S = sr(l);
  return /* @__PURE__ */ a.createElement(Bi.Provider, {
    value: u.current
  }, /* @__PURE__ */ a.createElement(g, {
    className: "".concat(o, "-tbody")
  }, r && /* @__PURE__ */ a.createElement(zu, {
    prefixCls: o,
    columnsKey: S,
    onColumnResize: c
  }), C));
}
process.env.NODE_ENV !== "production" && (Xi.displayName = "Body");
const Lu = kn(Xi);
var Hu = ["expandable"], jn = "RC_TABLE_INTERNAL_COL_DEFINE";
function ju(e) {
  var t = e.expandable, r = yt(e, Hu), n;
  return "expandable" in e ? n = F(F({}, r), t) : (process.env.NODE_ENV !== "production" && ["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(o) {
    return o in e;
  }) && Qe(!1, "expanded related props have been moved into `expandable`."), n = r), n.showExpandColumn === !1 && (n.expandIconColumnIndex = -1), n;
}
var Vu = ["columnType"];
function Ui(e) {
  for (var t = e.colWidths, r = e.columns, n = e.columCount, o = Dt(_t, ["tableLayout"]), i = o.tableLayout, c = [], l = n || r.length, d = !1, s = l - 1; s >= 0; s -= 1) {
    var v = t[s], f = r && r[s], p = void 0, u = void 0;
    if (f && (p = f[jn], i === "auto" && (u = f.minWidth)), v || u || p || d) {
      var g = p || {};
      g.columnType;
      var b = yt(g, Vu);
      c.unshift(/* @__PURE__ */ a.createElement("col", Pe({
        key: s,
        style: {
          width: v,
          minWidth: u
        }
      }, b))), d = !0;
    }
  }
  return /* @__PURE__ */ a.createElement("colgroup", null, c);
}
var Au = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function Fu(e, t) {
  return kt(function() {
    for (var r = [], n = 0; n < t; n += 1) {
      var o = e[n];
      if (o !== void 0)
        r[n] = o;
      else
        return null;
    }
    return r;
  }, [e.join("_"), t]);
}
var Gi = /* @__PURE__ */ a.forwardRef(function(e, t) {
  process.env.NODE_ENV !== "production" && fn(e);
  var r = e.className, n = e.noData, o = e.columns, i = e.flattenColumns, c = e.colWidths, l = e.columCount, d = e.stickyOffsets, s = e.direction, v = e.fixHeader, f = e.stickyTopOffset, p = e.stickyBottomOffset, u = e.stickyClassName, g = e.onScroll, b = e.maxContentScroll, m = e.children, h = yt(e, Au), C = Dt(_t, ["prefixCls", "scrollbarSize", "isSticky", "getComponent"]), S = C.prefixCls, E = C.scrollbarSize, x = C.isSticky, w = C.getComponent, N = w(["header", "table"], "table"), I = x && !v ? 0 : E, y = a.useRef(null), M = a.useCallback(function(z) {
    $o(t, z), $o(y, z);
  }, []);
  a.useEffect(function() {
    var z;
    function B(W) {
      var X = W, Y = X.currentTarget, ee = X.deltaX;
      ee && (g({
        currentTarget: Y,
        scrollLeft: Y.scrollLeft + ee
      }), W.preventDefault());
    }
    return (z = y.current) === null || z === void 0 || z.addEventListener("wheel", B, {
      passive: !1
    }), function() {
      var W;
      (W = y.current) === null || W === void 0 || W.removeEventListener("wheel", B);
    };
  }, []);
  var T = a.useMemo(function() {
    return i.every(function(z) {
      return z.width;
    });
  }, [i]), O = i[i.length - 1], R = {
    fixed: O ? O.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(S, "-cell-scrollbar")
      };
    }
  }, P = kt(function() {
    return I ? [].concat(_e(o), [R]) : o;
  }, [I, o]), $ = kt(function() {
    return I ? [].concat(_e(i), [R]) : i;
  }, [I, i]), D = kt(function() {
    var z = d.right, B = d.left;
    return F(F({}, d), {}, {
      left: s === "rtl" ? [].concat(_e(B.map(function(W) {
        return W + I;
      })), [0]) : B,
      right: s === "rtl" ? z : [].concat(_e(z.map(function(W) {
        return W + I;
      })), [0]),
      isSticky: x
    });
  }, [I, d, x]), _ = Fu(c, l);
  return /* @__PURE__ */ a.createElement("div", {
    style: F({
      overflow: "hidden"
    }, x ? {
      top: f,
      bottom: p
    } : {}),
    ref: M,
    className: Q(r, K({}, u, !!u))
  }, /* @__PURE__ */ a.createElement(N, {
    style: {
      tableLayout: "fixed",
      visibility: n || _ ? null : "hidden"
    }
  }, (!n || !b || T) && /* @__PURE__ */ a.createElement(Ui, {
    colWidths: _ ? [].concat(_e(_), [I]) : [],
    columCount: l + 1,
    columns: $
  }), m(F(F({}, h), {}, {
    stickyOffsets: D,
    columns: P,
    flattenColumns: $
  }))));
});
process.env.NODE_ENV !== "production" && (Gi.displayName = "FixedHolder");
const na = /* @__PURE__ */ a.memo(Gi);
var Yi = function(t) {
  var r = t.cells, n = t.stickyOffsets, o = t.flattenColumns, i = t.rowComponent, c = t.cellComponent, l = t.onHeaderRow, d = t.index, s = Dt(_t, ["prefixCls", "direction"]), v = s.prefixCls, f = s.direction, p;
  l && (p = l(r.map(function(g) {
    return g.column;
  }), d));
  var u = sr(r.map(function(g) {
    return g.column;
  }));
  return /* @__PURE__ */ a.createElement(i, p, r.map(function(g, b) {
    var m = g.column, h = uo(g.colStart, g.colEnd, o, n, f), C;
    return m && m.onHeaderCell && (C = g.column.onHeaderCell(m)), /* @__PURE__ */ a.createElement(Kn, Pe({}, g, {
      scope: m.title ? g.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: m.ellipsis,
      align: m.align,
      component: c,
      prefixCls: v,
      key: u[b]
    }, h, {
      additionalProps: C,
      rowType: "header"
    }));
  }));
};
process.env.NODE_ENV !== "production" && (Yi.displayName = "HeaderRow");
function Wu(e) {
  var t = [];
  function r(c, l) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    t[d] = t[d] || [];
    var s = l, v = c.filter(Boolean).map(function(f) {
      var p = {
        key: f.key,
        className: f.className || "",
        children: f.title,
        column: f,
        colStart: s
      }, u = 1, g = f.children;
      return g && g.length > 0 && (u = r(g, s, d + 1).reduce(function(b, m) {
        return b + m;
      }, 0), p.hasSubColumns = !0), "colSpan" in f && (u = f.colSpan), "rowSpan" in f && (p.rowSpan = f.rowSpan), p.colSpan = u, p.colEnd = p.colStart + u - 1, t[d].push(p), s += u, u;
    });
    return v;
  }
  r(e, 0);
  for (var n = t.length, o = function(l) {
    t[l].forEach(function(d) {
      !("rowSpan" in d) && !d.hasSubColumns && (d.rowSpan = n - l);
    });
  }, i = 0; i < n; i += 1)
    o(i);
  return t;
}
var qu = function(t) {
  process.env.NODE_ENV !== "production" && fn(t);
  var r = t.stickyOffsets, n = t.columns, o = t.flattenColumns, i = t.onHeaderRow, c = Dt(_t, ["prefixCls", "getComponent"]), l = c.prefixCls, d = c.getComponent, s = a.useMemo(function() {
    return Wu(n);
  }, [n]), v = d(["header", "wrapper"], "thead"), f = d(["header", "row"], "tr"), p = d(["header", "cell"], "th");
  return /* @__PURE__ */ a.createElement(v, {
    className: "".concat(l, "-thead")
  }, s.map(function(u, g) {
    var b = /* @__PURE__ */ a.createElement(Yi, {
      key: g,
      flattenColumns: o,
      cells: u,
      stickyOffsets: r,
      rowComponent: f,
      cellComponent: p,
      onHeaderRow: i,
      index: g
    });
    return b;
  }));
};
const ra = kn(qu);
function oa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof t == "number" ? t : t.endsWith("%") ? e * parseFloat(t) / 100 : null;
}
function Xu(e, t, r) {
  return a.useMemo(function() {
    if (t && t > 0) {
      var n = 0, o = 0;
      e.forEach(function(p) {
        var u = oa(t, p.width);
        u ? n += u : o += 1;
      });
      var i = Math.max(t, r), c = Math.max(i - n, o), l = o, d = c / o, s = 0, v = e.map(function(p) {
        var u = F({}, p), g = oa(t, u.width);
        if (g)
          u.width = g;
        else {
          var b = Math.floor(d);
          u.width = l === 1 ? c : b, c -= b, l -= 1;
        }
        return s += u.width, u;
      });
      if (s < i) {
        var f = i / s;
        c = i, v.forEach(function(p, u) {
          var g = Math.floor(p.width * f);
          p.width = u === v.length - 1 ? c : g, c -= g;
        });
      }
      return [v, Math.max(s, i)];
    }
    return [e, t];
  }, [e, t, r]);
}
var Uu = ["children"], Gu = ["fixed"];
function fo(e) {
  return An(e).filter(function(t) {
    return /* @__PURE__ */ a.isValidElement(t);
  }).map(function(t) {
    var r = t.key, n = t.props, o = n.children, i = yt(n, Uu), c = F({
      key: r
    }, i);
    return o && (c.children = fo(o)), c;
  });
}
function Ji(e) {
  return e.filter(function(t) {
    return t && St(t) === "object" && !t.hidden;
  }).map(function(t) {
    var r = t.children;
    return r && r.length > 0 ? F(F({}, t), {}, {
      children: Ji(r)
    }) : t;
  });
}
function Mr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return e.filter(function(r) {
    return r && St(r) === "object";
  }).reduce(function(r, n, o) {
    var i = n.fixed, c = i === !0 ? "left" : i, l = "".concat(t, "-").concat(o), d = n.children;
    return d && d.length > 0 ? [].concat(_e(r), _e(Mr(d, l).map(function(s) {
      return F({
        fixed: c
      }, s);
    }))) : [].concat(_e(r), [F(F({
      key: l
    }, n), {}, {
      fixed: c
    })]);
  }, []);
}
function Yu(e) {
  return e.map(function(t) {
    var r = t.fixed, n = yt(t, Gu), o = r;
    return r === "left" ? o = "right" : r === "right" && (o = "left"), F({
      fixed: o
    }, n);
  });
}
function Ju(e, t) {
  var r = e.prefixCls, n = e.columns, o = e.children, i = e.expandable, c = e.expandedKeys, l = e.columnTitle, d = e.getRowKey, s = e.onTriggerExpand, v = e.expandIcon, f = e.rowExpandable, p = e.expandIconColumnIndex, u = e.direction, g = e.expandRowByClick, b = e.columnWidth, m = e.fixed, h = e.scrollWidth, C = e.clientWidth, S = a.useMemo(function() {
    var O = n || fo(o) || [];
    return Ji(O.slice());
  }, [n, o]), E = a.useMemo(function() {
    if (i) {
      var O = S.slice();
      if (process.env.NODE_ENV !== "production" && p >= 0 && Qe(!1, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead."), !O.includes(Ut)) {
        var R = p || 0;
        R >= 0 && (R || m === "left" || !m) && O.splice(R, 0, Ut), m === "right" && O.splice(S.length, 0, Ut);
      }
      process.env.NODE_ENV !== "production" && O.filter(function(z) {
        return z === Ut;
      }).length > 1 && Qe(!1, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      var P = O.indexOf(Ut);
      O = O.filter(function(z, B) {
        return z !== Ut || B === P;
      });
      var $ = S[P], D;
      m ? D = m : D = $ ? $.fixed : null;
      var _ = K(K(K(K(K(K({}, jn, {
        className: "".concat(r, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), "title", l), "fixed", D), "className", "".concat(r, "-row-expand-icon-cell")), "width", b), "render", function(B, W, X) {
        var Y = d(W, X), ee = c.has(Y), ie = f ? f(W) : !0, ue = v({
          prefixCls: r,
          expanded: ee,
          expandable: ie,
          record: W,
          onExpand: s
        });
        return g ? /* @__PURE__ */ a.createElement("span", {
          onClick: function(Z) {
            return Z.stopPropagation();
          }
        }, ue) : ue;
      });
      return O.map(function(z) {
        return z === Ut ? _ : z;
      });
    }
    return process.env.NODE_ENV !== "production" && S.includes(Ut) && Qe(!1, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`."), S.filter(function(z) {
      return z !== Ut;
    });
  }, [i, S, d, c, v, u]), x = a.useMemo(function() {
    var O = E;
    return t && (O = t(O)), O.length || (O = [{
      render: function() {
        return null;
      }
    }]), O;
  }, [t, E, u]), w = a.useMemo(function() {
    return u === "rtl" ? Yu(Mr(x)) : Mr(x);
  }, [x, u, h]), N = a.useMemo(function() {
    for (var O = -1, R = w.length - 1; R >= 0; R -= 1) {
      var P = w[R].fixed;
      if (P === "left" || P === !0) {
        O = R;
        break;
      }
    }
    if (O >= 0)
      for (var $ = 0; $ <= O; $ += 1) {
        var D = w[$].fixed;
        if (D !== "left" && D !== !0)
          return !0;
      }
    var _ = w.findIndex(function(W) {
      var X = W.fixed;
      return X === "right";
    });
    if (_ >= 0)
      for (var z = _; z < w.length; z += 1) {
        var B = w[z].fixed;
        if (B !== "right")
          return !0;
      }
    return !1;
  }, [w]), I = Xu(w, h, C), y = ce(I, 2), M = y[0], T = y[1];
  return [x, M, T, N];
}
function Qu(e, t, r) {
  var n = ju(e), o = n.expandIcon, i = n.expandedRowKeys, c = n.defaultExpandedRowKeys, l = n.defaultExpandAllRows, d = n.expandedRowRender, s = n.onExpand, v = n.onExpandedRowsChange, f = n.childrenColumnName, p = o || _u, u = f || "children", g = a.useMemo(function() {
    return d ? "row" : e.expandable && e.internalHooks === Gn && e.expandable.__PARENT_RENDER_ICON__ || t.some(function(x) {
      return x && St(x) === "object" && x[u];
    }) ? "nest" : !1;
  }, [!!d, t]), b = a.useState(function() {
    return c || (l ? ku(t, r, u) : []);
  }), m = ce(b, 2), h = m[0], C = m[1], S = a.useMemo(function() {
    return new Set(i || h || []);
  }, [i, h]), E = a.useCallback(function(x) {
    var w = r(x, t.indexOf(x)), N, I = S.has(w);
    I ? (S.delete(w), N = _e(S)) : N = [].concat(_e(S), [w]), C(N), s && s(!I, x), v && v(N);
  }, [r, S, t, s, v]);
  return process.env.NODE_ENV !== "production" && d && t.some(function(x) {
    return Array.isArray(x == null ? void 0 : x[u]);
  }) && Qe(!1, "`expandedRowRender` should not use with nested Table"), [n, g, S, p, u, E];
}
function Zu(e, t, r) {
  var n = e.map(function(o, i) {
    return uo(i, i, e, t, r);
  });
  return Wr(function() {
    return n;
  }, [n], function(o, i) {
    return !Vn(o, i);
  });
}
function ef(e) {
  var t = et(e), r = dn({}), n = ce(r, 2), o = n[1], i = et(null), c = et([]);
  function l(d) {
    c.current.push(d);
    var s = Promise.resolve();
    i.current = s, s.then(function() {
      if (i.current === s) {
        var v = c.current, f = t.current;
        c.current = [], v.forEach(function(p) {
          t.current = p(t.current);
        }), i.current = null, f !== t.current && o({});
      }
    });
  }
  return Rn(function() {
    return function() {
      i.current = null;
    };
  }, []), [t.current, l];
}
function tf(e) {
  var t = et(null), r = et();
  function n() {
    window.clearTimeout(r.current);
  }
  function o(c) {
    t.current = c, n(), r.current = window.setTimeout(function() {
      t.current = null, r.current = void 0;
    }, 100);
  }
  function i() {
    return t.current;
  }
  return Rn(function() {
    return n;
  }, []), [o, i];
}
function nf() {
  var e = a.useState(-1), t = ce(e, 2), r = t[0], n = t[1], o = a.useState(-1), i = ce(o, 2), c = i[0], l = i[1], d = a.useCallback(function(s, v) {
    n(s), l(v);
  }, []);
  return [r, c, d];
}
var aa = ka() ? window : null;
function rf(e, t) {
  var r = St(e) === "object" ? e : {}, n = r.offsetHeader, o = n === void 0 ? 0 : n, i = r.offsetSummary, c = i === void 0 ? 0 : i, l = r.offsetScroll, d = l === void 0 ? 0 : l, s = r.getContainer, v = s === void 0 ? function() {
    return aa;
  } : s, f = v() || aa, p = !!e;
  return a.useMemo(function() {
    return {
      isSticky: p,
      stickyClassName: p ? "".concat(t, "-sticky-holder") : "",
      offsetHeader: o,
      offsetSummary: c,
      offsetScroll: d,
      container: f
    };
  }, [p, d, o, c, t, f]);
}
function of(e, t, r) {
  var n = kt(function() {
    var o = t.length, i = function(s, v, f) {
      for (var p = [], u = 0, g = s; g !== v; g += f)
        p.push(u), t[g].fixed && (u += e[g] || 0);
      return p;
    }, c = i(0, o, 1), l = i(o - 1, -1, -1).reverse();
    return r === "rtl" ? {
      left: l,
      right: c
    } : {
      left: c,
      right: l
    };
  }, [e, t, r]);
  return n;
}
function ia(e) {
  var t = e.className, r = e.children;
  return /* @__PURE__ */ a.createElement("div", {
    className: t
  }, r);
}
function la(e) {
  var t = qr(e), r = t.getBoundingClientRect(), n = document.documentElement;
  return {
    left: r.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || document.body.clientLeft || 0),
    top: r.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || document.body.clientTop || 0)
  };
}
var af = function(t, r) {
  var n, o, i = t.scrollBodyRef, c = t.onScroll, l = t.offsetScroll, d = t.container, s = t.direction, v = Dt(_t, "prefixCls"), f = ((n = i.current) === null || n === void 0 ? void 0 : n.scrollWidth) || 0, p = ((o = i.current) === null || o === void 0 ? void 0 : o.clientWidth) || 0, u = f && p * (p / f), g = a.useRef(), b = ef({
    scrollLeft: 0,
    isHiddenScrollBar: !0
  }), m = ce(b, 2), h = m[0], C = m[1], S = a.useRef({
    delta: 0,
    x: 0
  }), E = a.useState(!1), x = ce(E, 2), w = x[0], N = x[1], I = a.useRef(null);
  a.useEffect(function() {
    return function() {
      Pt.cancel(I.current);
    };
  }, []);
  var y = function() {
    N(!1);
  }, M = function($) {
    $.persist(), S.current.delta = $.pageX - h.scrollLeft, S.current.x = 0, N(!0), $.preventDefault();
  }, T = function($) {
    var D, _ = $ || ((D = window) === null || D === void 0 ? void 0 : D.event), z = _.buttons;
    if (!w || z === 0) {
      w && N(!1);
      return;
    }
    var B = S.current.x + $.pageX - S.current.x - S.current.delta, W = s === "rtl";
    B = Math.max(W ? u - p : 0, Math.min(W ? 0 : p - u, B));
    var X = !W || Math.abs(B) + Math.abs(u) < p;
    X && (c({
      scrollLeft: B / p * (f + 2)
    }), S.current.x = $.pageX);
  }, O = function() {
    Pt.cancel(I.current), I.current = Pt(function() {
      if (i.current) {
        var $ = la(i.current).top, D = $ + i.current.offsetHeight, _ = d === window ? document.documentElement.scrollTop + window.innerHeight : la(d).top + d.clientHeight;
        D - Io() <= _ || $ >= _ - l ? C(function(z) {
          return F(F({}, z), {}, {
            isHiddenScrollBar: !0
          });
        }) : C(function(z) {
          return F(F({}, z), {}, {
            isHiddenScrollBar: !1
          });
        });
      }
    });
  }, R = function($) {
    C(function(D) {
      return F(F({}, D), {}, {
        scrollLeft: $ / f * p || 0
      });
    });
  };
  return a.useImperativeHandle(r, function() {
    return {
      setScrollLeft: R,
      checkScrollBarVisible: O
    };
  }), a.useEffect(function() {
    var P = Yo(document.body, "mouseup", y, !1), $ = Yo(document.body, "mousemove", T, !1);
    return O(), function() {
      P.remove(), $.remove();
    };
  }, [u, w]), a.useEffect(function() {
    if (i.current) {
      for (var P = [], $ = qr(i.current); $; )
        P.push($), $ = $.parentElement;
      return P.forEach(function(D) {
        return D.addEventListener("scroll", O, !1);
      }), window.addEventListener("resize", O, !1), window.addEventListener("scroll", O, !1), d.addEventListener("scroll", O, !1), function() {
        P.forEach(function(D) {
          return D.removeEventListener("scroll", O);
        }), window.removeEventListener("resize", O), window.removeEventListener("scroll", O), d.removeEventListener("scroll", O);
      };
    }
  }, [d]), a.useEffect(function() {
    h.isHiddenScrollBar || C(function(P) {
      var $ = i.current;
      return $ ? F(F({}, P), {}, {
        scrollLeft: $.scrollLeft / $.scrollWidth * $.clientWidth
      }) : P;
    });
  }, [h.isHiddenScrollBar]), f <= p || !u || h.isHiddenScrollBar ? null : /* @__PURE__ */ a.createElement("div", {
    style: {
      height: Io(),
      width: p,
      bottom: l
    },
    className: "".concat(v, "-sticky-scroll")
  }, /* @__PURE__ */ a.createElement("div", {
    onMouseDown: M,
    ref: g,
    className: Q("".concat(v, "-sticky-scroll-bar"), K({}, "".concat(v, "-sticky-scroll-bar-active"), w)),
    style: {
      width: "".concat(u, "px"),
      transform: "translate3d(".concat(h.scrollLeft, "px, 0, 0)")
    }
  }));
};
const lf = /* @__PURE__ */ a.forwardRef(af);
var Qi = "rc-table", sf = [], cf = {};
function df() {
  return "No Data";
}
function uf(e, t) {
  var r = F({
    rowKey: "key",
    prefixCls: Qi,
    emptyText: df
  }, e), n = r.prefixCls, o = r.className, i = r.rowClassName, c = r.style, l = r.data, d = r.rowKey, s = r.scroll, v = r.tableLayout, f = r.direction, p = r.title, u = r.footer, g = r.summary, b = r.caption, m = r.id, h = r.showHeader, C = r.components, S = r.emptyText, E = r.onRow, x = r.onHeaderRow, w = r.onScroll, N = r.internalHooks, I = r.transformColumns, y = r.internalRefs, M = r.tailor, T = r.getContainerWidth, O = r.sticky, R = r.rowHoverable, P = R === void 0 ? !0 : R, $ = l || sf, D = !!$.length, _ = N === Gn;
  process.env.NODE_ENV !== "production" && (["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(ze) {
    Qe(r[ze] === void 0, "`".concat(ze, "` is removed, please use `onRow` instead."));
  }), Qe(!("getBodyWrapper" in r), "`getBodyWrapper` is deprecated, please use custom `components` instead."));
  var z = a.useCallback(function(ze, Fe) {
    return Ur(C, ze) || Fe;
  }, [C]), B = a.useMemo(function() {
    return typeof d == "function" ? d : function(ze) {
      var Fe = ze && ze[d];
      return process.env.NODE_ENV !== "production" && Qe(Fe !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key."), Fe;
    };
  }, [d]), W = z(["body"]), X = nf(), Y = ce(X, 3), ee = Y[0], ie = Y[1], ue = Y[2], xe = Qu(r, $, B), Z = ce(xe, 6), ae = Z[0], me = Z[1], ye = Z[2], L = Z[3], k = Z[4], H = Z[5], q = s == null ? void 0 : s.x, A = a.useState(0), j = ce(A, 2), fe = j[0], te = j[1], Ne = Ju(F(F(F({}, r), ae), {}, {
    expandable: !!ae.expandedRowRender,
    columnTitle: ae.columnTitle,
    expandedKeys: ye,
    getRowKey: B,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: H,
    expandIcon: L,
    expandIconColumnIndex: ae.expandIconColumnIndex,
    direction: f,
    scrollWidth: _ && M && typeof q == "number" ? q : null,
    clientWidth: fe
  }), _ ? I : null), Ee = ce(Ne, 4), V = Ee[0], G = Ee[1], Ce = Ee[2], be = Ee[3], $e = Ce ?? q, qe = a.useMemo(function() {
    return {
      columns: V,
      flattenColumns: G
    };
  }, [V, G]), Oe = a.useRef(), He = a.useRef(), Se = a.useRef(), he = a.useRef();
  a.useImperativeHandle(t, function() {
    return {
      nativeElement: Oe.current,
      scrollTo: function(Fe) {
        var It;
        if (Se.current instanceof HTMLElement) {
          var Wt = Fe.index, Rt = Fe.top, wn = Fe.key;
          if (Su(Rt)) {
            var gn;
            (gn = Se.current) === null || gn === void 0 || gn.scrollTo({
              top: Rt
            });
          } else {
            var hn, Ln = wn ?? B($[Wt]);
            (hn = Se.current.querySelector('[data-row-key="'.concat(Ln, '"]'))) === null || hn === void 0 || hn.scrollIntoView();
          }
        } else (It = Se.current) !== null && It !== void 0 && It.scrollTo && Se.current.scrollTo(Fe);
      }
    };
  });
  var ne = a.useRef(), J = a.useState(!1), ke = ce(J, 2), Te = ke[0], ve = ke[1], tt = a.useState(!1), De = ce(tt, 2), at = De[0], je = De[1], dt = a.useState(/* @__PURE__ */ new Map()), ut = ce(dt, 2), xt = ut[0], Ue = ut[1], Tt = sr(G), it = Tt.map(function(ze) {
    return xt.get(ze);
  }), lt = a.useMemo(function() {
    return it;
  }, [it.join("_")]), ft = of(lt, G, f), ot = s && Tr(s.y), Ae = s && Tr($e) || !!ae.fixed, vt = Ae && G.some(function(ze) {
    var Fe = ze.fixed;
    return Fe;
  }), pt = a.useRef(), le = rf(O, n), re = le.isSticky, se = le.offsetHeader, de = le.offsetSummary, Le = le.offsetScroll, Ge = le.stickyClassName, mt = le.container, ge = a.useMemo(function() {
    return g == null ? void 0 : g($);
  }, [g, $]), Me = (ot || re) && /* @__PURE__ */ a.isValidElement(ge) && ge.type === cr && ge.props.fixed, Be, We, nt;
  ot && (We = {
    overflowY: D ? "scroll" : "auto",
    maxHeight: s.y
  }), Ae && (Be = {
    overflowX: "auto"
  }, ot || (We = {
    overflowY: "hidden"
  }), nt = {
    width: $e === !0 ? "auto" : $e,
    minWidth: "100%"
  });
  var ht = a.useCallback(function(ze, Fe) {
    Ue(function(It) {
      if (It.get(ze) !== Fe) {
        var Wt = new Map(It);
        return Wt.set(ze, Fe), Wt;
      }
      return It;
    });
  }, []), Et = tf(), rt = ce(Et, 2), wt = rt[0], we = rt[1];
  function pe(ze, Fe) {
    Fe && (typeof Fe == "function" ? Fe(ze) : Fe.scrollLeft !== ze && (Fe.scrollLeft = ze, Fe.scrollLeft !== ze && setTimeout(function() {
      Fe.scrollLeft = ze;
    }, 0)));
  }
  var Ke = en(function(ze) {
    var Fe = ze.currentTarget, It = ze.scrollLeft, Wt = f === "rtl", Rt = typeof It == "number" ? It : Fe.scrollLeft, wn = Fe || cf;
    if (!we() || we() === wn) {
      var gn;
      wt(wn), pe(Rt, He.current), pe(Rt, Se.current), pe(Rt, ne.current), pe(Rt, (gn = pt.current) === null || gn === void 0 ? void 0 : gn.setScrollLeft);
    }
    var hn = Fe || He.current;
    if (hn) {
      var Ln = (
        // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
        _ && M && typeof $e == "number" ? $e : hn.scrollWidth
      ), vr = hn.clientWidth;
      if (Ln === vr) {
        ve(!1), je(!1);
        return;
      }
      Wt ? (ve(-Rt < Ln - vr), je(-Rt > 0)) : (ve(Rt > 0), je(Rt < Ln - vr));
    }
  }), Ze = en(function(ze) {
    Ke(ze), w == null || w(ze);
  }), st = function() {
    if (Ae && Se.current) {
      var Fe;
      Ke({
        currentTarget: qr(Se.current),
        scrollLeft: (Fe = Se.current) === null || Fe === void 0 ? void 0 : Fe.scrollLeft
      });
    } else
      ve(!1), je(!1);
  }, At = function(Fe) {
    var It, Wt = Fe.width;
    (It = pt.current) === null || It === void 0 || It.checkScrollBarVisible();
    var Rt = Oe.current ? Oe.current.offsetWidth : Wt;
    _ && T && Oe.current && (Rt = T(Oe.current, Rt) || Rt), Rt !== fe && (st(), te(Rt));
  }, $t = a.useRef(!1);
  a.useEffect(function() {
    $t.current && st();
  }, [Ae, l, V.length]), a.useEffect(function() {
    $t.current = !0;
  }, []);
  var Lt = a.useState(0), Yt = ce(Lt, 2), Ft = Yt[0], Re = Yt[1], Ye = a.useState(!0), ct = ce(Ye, 2), Ht = ct[0], on = ct[1];
  Mt(function() {
    (!M || !_) && (Se.current instanceof Element ? Re(Ro(Se.current).width) : Re(Ro(he.current).width)), on(Ll("position", "sticky"));
  }, []), a.useEffect(function() {
    _ && y && (y.body.current = Se.current);
  });
  var ur = a.useCallback(function(ze) {
    return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(ra, ze), Me === "top" && /* @__PURE__ */ a.createElement(Jn, ze, ge));
  }, [Me, ge]), fr = a.useCallback(function(ze) {
    return /* @__PURE__ */ a.createElement(Jn, ze, ge);
  }, [ge]), Yn = z(["table"], "table"), xn = a.useMemo(function() {
    return v || (vt ? $e === "max-content" ? "auto" : "fixed" : ot || re || G.some(function(ze) {
      var Fe = ze.ellipsis;
      return Fe;
    }) ? "fixed" : "auto");
  }, [ot, vt, G, v, re]), En, mn = {
    colWidths: lt,
    columCount: G.length,
    stickyOffsets: ft,
    onHeaderRow: x,
    fixHeader: ot,
    scroll: s
  }, Je = a.useMemo(function() {
    return D ? null : typeof S == "function" ? S() : S;
  }, [D, S]), Ve = /* @__PURE__ */ a.createElement(Lu, {
    data: $,
    measureColumnWidth: ot || Ae || re
  }), Nt = /* @__PURE__ */ a.createElement(Ui, {
    colWidths: G.map(function(ze) {
      var Fe = ze.width;
      return Fe;
    }),
    columns: G
  }), Ot = b != null ? /* @__PURE__ */ a.createElement("caption", {
    className: "".concat(n, "-caption")
  }, b) : void 0, gt = nn(r, {
    data: !0
  }), Ct = nn(r, {
    aria: !0
  });
  if (ot || re) {
    var jt;
    typeof W == "function" ? (jt = W($, {
      scrollbarSize: Ft,
      ref: Se,
      onScroll: Ke
    }), mn.colWidths = G.map(function(ze, Fe) {
      var It = ze.width, Wt = Fe === G.length - 1 ? It - Ft : It;
      return typeof Wt == "number" && !Number.isNaN(Wt) ? Wt : (process.env.NODE_ENV !== "production" && Qe(r.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value."), 0);
    })) : jt = /* @__PURE__ */ a.createElement("div", {
      style: F(F({}, Be), We),
      onScroll: Ze,
      ref: Se,
      className: Q("".concat(n, "-body"))
    }, /* @__PURE__ */ a.createElement(Yn, Pe({
      style: F(F({}, nt), {}, {
        tableLayout: xn
      })
    }, Ct), Ot, Nt, Ve, !Me && ge && /* @__PURE__ */ a.createElement(Jn, {
      stickyOffsets: ft,
      flattenColumns: G
    }, ge)));
    var Vt = F(F(F({
      noData: !$.length,
      maxContentScroll: Ae && $e === "max-content"
    }, mn), qe), {}, {
      direction: f,
      stickyClassName: Ge,
      onScroll: Ke
    });
    En = /* @__PURE__ */ a.createElement(a.Fragment, null, h !== !1 && /* @__PURE__ */ a.createElement(na, Pe({}, Vt, {
      stickyTopOffset: se,
      className: "".concat(n, "-header"),
      ref: He
    }), ur), jt, Me && Me !== "top" && /* @__PURE__ */ a.createElement(na, Pe({}, Vt, {
      stickyBottomOffset: de,
      className: "".concat(n, "-summary"),
      ref: ne
    }), fr), re && Se.current && Se.current instanceof Element && /* @__PURE__ */ a.createElement(lf, {
      ref: pt,
      offsetScroll: Le,
      scrollBodyRef: Se,
      onScroll: Ke,
      container: mt,
      direction: f
    }));
  } else
    En = /* @__PURE__ */ a.createElement("div", {
      style: F(F({}, Be), We),
      className: Q("".concat(n, "-content")),
      onScroll: Ke,
      ref: Se
    }, /* @__PURE__ */ a.createElement(Yn, Pe({
      style: F(F({}, nt), {}, {
        tableLayout: xn
      })
    }, Ct), Ot, Nt, h !== !1 && /* @__PURE__ */ a.createElement(ra, Pe({}, mn, qe)), Ve, ge && /* @__PURE__ */ a.createElement(Jn, {
      stickyOffsets: ft,
      flattenColumns: G
    }, ge)));
  var Xt = /* @__PURE__ */ a.createElement("div", Pe({
    className: Q(n, o, K(K(K(K(K(K(K(K(K(K({}, "".concat(n, "-rtl"), f === "rtl"), "".concat(n, "-ping-left"), Te), "".concat(n, "-ping-right"), at), "".concat(n, "-layout-fixed"), v === "fixed"), "".concat(n, "-fixed-header"), ot), "".concat(n, "-fixed-column"), vt), "".concat(n, "-fixed-column-gapped"), vt && be), "".concat(n, "-scroll-horizontal"), Ae), "".concat(n, "-has-fix-left"), G[0] && G[0].fixed), "".concat(n, "-has-fix-right"), G[G.length - 1] && G[G.length - 1].fixed === "right")),
    style: c,
    id: m,
    ref: Oe
  }, gt), p && /* @__PURE__ */ a.createElement(ia, {
    className: "".concat(n, "-title")
  }, p($)), /* @__PURE__ */ a.createElement("div", {
    ref: he,
    className: "".concat(n, "-container")
  }, En), u && /* @__PURE__ */ a.createElement(ia, {
    className: "".concat(n, "-footer")
  }, u($)));
  Ae && (Xt = /* @__PURE__ */ a.createElement(Wn, {
    onResize: At
  }, Xt));
  var an = Zu(G, ft, f), ln = a.useMemo(function() {
    return {
      // Scroll
      scrollX: $e,
      // Table
      prefixCls: n,
      getComponent: z,
      scrollbarSize: Ft,
      direction: f,
      fixedInfoList: an,
      isSticky: re,
      supportSticky: Ht,
      componentWidth: fe,
      fixHeader: ot,
      fixColumn: vt,
      horizonScroll: Ae,
      // Body
      tableLayout: xn,
      rowClassName: i,
      expandedRowClassName: ae.expandedRowClassName,
      expandIcon: L,
      expandableType: me,
      expandRowByClick: ae.expandRowByClick,
      expandedRowRender: ae.expandedRowRender,
      onTriggerExpand: H,
      expandIconColumnIndex: ae.expandIconColumnIndex,
      indentSize: ae.indentSize,
      allColumnsFixedLeft: G.every(function(ze) {
        return ze.fixed === "left";
      }),
      emptyNode: Je,
      // Column
      columns: V,
      flattenColumns: G,
      onColumnResize: ht,
      // Row
      hoverStartRow: ee,
      hoverEndRow: ie,
      onHover: ue,
      rowExpandable: ae.rowExpandable,
      onRow: E,
      getRowKey: B,
      expandedKeys: ye,
      childrenColumnName: k,
      rowHoverable: P
    };
  }, [
    // Scroll
    $e,
    // Table
    n,
    z,
    Ft,
    f,
    an,
    re,
    Ht,
    fe,
    ot,
    vt,
    Ae,
    // Body
    xn,
    i,
    ae.expandedRowClassName,
    L,
    me,
    ae.expandRowByClick,
    ae.expandedRowRender,
    H,
    ae.expandIconColumnIndex,
    ae.indentSize,
    Je,
    // Column
    V,
    G,
    ht,
    // Row
    ee,
    ie,
    ue,
    ae.rowExpandable,
    E,
    B,
    ye,
    k,
    P
  ]);
  return /* @__PURE__ */ a.createElement(_t.Provider, {
    value: ln
  }, Xt);
}
var Zi = /* @__PURE__ */ a.forwardRef(uf);
process.env.NODE_ENV !== "production" && (Zi.displayName = "Table");
function el(e) {
  return ki(Zi, e);
}
var Bn = el();
Bn.EXPAND_COLUMN = Ut;
Bn.INTERNAL_HOOKS = Gn;
Bn.Column = Tu;
Bn.ColumnGroup = Mu;
Bn.Summary = Li;
var vo = so(null), tl = so(null);
function ff(e, t, r) {
  var n = t || 1;
  return r[e + n] - (r[e] || 0);
}
function vf(e) {
  var t = e.rowInfo, r = e.column, n = e.colIndex, o = e.indent, i = e.index, c = e.component, l = e.renderIndex, d = e.record, s = e.style, v = e.className, f = e.inverse, p = e.getHeight, u = r.render, g = r.dataIndex, b = r.className, m = r.width, h = Dt(tl, ["columnsOffset"]), C = h.columnsOffset, S = Wi(t, r, n, o, i), E = S.key, x = S.fixedInfo, w = S.appendCellNode, N = S.additionalCellProps, I = N.style, y = N.colSpan, M = y === void 0 ? 1 : y, T = N.rowSpan, O = T === void 0 ? 1 : T, R = n - 1, P = ff(R, M, C), $ = M > 1 ? m - P : 0, D = F(F(F({}, I), s), {}, {
    flex: "0 0 ".concat(P, "px"),
    width: "".concat(P, "px"),
    marginRight: $,
    pointerEvents: "auto"
  }), _ = a.useMemo(function() {
    return f ? O <= 1 : M === 0 || O === 0 || O > 1;
  }, [O, M, f]);
  _ ? D.visibility = "hidden" : f && (D.height = p == null ? void 0 : p(O));
  var z = _ ? function() {
    return null;
  } : u, B = {};
  return (O === 0 || M === 0) && (B.rowSpan = 1, B.colSpan = 1), /* @__PURE__ */ a.createElement(Kn, Pe({
    className: Q(b, v),
    ellipsis: r.ellipsis,
    align: r.align,
    scope: r.rowScope,
    component: c,
    prefixCls: t.prefixCls,
    key: E,
    record: d,
    index: i,
    renderIndex: l,
    dataIndex: g,
    render: z,
    shouldCellUpdate: r.shouldCellUpdate
  }, x, {
    appendNode: w,
    additionalProps: F(F({}, N), {}, {
      style: D
    }, B)
  }));
}
var pf = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], mf = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.data, n = e.index, o = e.className, i = e.rowKey, c = e.style, l = e.extra, d = e.getHeight, s = yt(e, pf), v = r.record, f = r.indent, p = r.index, u = Dt(_t, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), g = u.scrollX, b = u.flattenColumns, m = u.prefixCls, h = u.fixColumn, C = u.componentWidth, S = Dt(vo, ["getComponent"]), E = S.getComponent, x = Vi(v, i, n, f), w = E(["body", "row"], "div"), N = E(["body", "cell"], "div"), I = x.rowSupportExpand, y = x.expanded, M = x.rowProps, T = x.expandedRowRender, O = x.expandedRowClassName, R;
  if (I && y) {
    var P = T(v, n, f + 1, y), $ = Fi(O, v, n, f), D = {};
    h && (D = {
      style: K({}, "--virtual-width", "".concat(C, "px"))
    });
    var _ = "".concat(m, "-expanded-row-cell");
    R = /* @__PURE__ */ a.createElement(w, {
      className: Q("".concat(m, "-expanded-row"), "".concat(m, "-expanded-row-level-").concat(f + 1), $)
    }, /* @__PURE__ */ a.createElement(Kn, {
      component: N,
      prefixCls: m,
      className: Q(_, K({}, "".concat(_, "-fixed"), h)),
      additionalProps: D
    }, P));
  }
  var z = F(F({}, c), {}, {
    width: g
  });
  l && (z.position = "absolute", z.pointerEvents = "none");
  var B = /* @__PURE__ */ a.createElement(w, Pe({}, M, s, {
    "data-row-key": i,
    ref: I ? null : t,
    className: Q(o, "".concat(m, "-row"), M == null ? void 0 : M.className, K({}, "".concat(m, "-row-extra"), l)),
    style: F(F({}, z), M == null ? void 0 : M.style)
  }), b.map(function(W, X) {
    return /* @__PURE__ */ a.createElement(vf, {
      key: X,
      component: N,
      rowInfo: x,
      column: W,
      colIndex: X,
      indent: f,
      index: n,
      renderIndex: p,
      record: v,
      inverse: l,
      getHeight: d
    });
  }));
  return I ? /* @__PURE__ */ a.createElement("div", {
    ref: t
  }, B, R) : B;
}), _r = kn(mf);
process.env.NODE_ENV !== "production" && (_r.displayName = "BodyLine");
var gf = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.data, n = e.onScroll, o = Dt(_t, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "scrollX", "direction"]), i = o.flattenColumns, c = o.onColumnResize, l = o.getRowKey, d = o.expandedKeys, s = o.prefixCls, v = o.childrenColumnName, f = o.scrollX, p = o.direction, u = Dt(vo), g = u.sticky, b = u.scrollY, m = u.listItemHeight, h = u.getComponent, C = u.onScroll, S = a.useRef(), E = ji(r, v, d, l), x = a.useMemo(function() {
    var R = 0;
    return i.map(function(P) {
      var $ = P.width, D = P.key;
      return R += $, [D, $, R];
    });
  }, [i]), w = a.useMemo(function() {
    return x.map(function(R) {
      return R[2];
    });
  }, [x]);
  a.useEffect(function() {
    x.forEach(function(R) {
      var P = ce(R, 2), $ = P[0], D = P[1];
      c($, D);
    });
  }, [x]), a.useImperativeHandle(t, function() {
    var R, P = {
      scrollTo: function(D) {
        var _;
        (_ = S.current) === null || _ === void 0 || _.scrollTo(D);
      },
      nativeElement: (R = S.current) === null || R === void 0 ? void 0 : R.nativeElement
    };
    return Object.defineProperty(P, "scrollLeft", {
      get: function() {
        var D;
        return ((D = S.current) === null || D === void 0 ? void 0 : D.getScrollInfo().x) || 0;
      },
      set: function(D) {
        var _;
        (_ = S.current) === null || _ === void 0 || _.scrollTo({
          left: D
        });
      }
    }), P;
  });
  var N = function(P, $) {
    var D, _ = (D = E[$]) === null || D === void 0 ? void 0 : D.record, z = P.onCell;
    if (z) {
      var B, W = z(_, $);
      return (B = W == null ? void 0 : W.rowSpan) !== null && B !== void 0 ? B : 1;
    }
    return 1;
  }, I = function(P) {
    var $ = P.start, D = P.end, _ = P.getSize, z = P.offsetY;
    if (D < 0)
      return null;
    for (var B = i.filter(
      // rowSpan is 0
      function(L) {
        return N(L, $) === 0;
      }
    ), W = $, X = function(k) {
      if (B = B.filter(function(H) {
        return N(H, k) === 0;
      }), !B.length)
        return W = k, 1;
    }, Y = $; Y >= 0 && !X(Y); Y -= 1)
      ;
    for (var ee = i.filter(
      // rowSpan is not 1
      function(L) {
        return N(L, D) !== 1;
      }
    ), ie = D, ue = function(k) {
      if (ee = ee.filter(function(H) {
        return N(H, k) !== 1;
      }), !ee.length)
        return ie = Math.max(k - 1, D), 1;
    }, xe = D; xe < E.length && !ue(xe); xe += 1)
      ;
    for (var Z = [], ae = function(k) {
      var H = E[k];
      if (!H)
        return 1;
      i.some(function(q) {
        return N(q, k) > 1;
      }) && Z.push(k);
    }, me = W; me <= ie; me += 1)
      ae(me);
    var ye = Z.map(function(L) {
      var k = E[L], H = l(k.record, L), q = function(fe) {
        var te = L + fe - 1, Ne = l(E[te].record, te), Ee = _(H, Ne);
        return Ee.bottom - Ee.top;
      }, A = _(H);
      return /* @__PURE__ */ a.createElement(_r, {
        key: L,
        data: k,
        rowKey: H,
        index: L,
        style: {
          top: -z + A.top
        },
        extra: !0,
        getHeight: q
      });
    });
    return ye;
  }, y = a.useMemo(function() {
    return {
      columnsOffset: w
    };
  }, [w]), M = "".concat(s, "-tbody"), T = h(["body", "wrapper"]), O = {};
  return g && (O.position = "sticky", O.bottom = 0, St(g) === "object" && g.offsetScroll && (O.bottom = g.offsetScroll)), /* @__PURE__ */ a.createElement(tl.Provider, {
    value: y
  }, /* @__PURE__ */ a.createElement(lr, {
    fullHeight: !1,
    ref: S,
    prefixCls: "".concat(M, "-virtual"),
    styles: {
      horizontalScrollBar: O
    },
    className: M,
    height: b,
    itemHeight: m || 24,
    data: E,
    itemKey: function(P) {
      return l(P.record);
    },
    component: T,
    scrollWidth: f,
    direction: p,
    onVirtualScroll: function(P) {
      var $, D = P.x;
      n({
        currentTarget: ($ = S.current) === null || $ === void 0 ? void 0 : $.nativeElement,
        scrollLeft: D
      });
    },
    onScroll: C,
    extraRender: I
  }, function(R, P, $) {
    var D = l(R.record, P);
    return /* @__PURE__ */ a.createElement(_r, {
      data: R,
      rowKey: D,
      index: P,
      style: $.style
    });
  }));
}), nl = kn(gf);
process.env.NODE_ENV !== "production" && (nl.displayName = "ResponseGrid");
var hf = function(t, r) {
  var n = r.ref, o = r.onScroll;
  return /* @__PURE__ */ a.createElement(nl, {
    ref: n,
    data: t,
    onScroll: o
  });
};
function bf(e, t) {
  var r = e.data, n = e.columns, o = e.scroll, i = e.sticky, c = e.prefixCls, l = c === void 0 ? Qi : c, d = e.className, s = e.listItemHeight, v = e.components, f = e.onScroll, p = o || {}, u = p.x, g = p.y;
  typeof u != "number" && (process.env.NODE_ENV !== "production" && Qe(!u, "`scroll.x` in virtual table must be number."), u = 1), typeof g != "number" && (g = 500, process.env.NODE_ENV !== "production" && Qe(!1, "`scroll.y` in virtual table must be number."));
  var b = en(function(C, S) {
    return Ur(v, C) || S;
  }), m = en(f), h = a.useMemo(function() {
    return {
      sticky: i,
      scrollY: g,
      listItemHeight: s,
      getComponent: b,
      onScroll: m
    };
  }, [i, g, s, b, m]);
  return /* @__PURE__ */ a.createElement(vo.Provider, {
    value: h
  }, /* @__PURE__ */ a.createElement(Bn, Pe({}, e, {
    className: Q(d, "".concat(l, "-virtual")),
    scroll: F(F({}, o), {}, {
      x: u
    }),
    components: F(F({}, v), {}, {
      // fix https://github.com/ant-design/ant-design/issues/48991
      body: r != null && r.length ? hf : void 0
    }),
    columns: n,
    internalHooks: Gn,
    tailor: !0,
    ref: t
  })));
}
var rl = /* @__PURE__ */ a.forwardRef(bf);
process.env.NODE_ENV !== "production" && (rl.displayName = "VirtualTable");
function ol(e) {
  return ki(rl, e);
}
ol();
const yf = (e) => null, Cf = (e) => null;
var po = /* @__PURE__ */ a.createContext(null), Sf = /* @__PURE__ */ a.createContext({}), xf = function(t) {
  for (var r = t.prefixCls, n = t.level, o = t.isStart, i = t.isEnd, c = "".concat(r, "-indent-unit"), l = [], d = 0; d < n; d += 1)
    l.push(/* @__PURE__ */ a.createElement("span", {
      key: d,
      className: Q(c, K(K({}, "".concat(c, "-start"), o[d]), "".concat(c, "-end"), i[d]))
    }));
  return /* @__PURE__ */ a.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(r, "-indent")
  }, l);
};
const Ef = /* @__PURE__ */ a.memo(xf);
var wf = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], sa = "open", ca = "close", $f = "---", Tn = function(t) {
  var r, n, o, i = t.eventKey, c = t.className, l = t.style, d = t.dragOver, s = t.dragOverGapTop, v = t.dragOverGapBottom, f = t.isLeaf, p = t.isStart, u = t.isEnd, g = t.expanded, b = t.selected, m = t.checked, h = t.halfChecked, C = t.loading, S = t.domRef, E = t.active, x = t.data, w = t.onMouseMove, N = t.selectable, I = yt(t, wf), y = oe.useContext(po), M = oe.useContext(Sf), T = oe.useRef(null), O = oe.useState(!1), R = ce(O, 2), P = R[0], $ = R[1], D = !!(y.disabled || t.disabled || (r = M.nodeDisabled) !== null && r !== void 0 && r.call(M, x)), _ = oe.useMemo(function() {
    return !y.checkable || t.checkable === !1 ? !1 : y.checkable;
  }, [y.checkable, t.checkable]), z = function(J) {
    D || y.onNodeSelect(J, bt(t));
  }, B = function(J) {
    D || !_ || t.disableCheckbox || y.onNodeCheck(J, bt(t), !m);
  }, W = oe.useMemo(function() {
    return typeof N == "boolean" ? N : y.selectable;
  }, [N, y.selectable]), X = function(J) {
    y.onNodeClick(J, bt(t)), W ? z(J) : B(J);
  }, Y = function(J) {
    y.onNodeDoubleClick(J, bt(t));
  }, ee = function(J) {
    y.onNodeMouseEnter(J, bt(t));
  }, ie = function(J) {
    y.onNodeMouseLeave(J, bt(t));
  }, ue = function(J) {
    y.onNodeContextMenu(J, bt(t));
  }, xe = oe.useMemo(function() {
    return !!(y.draggable && (!y.draggable.nodeDraggable || y.draggable.nodeDraggable(x)));
  }, [y.draggable, x]), Z = function(J) {
    J.stopPropagation(), $(!0), y.onNodeDragStart(J, t);
    try {
      J.dataTransfer.setData("text/plain", "");
    } catch {
    }
  }, ae = function(J) {
    J.preventDefault(), J.stopPropagation(), y.onNodeDragEnter(J, t);
  }, me = function(J) {
    J.preventDefault(), J.stopPropagation(), y.onNodeDragOver(J, t);
  }, ye = function(J) {
    J.stopPropagation(), y.onNodeDragLeave(J, t);
  }, L = function(J) {
    J.stopPropagation(), $(!1), y.onNodeDragEnd(J, t);
  }, k = function(J) {
    J.preventDefault(), J.stopPropagation(), $(!1), y.onNodeDrop(J, t);
  }, H = function(J) {
    C || y.onNodeExpand(J, bt(t));
  }, q = oe.useMemo(function() {
    var ne = Kt(y.keyEntities, i) || {}, J = ne.children;
    return !!(J || []).length;
  }, [y.keyEntities, i]), A = oe.useMemo(function() {
    return f === !1 ? !1 : f || !y.loadData && !q || y.loadData && t.loaded && !q;
  }, [f, y.loadData, q, t.loaded]);
  oe.useEffect(function() {
    C || typeof y.loadData == "function" && g && !A && !t.loaded && y.onNodeLoad(bt(t));
  }, [C, y.loadData, y.onNodeLoad, g, A, t]);
  var j = oe.useMemo(function() {
    var ne;
    return (ne = y.draggable) !== null && ne !== void 0 && ne.icon ? /* @__PURE__ */ oe.createElement("span", {
      className: "".concat(y.prefixCls, "-draggable-icon")
    }, y.draggable.icon) : null;
  }, [y.draggable]), fe = function(J) {
    var ke = t.switcherIcon || y.switcherIcon;
    return typeof ke == "function" ? ke(F(F({}, t), {}, {
      isLeaf: J
    })) : ke;
  }, te = function() {
    if (A) {
      var J = fe(!0);
      return J !== !1 ? /* @__PURE__ */ oe.createElement("span", {
        className: Q("".concat(y.prefixCls, "-switcher"), "".concat(y.prefixCls, "-switcher-noop"))
      }, J) : null;
    }
    var ke = fe(!1);
    return ke !== !1 ? /* @__PURE__ */ oe.createElement("span", {
      onClick: H,
      className: Q("".concat(y.prefixCls, "-switcher"), "".concat(y.prefixCls, "-switcher_").concat(g ? sa : ca))
    }, ke) : null;
  }, Ne = oe.useMemo(function() {
    if (!_)
      return null;
    var ne = typeof _ != "boolean" ? _ : null;
    return /* @__PURE__ */ oe.createElement("span", {
      className: Q("".concat(y.prefixCls, "-checkbox"), K(K(K({}, "".concat(y.prefixCls, "-checkbox-checked"), m), "".concat(y.prefixCls, "-checkbox-indeterminate"), !m && h), "".concat(y.prefixCls, "-checkbox-disabled"), D || t.disableCheckbox)),
      onClick: B,
      role: "checkbox",
      "aria-checked": h ? "mixed" : m,
      "aria-disabled": D || t.disableCheckbox,
      "aria-label": "Select ".concat(typeof t.title == "string" ? t.title : "tree node")
    }, ne);
  }, [_, m, h, D, t.disableCheckbox, t.title]), Ee = oe.useMemo(function() {
    return A ? null : g ? sa : ca;
  }, [A, g]), V = oe.useMemo(function() {
    return /* @__PURE__ */ oe.createElement("span", {
      className: Q("".concat(y.prefixCls, "-iconEle"), "".concat(y.prefixCls, "-icon__").concat(Ee || "docu"), K({}, "".concat(y.prefixCls, "-icon_loading"), C))
    });
  }, [y.prefixCls, Ee, C]), G = oe.useMemo(function() {
    var ne = !!y.draggable, J = !t.disabled && ne && y.dragOverNodeKey === i;
    return J ? y.dropIndicatorRender({
      dropPosition: y.dropPosition,
      dropLevelOffset: y.dropLevelOffset,
      indent: y.indent,
      prefixCls: y.prefixCls,
      direction: y.direction
    }) : null;
  }, [y.dropPosition, y.dropLevelOffset, y.indent, y.prefixCls, y.direction, y.draggable, y.dragOverNodeKey, y.dropIndicatorRender]), Ce = oe.useMemo(function() {
    var ne = t.title, J = ne === void 0 ? $f : ne, ke = "".concat(y.prefixCls, "-node-content-wrapper"), Te;
    if (y.showIcon) {
      var ve = t.icon || y.icon;
      Te = ve ? /* @__PURE__ */ oe.createElement("span", {
        className: Q("".concat(y.prefixCls, "-iconEle"), "".concat(y.prefixCls, "-icon__customize"))
      }, typeof ve == "function" ? ve(t) : ve) : V;
    } else y.loadData && C && (Te = V);
    var tt;
    return typeof J == "function" ? tt = J(x) : y.titleRender ? tt = y.titleRender(x) : tt = J, /* @__PURE__ */ oe.createElement("span", {
      ref: T,
      title: typeof J == "string" ? J : "",
      className: Q(ke, "".concat(ke, "-").concat(Ee || "normal"), K({}, "".concat(y.prefixCls, "-node-selected"), !D && (b || P))),
      onMouseEnter: ee,
      onMouseLeave: ie,
      onContextMenu: ue,
      onClick: X,
      onDoubleClick: Y
    }, Te, /* @__PURE__ */ oe.createElement("span", {
      className: "".concat(y.prefixCls, "-title")
    }, tt), G);
  }, [y.prefixCls, y.showIcon, t, y.icon, V, y.titleRender, x, Ee, ee, ie, ue, X, Y]), be = nn(I, {
    aria: !0,
    data: !0
  }), $e = Kt(y.keyEntities, i) || {}, qe = $e.level, Oe = u[u.length - 1], He = !D && xe, Se = y.draggingNodeKey === i, he = N !== void 0 ? {
    "aria-selected": !!N
  } : void 0;
  return /* @__PURE__ */ oe.createElement("div", Pe({
    ref: S,
    role: "treeitem",
    "aria-expanded": f ? void 0 : g,
    className: Q(c, "".concat(y.prefixCls, "-treenode"), (o = {}, K(K(K(K(K(K(K(K(K(K(o, "".concat(y.prefixCls, "-treenode-disabled"), D), "".concat(y.prefixCls, "-treenode-switcher-").concat(g ? "open" : "close"), !f), "".concat(y.prefixCls, "-treenode-checkbox-checked"), m), "".concat(y.prefixCls, "-treenode-checkbox-indeterminate"), h), "".concat(y.prefixCls, "-treenode-selected"), b), "".concat(y.prefixCls, "-treenode-loading"), C), "".concat(y.prefixCls, "-treenode-active"), E), "".concat(y.prefixCls, "-treenode-leaf-last"), Oe), "".concat(y.prefixCls, "-treenode-draggable"), xe), "dragging", Se), K(K(K(K(K(K(K(o, "drop-target", y.dropTargetKey === i), "drop-container", y.dropContainerKey === i), "drag-over", !D && d), "drag-over-gap-top", !D && s), "drag-over-gap-bottom", !D && v), "filter-node", (n = y.filterTreeNode) === null || n === void 0 ? void 0 : n.call(y, bt(t))), "".concat(y.prefixCls, "-treenode-leaf"), A))),
    style: l,
    draggable: He,
    onDragStart: He ? Z : void 0,
    onDragEnter: xe ? ae : void 0,
    onDragOver: xe ? me : void 0,
    onDragLeave: xe ? ye : void 0,
    onDrop: xe ? k : void 0,
    onDragEnd: xe ? L : void 0,
    onMouseMove: w
  }, he, be), /* @__PURE__ */ oe.createElement(Ef, {
    prefixCls: y.prefixCls,
    level: qe,
    isStart: p,
    isEnd: u
  }), j, te(), Ne, Ce);
};
Tn.isTreeNode = 1;
process.env.NODE_ENV !== "production" && (Tn.displayName = "TreeNode");
function Jt(e, t) {
  if (!e) return [];
  var r = e.slice(), n = r.indexOf(t);
  return n >= 0 && r.splice(n, 1), r;
}
function sn(e, t) {
  var r = (e || []).slice();
  return r.indexOf(t) === -1 && r.push(t), r;
}
function mo(e) {
  return e.split("-");
}
function Nf(e, t) {
  var r = [], n = Kt(t, e);
  function o() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    i.forEach(function(c) {
      var l = c.key, d = c.children;
      r.push(l), o(d);
    });
  }
  return o(n.children), r;
}
function Of(e) {
  if (e.parent) {
    var t = mo(e.pos);
    return Number(t[t.length - 1]) === e.parent.children.length - 1;
  }
  return !1;
}
function If(e) {
  var t = mo(e.pos);
  return Number(t[t.length - 1]) === 0;
}
function da(e, t, r, n, o, i, c, l, d, s) {
  var v, f = e.clientX, p = e.clientY, u = e.target.getBoundingClientRect(), g = u.top, b = u.height, m = (s === "rtl" ? -1 : 1) * (((o == null ? void 0 : o.x) || 0) - f), h = (m - 12) / n, C = d.filter(function(D) {
    var _;
    return (_ = l[D]) === null || _ === void 0 || (_ = _.children) === null || _ === void 0 ? void 0 : _.length;
  }), S = Kt(l, r.eventKey);
  if (p < g + b / 2) {
    var E = c.findIndex(function(D) {
      return D.key === S.key;
    }), x = E <= 0 ? 0 : E - 1, w = c[x].key;
    S = Kt(l, w);
  }
  var N = S.key, I = S, y = S.key, M = 0, T = 0;
  if (!C.includes(N))
    for (var O = 0; O < h && Of(S); O += 1)
      S = S.parent, T += 1;
  var R = t.data, P = S.node, $ = !0;
  return If(S) && S.level === 0 && p < g + b / 2 && i({
    dragNode: R,
    dropNode: P,
    dropPosition: -1
  }) && S.key === r.eventKey ? M = -1 : (I.children || []).length && C.includes(y) ? i({
    dragNode: R,
    dropNode: P,
    dropPosition: 0
  }) ? M = 0 : $ = !1 : T === 0 ? h > -1.5 ? i({
    dragNode: R,
    dropNode: P,
    dropPosition: 1
  }) ? M = 1 : $ = !1 : i({
    dragNode: R,
    dropNode: P,
    dropPosition: 0
  }) ? M = 0 : i({
    dragNode: R,
    dropNode: P,
    dropPosition: 1
  }) ? M = 1 : $ = !1 : i({
    dragNode: R,
    dropNode: P,
    dropPosition: 1
  }) ? M = 1 : $ = !1, {
    dropPosition: M,
    dropLevelOffset: T,
    dropTargetKey: S.key,
    dropTargetPos: S.pos,
    dragOverNodeKey: y,
    dropContainerKey: M === 0 ? null : ((v = S.parent) === null || v === void 0 ? void 0 : v.key) || null,
    dropAllowed: $
  };
}
function ua(e, t) {
  if (e) {
    var r = t.multiple;
    return r ? e.slice() : e.length ? [e[0]] : e;
  }
}
function yr(e) {
  if (!e)
    return null;
  var t;
  if (Array.isArray(e))
    t = {
      checkedKeys: e,
      halfCheckedKeys: void 0
    };
  else if (St(e) === "object")
    t = {
      checkedKeys: e.checked || void 0,
      halfCheckedKeys: e.halfChecked || void 0
    };
  else
    return Qe(!1, "`checkedKeys` is not an array or an object"), null;
  return t;
}
function kr(e, t) {
  var r = /* @__PURE__ */ new Set();
  function n(o) {
    if (!r.has(o)) {
      var i = Kt(t, o);
      if (i) {
        r.add(o);
        var c = i.parent, l = i.node;
        l.disabled || c && n(c.key);
      }
    }
  }
  return (e || []).forEach(function(o) {
    n(o);
  }), _e(r);
}
function Rf(e) {
  const [t, r] = dn(null);
  return [$n((i, c, l) => {
    const d = t ?? i, s = Math.min(d || 0, i), v = Math.max(d || 0, i), f = c.slice(s, v + 1).map((g) => e(g)), p = f.some((g) => !l.has(g)), u = [];
    return f.forEach((g) => {
      p ? (l.has(g) || u.push(g), l.add(g)) : (l.delete(g), u.push(g));
    }), r(p ? v : null), u;
  }, [t]), (i) => {
    r(i);
  }];
}
const Qt = {}, Kr = "SELECT_ALL", Br = "SELECT_INVERT", zr = "SELECT_NONE", fa = [], al = (e, t) => {
  let r = [];
  return (t || []).forEach((n) => {
    r.push(n), n && typeof n == "object" && e in n && (r = [].concat(_e(r), _e(al(e, n[e]))));
  }), r;
}, Pf = (e, t) => {
  const {
    preserveSelectedRowKeys: r,
    selectedRowKeys: n,
    defaultSelectedRowKeys: o,
    getCheckboxProps: i,
    onChange: c,
    onSelect: l,
    onSelectAll: d,
    onSelectInvert: s,
    onSelectNone: v,
    onSelectMultiple: f,
    columnWidth: p,
    type: u,
    selections: g,
    fixed: b,
    renderCell: m,
    hideSelectAll: h,
    checkStrictly: C = !0
  } = t || {}, {
    prefixCls: S,
    data: E,
    pageData: x,
    getRecordByKey: w,
    getRowKey: N,
    expandType: I,
    childrenColumnName: y,
    locale: M,
    getPopupContainer: T
  } = e, O = rn("Table"), [R, P] = Rf((L) => L), [$, D] = un(n || o || fa, {
    value: n
  }), _ = a.useRef(/* @__PURE__ */ new Map()), z = $n((L) => {
    if (r) {
      const k = /* @__PURE__ */ new Map();
      L.forEach((H) => {
        let q = w(H);
        !q && _.current.has(H) && (q = _.current.get(H)), k.set(H, q);
      }), _.current = k;
    }
  }, [w, r]);
  a.useEffect(() => {
    z($);
  }, [$]);
  const B = kt(() => al(y, x), [y, x]), {
    keyEntities: W
  } = kt(() => {
    if (C)
      return {
        keyEntities: null
      };
    let L = E;
    if (r) {
      const k = new Set(B.map((q, A) => N(q, A))), H = Array.from(_.current).reduce((q, [A, j]) => k.has(A) ? q : q.concat(j), []);
      L = [].concat(_e(L), _e(H));
    }
    return oo(L, {
      externalGetKey: N,
      childrenPropName: y
    });
  }, [E, N, C, y, r, B]), X = kt(() => {
    const L = /* @__PURE__ */ new Map();
    return B.forEach((k, H) => {
      const q = N(k, H), A = (i ? i(k) : null) || {};
      L.set(q, A), process.env.NODE_ENV !== "production" && O(!("checked" in A || "defaultChecked" in A), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.");
    }), L;
  }, [B, N, i]), Y = $n((L) => {
    const k = N(L);
    let H;
    return X.has(k) ? H = X.get(N(L)) : H = i ? i(L) : void 0, !!(H != null && H.disabled);
  }, [X, N]), [ee, ie] = kt(() => {
    if (C)
      return [$ || [], []];
    const {
      checkedKeys: L,
      halfCheckedKeys: k
    } = On($, !0, W, Y);
    return [L || [], k];
  }, [$, C, W, Y]), ue = kt(() => {
    const L = u === "radio" ? ee.slice(0, 1) : ee;
    return new Set(L);
  }, [ee, u]), xe = kt(() => u === "radio" ? /* @__PURE__ */ new Set() : new Set(ie), [ie, u]);
  a.useEffect(() => {
    t || D(fa);
  }, [!!t]);
  const Z = $n((L, k) => {
    let H, q;
    z(L), r ? (H = L, q = L.map((A) => _.current.get(A))) : (H = [], q = [], L.forEach((A) => {
      const j = w(A);
      j !== void 0 && (H.push(A), q.push(j));
    })), D(H), c == null || c(H, q, {
      type: k
    });
  }, [D, w, c, r]), ae = $n((L, k, H, q) => {
    if (l) {
      const A = H.map((j) => w(j));
      l(w(L), k, A, q);
    }
    Z(H, "single");
  }, [l, w, Z]), me = kt(() => !g || h ? null : (g === !0 ? [Kr, Br, zr] : g).map((k) => k === Kr ? {
    key: "all",
    text: M.selectionAll,
    onSelect() {
      Z(E.map((H, q) => N(H, q)).filter((H) => {
        const q = X.get(H);
        return !(q != null && q.disabled) || ue.has(H);
      }), "all");
    }
  } : k === Br ? {
    key: "invert",
    text: M.selectInvert,
    onSelect() {
      const H = new Set(ue);
      x.forEach((A, j) => {
        const fe = N(A, j), te = X.get(fe);
        te != null && te.disabled || (H.has(fe) ? H.delete(fe) : H.add(fe));
      });
      const q = Array.from(H);
      s && (O.deprecated(!1, "onSelectInvert", "onChange"), s(q)), Z(q, "invert");
    }
  } : k === zr ? {
    key: "none",
    text: M.selectNone,
    onSelect() {
      v == null || v(), Z(Array.from(ue).filter((H) => {
        const q = X.get(H);
        return q == null ? void 0 : q.disabled;
      }), "none");
    }
  } : k).map((k) => Object.assign(Object.assign({}, k), {
    onSelect: (...H) => {
      var q, A;
      (A = k.onSelect) === null || A === void 0 || (q = A).call.apply(q, [k].concat(H)), P(null);
    }
  })), [g, ue, x, N, s, Z]);
  return [$n((L) => {
    var k;
    if (!t)
      return process.env.NODE_ENV !== "production" && O(!L.includes(Qt), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`."), L.filter((he) => he !== Qt);
    let H = _e(L);
    const q = new Set(ue), A = B.map(N).filter((he) => !X.get(he).disabled), j = A.every((he) => q.has(he)), fe = A.some((he) => q.has(he)), te = () => {
      const he = [];
      j ? A.forEach((J) => {
        q.delete(J), he.push(J);
      }) : A.forEach((J) => {
        q.has(J) || (q.add(J), he.push(J));
      });
      const ne = Array.from(q);
      d == null || d(!j, ne.map((J) => w(J)), he.map((J) => w(J))), Z(ne, "all"), P(null);
    };
    let Ne, Ee;
    if (u !== "radio") {
      let he;
      if (me) {
        const ve = {
          getPopupContainer: T,
          items: me.map((tt, De) => {
            const {
              key: at,
              text: je,
              onSelect: dt
            } = tt;
            return {
              key: at ?? De,
              onClick: () => {
                dt == null || dt(A);
              },
              label: je
            };
          })
        };
        he = /* @__PURE__ */ a.createElement("div", {
          className: `${S}-selection-extra`
        }, /* @__PURE__ */ a.createElement(Pa, {
          menu: ve,
          getPopupContainer: T
        }, /* @__PURE__ */ a.createElement("span", null, /* @__PURE__ */ a.createElement(Wl, null))));
      }
      const ne = B.map((ve, tt) => {
        const De = N(ve, tt), at = X.get(De) || {};
        return Object.assign({
          checked: q.has(De)
        }, at);
      }).filter(({
        disabled: ve
      }) => ve), J = !!ne.length && ne.length === B.length, ke = J && ne.every(({
        checked: ve
      }) => ve), Te = J && ne.some(({
        checked: ve
      }) => ve);
      Ee = /* @__PURE__ */ a.createElement(yn, {
        checked: J ? ke : !!B.length && j,
        indeterminate: J ? !ke && Te : !j && fe,
        onChange: te,
        disabled: B.length === 0 || J,
        "aria-label": he ? "Custom selection" : "Select all",
        skipGroup: !0
      }), Ne = !h && /* @__PURE__ */ a.createElement("div", {
        className: `${S}-selection`
      }, Ee, he);
    }
    let V;
    u === "radio" ? V = (he, ne, J) => {
      const ke = N(ne, J), Te = q.has(ke), ve = X.get(ke);
      return {
        node: /* @__PURE__ */ a.createElement(Xn, Object.assign({}, ve, {
          checked: Te,
          onClick: (tt) => {
            var De;
            tt.stopPropagation(), (De = ve == null ? void 0 : ve.onClick) === null || De === void 0 || De.call(ve, tt);
          },
          onChange: (tt) => {
            var De;
            q.has(ke) || ae(ke, !0, [ke], tt.nativeEvent), (De = ve == null ? void 0 : ve.onChange) === null || De === void 0 || De.call(ve, tt);
          }
        })),
        checked: Te
      };
    } : V = (he, ne, J) => {
      var ke;
      const Te = N(ne, J), ve = q.has(Te), tt = xe.has(Te), De = X.get(Te);
      let at;
      return I === "nest" ? (at = tt, process.env.NODE_ENV !== "production" && O(typeof (De == null ? void 0 : De.indeterminate) != "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.")) : at = (ke = De == null ? void 0 : De.indeterminate) !== null && ke !== void 0 ? ke : tt, {
        node: /* @__PURE__ */ a.createElement(yn, Object.assign({}, De, {
          indeterminate: at,
          checked: ve,
          skipGroup: !0,
          onClick: (je) => {
            var dt;
            je.stopPropagation(), (dt = De == null ? void 0 : De.onClick) === null || dt === void 0 || dt.call(De, je);
          },
          onChange: (je) => {
            var dt;
            const {
              nativeEvent: ut
            } = je, {
              shiftKey: xt
            } = ut, Ue = A.findIndex((it) => it === Te), Tt = ee.some((it) => A.includes(it));
            if (xt && C && Tt) {
              const it = R(Ue, A, q), lt = Array.from(q);
              f == null || f(!ve, lt.map((ft) => w(ft)), it.map((ft) => w(ft))), Z(lt, "multiple");
            } else {
              const it = ee;
              if (C) {
                const lt = ve ? Jt(it, Te) : sn(it, Te);
                ae(Te, !ve, lt, ut);
              } else {
                const lt = On([].concat(_e(it), [Te]), !0, W, Y), {
                  checkedKeys: ft,
                  halfCheckedKeys: ot
                } = lt;
                let Ae = ft;
                if (ve) {
                  const vt = new Set(ft);
                  vt.delete(Te), Ae = On(Array.from(vt), {
                    checked: !1,
                    halfCheckedKeys: ot
                  }, W, Y).checkedKeys;
                }
                ae(Te, !ve, Ae, ut);
              }
            }
            P(ve ? null : Ue), (dt = De == null ? void 0 : De.onChange) === null || dt === void 0 || dt.call(De, je);
          }
        })),
        checked: ve
      };
    };
    const G = (he, ne, J) => {
      const {
        node: ke,
        checked: Te
      } = V(he, ne, J);
      return m ? m(Te, ne, J, ke) : ke;
    };
    if (!H.includes(Qt))
      if (H.findIndex((he) => {
        var ne;
        return ((ne = he[jn]) === null || ne === void 0 ? void 0 : ne.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [he, ...ne] = H;
        H = [he, Qt].concat(_e(ne));
      } else
        H = [Qt].concat(_e(H));
    const Ce = H.indexOf(Qt);
    process.env.NODE_ENV !== "production" && O(H.filter((he) => he === Qt).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`."), H = H.filter((he, ne) => he !== Qt || ne === Ce);
    const be = H[Ce - 1], $e = H[Ce + 1];
    let qe = b;
    qe === void 0 && (($e == null ? void 0 : $e.fixed) !== void 0 ? qe = $e.fixed : (be == null ? void 0 : be.fixed) !== void 0 && (qe = be.fixed)), qe && be && ((k = be[jn]) === null || k === void 0 ? void 0 : k.columnType) === "EXPAND_COLUMN" && be.fixed === void 0 && (be.fixed = qe);
    const Oe = Q(`${S}-selection-col`, {
      [`${S}-selection-col-with-dropdown`]: g && u === "checkbox"
    }), He = () => t != null && t.columnTitle ? typeof t.columnTitle == "function" ? t.columnTitle(Ee) : t.columnTitle : Ne, Se = {
      fixed: qe,
      width: p,
      className: `${S}-selection-column`,
      title: He(),
      render: G,
      onCell: t.onCell,
      align: t.align,
      [jn]: {
        className: Oe
      }
    };
    return H.map((he) => he === Qt ? Se : he);
  }, [N, B, t, ee, ue, xe, p, me, I, X, f, ae, Y]), ue];
};
function Df(e, t) {
  return e._antProxy = e._antProxy || {}, Object.keys(t).forEach((r) => {
    if (!(r in e._antProxy)) {
      const n = e[r];
      e._antProxy[r] = n, e[r] = t[r];
    }
  }), e;
}
function Tf(e, t) {
  return Ta(e, () => {
    const r = t(), {
      nativeElement: n
    } = r;
    return typeof Proxy < "u" ? new Proxy(n, {
      get(o, i) {
        return r[i] ? r[i] : Reflect.get(o, i);
      }
    }) : Df(n, r);
  });
}
function Mf(e) {
  return (t) => {
    const {
      prefixCls: r,
      onExpand: n,
      record: o,
      expanded: i,
      expandable: c
    } = t, l = `${r}-row-expand-icon`;
    return /* @__PURE__ */ a.createElement("button", {
      type: "button",
      onClick: (d) => {
        n(o, d), d.stopPropagation();
      },
      className: Q(l, {
        [`${l}-spaced`]: !c,
        [`${l}-expanded`]: c && i,
        [`${l}-collapsed`]: c && !i
      }),
      "aria-label": i ? e.collapse : e.expand,
      "aria-expanded": i
    });
  };
}
function _f(e) {
  return (r, n) => {
    const o = r.querySelector(`.${e}-container`);
    let i = n;
    if (o) {
      const c = getComputedStyle(o), l = parseInt(c.borderLeftWidth, 10), d = parseInt(c.borderRightWidth, 10);
      i = n - l - d;
    }
    return i;
  };
}
const vn = (e, t) => "key" in e && e.key !== void 0 && e.key !== null ? e.key : e.dataIndex ? Array.isArray(e.dataIndex) ? e.dataIndex.join(".") : e.dataIndex : t;
function zn(e, t) {
  return t ? `${t}-${e}` : `${e}`;
}
const dr = (e, t) => typeof e == "function" ? e(t) : e, kf = (e, t) => {
  const r = dr(e, t);
  return Object.prototype.toString.call(r) === "[object Object]" ? "" : r;
};
function Kf(e) {
  const t = a.useRef(e), r = Xl();
  return [() => t.current, (n) => {
    t.current = n, r();
  }];
}
var il = function(t) {
  var r = t.dropPosition, n = t.dropLevelOffset, o = t.indent, i = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (r) {
    case -1:
      i.top = 0, i.left = -n * o;
      break;
    case 1:
      i.bottom = 0, i.left = -n * o;
      break;
    case 0:
      i.bottom = 0, i.left = o;
      break;
  }
  return /* @__PURE__ */ oe.createElement("div", {
    style: i
  });
};
process.env.NODE_ENV !== "production" && (il.displayName = "DropIndicator");
function ll(e) {
  if (e == null) throw new TypeError("Cannot destructure " + e);
}
function Bf(e, t) {
  var r = a.useState(!1), n = ce(r, 2), o = n[0], i = n[1];
  Mt(function() {
    if (o)
      return e(), function() {
        t();
      };
  }, [o]), Mt(function() {
    return i(!0), function() {
      i(!1);
    };
  }, []);
}
var zf = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], sl = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.className, n = e.style, o = e.motion, i = e.motionNodes, c = e.motionType, l = e.onMotionStart, d = e.onMotionEnd, s = e.active, v = e.treeNodeRequiredProps, f = yt(e, zf), p = a.useState(!0), u = ce(p, 2), g = u[0], b = u[1], m = a.useContext(po), h = m.prefixCls, C = i && c !== "hide";
  Mt(function() {
    i && C !== g && b(C);
  }, [i]);
  var S = function() {
    i && l();
  }, E = a.useRef(!1), x = function() {
    i && !E.current && (E.current = !0, d());
  };
  Bf(S, x);
  var w = function(I) {
    C === I && x();
  };
  return i ? /* @__PURE__ */ a.createElement(Pl, Pe({
    ref: t,
    visible: g
  }, o, {
    motionAppear: c === "show",
    onVisibleChanged: w
  }), function(N, I) {
    var y = N.className, M = N.style;
    return /* @__PURE__ */ a.createElement("div", {
      ref: I,
      className: Q("".concat(h, "-treenode-motion"), y),
      style: M
    }, i.map(function(T) {
      var O = Object.assign({}, (ll(T.data), T.data)), R = T.title, P = T.key, $ = T.isStart, D = T.isEnd;
      delete O.children;
      var _ = Hn(P, v);
      return /* @__PURE__ */ a.createElement(Tn, Pe({}, O, _, {
        title: R,
        active: s,
        data: T.data,
        key: P,
        isStart: $,
        isEnd: D
      }));
    }));
  }) : /* @__PURE__ */ a.createElement(Tn, Pe({
    domRef: t,
    className: r,
    style: n
  }, f, {
    active: s
  }));
});
process.env.NODE_ENV !== "production" && (sl.displayName = "MotionTreeNode");
function Lf() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.length, n = t.length;
  if (Math.abs(r - n) !== 1)
    return {
      add: !1,
      key: null
    };
  function o(i, c) {
    var l = /* @__PURE__ */ new Map();
    i.forEach(function(s) {
      l.set(s, !0);
    });
    var d = c.filter(function(s) {
      return !l.has(s);
    });
    return d.length === 1 ? d[0] : null;
  }
  return r < n ? {
    add: !0,
    key: o(e, t)
  } : {
    add: !1,
    key: o(t, e)
  };
}
function va(e, t, r) {
  var n = e.findIndex(function(l) {
    return l.key === r;
  }), o = e[n + 1], i = t.findIndex(function(l) {
    return l.key === r;
  });
  if (o) {
    var c = t.findIndex(function(l) {
      return l.key === o.key;
    });
    return t.slice(i + 1, c);
  }
  return t.slice(i + 1);
}
var Hf = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "scrollWidth", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], pa = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, jf = function() {
}, Cn = "RC_TREE_MOTION_".concat(Math.random()), Lr = {
  key: Cn
}, cl = {
  key: Cn,
  level: 0,
  index: 0,
  pos: "0",
  node: Lr,
  nodes: [Lr]
}, ma = {
  parent: null,
  children: [],
  pos: cl.pos,
  data: Lr,
  title: null,
  key: Cn,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function ga(e, t, r, n) {
  return t === !1 || !r ? e : e.slice(0, Math.ceil(r / n) + 1);
}
function ha(e) {
  var t = e.key, r = e.pos;
  return Un(t, r);
}
function Vf(e) {
  for (var t = String(e.data.key), r = e; r.parent; )
    r = r.parent, t = "".concat(r.data.key, " > ").concat(t);
  return t;
}
var dl = /* @__PURE__ */ a.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.data;
  e.selectable, e.checkable;
  var o = e.expandedKeys, i = e.selectedKeys, c = e.checkedKeys, l = e.loadedKeys, d = e.loadingKeys, s = e.halfCheckedKeys, v = e.keyEntities, f = e.disabled, p = e.dragging, u = e.dragOverNodeKey, g = e.dropPosition, b = e.motion, m = e.height, h = e.itemHeight, C = e.virtual, S = e.scrollWidth, E = e.focusable, x = e.activeItem, w = e.focused, N = e.tabIndex, I = e.onKeyDown, y = e.onFocus, M = e.onBlur, T = e.onActiveChange, O = e.onListChangeStart, R = e.onListChangeEnd, P = yt(e, Hf), $ = a.useRef(null), D = a.useRef(null);
  a.useImperativeHandle(t, function() {
    return {
      scrollTo: function(G) {
        $.current.scrollTo(G);
      },
      getIndentWidth: function() {
        return D.current.offsetWidth;
      }
    };
  });
  var _ = a.useState(o), z = ce(_, 2), B = z[0], W = z[1], X = a.useState(n), Y = ce(X, 2), ee = Y[0], ie = Y[1], ue = a.useState(n), xe = ce(ue, 2), Z = xe[0], ae = xe[1], me = a.useState([]), ye = ce(me, 2), L = ye[0], k = ye[1], H = a.useState(null), q = ce(H, 2), A = q[0], j = q[1], fe = a.useRef(n);
  fe.current = n;
  function te() {
    var V = fe.current;
    ie(V), ae(V), k([]), j(null), R();
  }
  Mt(function() {
    W(o);
    var V = Lf(B, o);
    if (V.key !== null)
      if (V.add) {
        var G = ee.findIndex(function(He) {
          var Se = He.key;
          return Se === V.key;
        }), Ce = ga(va(ee, n, V.key), C, m, h), be = ee.slice();
        be.splice(G + 1, 0, ma), ae(be), k(Ce), j("show");
      } else {
        var $e = n.findIndex(function(He) {
          var Se = He.key;
          return Se === V.key;
        }), qe = ga(va(n, ee, V.key), C, m, h), Oe = n.slice();
        Oe.splice($e + 1, 0, ma), ae(Oe), k(qe), j("hide");
      }
    else ee !== n && (ie(n), ae(n));
  }, [o, n]), a.useEffect(function() {
    p || te();
  }, [p]);
  var Ne = b ? Z : n, Ee = {
    expandedKeys: o,
    selectedKeys: i,
    loadedKeys: l,
    loadingKeys: d,
    checkedKeys: c,
    halfCheckedKeys: s,
    dragOverNodeKey: u,
    dropPosition: g,
    keyEntities: v
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, w && x && /* @__PURE__ */ a.createElement("span", {
    style: pa,
    "aria-live": "assertive"
  }, Vf(x)), /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("input", {
    style: pa,
    disabled: E === !1 || f,
    tabIndex: E !== !1 ? N : null,
    onKeyDown: I,
    onFocus: y,
    onBlur: M,
    value: "",
    onChange: jf,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ a.createElement("div", {
    className: "".concat(r, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ a.createElement("div", {
    className: "".concat(r, "-indent")
  }, /* @__PURE__ */ a.createElement("div", {
    ref: D,
    className: "".concat(r, "-indent-unit")
  }))), /* @__PURE__ */ a.createElement(lr, Pe({}, P, {
    data: Ne,
    itemKey: ha,
    height: m,
    fullHeight: !1,
    virtual: C,
    itemHeight: h,
    scrollWidth: S,
    prefixCls: "".concat(r, "-list"),
    ref: $,
    role: "tree",
    onVisibleChange: function(G) {
      G.every(function(Ce) {
        return ha(Ce) !== Cn;
      }) && te();
    }
  }), function(V) {
    var G = V.pos, Ce = Object.assign({}, (ll(V.data), V.data)), be = V.title, $e = V.key, qe = V.isStart, Oe = V.isEnd, He = Un($e, G);
    delete Ce.key, delete Ce.children;
    var Se = Hn(He, Ee);
    return /* @__PURE__ */ a.createElement(sl, Pe({}, Ce, Se, {
      title: be,
      active: !!x && $e === x.key,
      pos: G,
      data: V.data,
      isStart: qe,
      isEnd: Oe,
      motion: b,
      motionNodes: $e === Cn ? L : null,
      motionType: A,
      onMotionStart: O,
      onMotionEnd: te,
      treeNodeRequiredProps: Ee,
      onMouseMove: function() {
        T(null);
      }
    }));
  }));
});
process.env.NODE_ENV !== "production" && (dl.displayName = "NodeList");
var Af = 10, go = /* @__PURE__ */ function(e) {
  Dl(r, e);
  var t = Tl(r);
  function r() {
    var n;
    _a(this, r);
    for (var o = arguments.length, i = new Array(o), c = 0; c < o; c++)
      i[c] = arguments[c];
    return n = t.call.apply(t, [this].concat(i)), K(Xe(n), "destroyed", !1), K(Xe(n), "delayedDragEnterLogic", void 0), K(Xe(n), "loadingRetryTimes", {}), K(Xe(n), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: Dn()
    }), K(Xe(n), "dragStartMousePosition", null), K(Xe(n), "dragNodeProps", null), K(Xe(n), "currentMouseOverDroppableNodeKey", null), K(Xe(n), "listRef", /* @__PURE__ */ a.createRef()), K(Xe(n), "onNodeDragStart", function(l, d) {
      var s = n.state, v = s.expandedKeys, f = s.keyEntities, p = n.props.onDragStart, u = d.eventKey;
      n.dragNodeProps = d, n.dragStartMousePosition = {
        x: l.clientX,
        y: l.clientY
      };
      var g = Jt(v, u);
      n.setState({
        draggingNodeKey: u,
        dragChildrenKeys: Nf(u, f),
        indent: n.listRef.current.getIndentWidth()
      }), n.setExpandedKeys(g), window.addEventListener("dragend", n.onWindowDragEnd), p == null || p({
        event: l,
        node: bt(d)
      });
    }), K(Xe(n), "onNodeDragEnter", function(l, d) {
      var s = n.state, v = s.expandedKeys, f = s.keyEntities, p = s.dragChildrenKeys, u = s.flattenNodes, g = s.indent, b = n.props, m = b.onDragEnter, h = b.onExpand, C = b.allowDrop, S = b.direction, E = d.pos, x = d.eventKey;
      if (n.currentMouseOverDroppableNodeKey !== x && (n.currentMouseOverDroppableNodeKey = x), !n.dragNodeProps) {
        n.resetDragState();
        return;
      }
      var w = da(l, n.dragNodeProps, d, g, n.dragStartMousePosition, C, u, f, v, S), N = w.dropPosition, I = w.dropLevelOffset, y = w.dropTargetKey, M = w.dropContainerKey, T = w.dropTargetPos, O = w.dropAllowed, R = w.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        p.includes(y) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !O
      ) {
        n.resetDragState();
        return;
      }
      if (n.delayedDragEnterLogic || (n.delayedDragEnterLogic = {}), Object.keys(n.delayedDragEnterLogic).forEach(function(P) {
        clearTimeout(n.delayedDragEnterLogic[P]);
      }), n.dragNodeProps.eventKey !== d.eventKey && (l.persist(), n.delayedDragEnterLogic[E] = window.setTimeout(function() {
        if (n.state.draggingNodeKey !== null) {
          var P = _e(v), $ = Kt(f, d.eventKey);
          $ && ($.children || []).length && (P = sn(v, d.eventKey)), n.props.hasOwnProperty("expandedKeys") || n.setExpandedKeys(P), h == null || h(P, {
            node: bt(d),
            expanded: !0,
            nativeEvent: l.nativeEvent
          });
        }
      }, 800)), n.dragNodeProps.eventKey === y && I === 0) {
        n.resetDragState();
        return;
      }
      n.setState({
        dragOverNodeKey: R,
        dropPosition: N,
        dropLevelOffset: I,
        dropTargetKey: y,
        dropContainerKey: M,
        dropTargetPos: T,
        dropAllowed: O
      }), m == null || m({
        event: l,
        node: bt(d),
        expandedKeys: v
      });
    }), K(Xe(n), "onNodeDragOver", function(l, d) {
      var s = n.state, v = s.dragChildrenKeys, f = s.flattenNodes, p = s.keyEntities, u = s.expandedKeys, g = s.indent, b = n.props, m = b.onDragOver, h = b.allowDrop, C = b.direction;
      if (n.dragNodeProps) {
        var S = da(l, n.dragNodeProps, d, g, n.dragStartMousePosition, h, f, p, u, C), E = S.dropPosition, x = S.dropLevelOffset, w = S.dropTargetKey, N = S.dropContainerKey, I = S.dropTargetPos, y = S.dropAllowed, M = S.dragOverNodeKey;
        v.includes(w) || !y || (n.dragNodeProps.eventKey === w && x === 0 ? n.state.dropPosition === null && n.state.dropLevelOffset === null && n.state.dropTargetKey === null && n.state.dropContainerKey === null && n.state.dropTargetPos === null && n.state.dropAllowed === !1 && n.state.dragOverNodeKey === null || n.resetDragState() : E === n.state.dropPosition && x === n.state.dropLevelOffset && w === n.state.dropTargetKey && N === n.state.dropContainerKey && I === n.state.dropTargetPos && y === n.state.dropAllowed && M === n.state.dragOverNodeKey || n.setState({
          dropPosition: E,
          dropLevelOffset: x,
          dropTargetKey: w,
          dropContainerKey: N,
          dropTargetPos: I,
          dropAllowed: y,
          dragOverNodeKey: M
        }), m == null || m({
          event: l,
          node: bt(d)
        }));
      }
    }), K(Xe(n), "onNodeDragLeave", function(l, d) {
      n.currentMouseOverDroppableNodeKey === d.eventKey && !l.currentTarget.contains(l.relatedTarget) && (n.resetDragState(), n.currentMouseOverDroppableNodeKey = null);
      var s = n.props.onDragLeave;
      s == null || s({
        event: l,
        node: bt(d)
      });
    }), K(Xe(n), "onWindowDragEnd", function(l) {
      n.onNodeDragEnd(l, null, !0), window.removeEventListener("dragend", n.onWindowDragEnd);
    }), K(Xe(n), "onNodeDragEnd", function(l, d) {
      var s = n.props.onDragEnd;
      n.setState({
        dragOverNodeKey: null
      }), n.cleanDragState(), s == null || s({
        event: l,
        node: bt(d)
      }), n.dragNodeProps = null, window.removeEventListener("dragend", n.onWindowDragEnd);
    }), K(Xe(n), "onNodeDrop", function(l, d) {
      var s, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, f = n.state, p = f.dragChildrenKeys, u = f.dropPosition, g = f.dropTargetKey, b = f.dropTargetPos, m = f.dropAllowed;
      if (m) {
        var h = n.props.onDrop;
        if (n.setState({
          dragOverNodeKey: null
        }), n.cleanDragState(), g !== null) {
          var C = F(F({}, Hn(g, n.getTreeNodeRequiredProps())), {}, {
            active: ((s = n.getActiveItem()) === null || s === void 0 ? void 0 : s.key) === g,
            data: Kt(n.state.keyEntities, g).node
          }), S = p.includes(g);
          Qe(!S, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var E = mo(b), x = {
            event: l,
            node: bt(C),
            dragNode: n.dragNodeProps ? bt(n.dragNodeProps) : null,
            dragNodesKeys: [n.dragNodeProps.eventKey].concat(p),
            dropToGap: u !== 0,
            dropPosition: u + Number(E[E.length - 1])
          };
          v || h == null || h(x), n.dragNodeProps = null;
        }
      }
    }), K(Xe(n), "cleanDragState", function() {
      var l = n.state.draggingNodeKey;
      l !== null && n.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), n.dragStartMousePosition = null, n.currentMouseOverDroppableNodeKey = null;
    }), K(Xe(n), "triggerExpandActionExpand", function(l, d) {
      var s = n.state, v = s.expandedKeys, f = s.flattenNodes, p = d.expanded, u = d.key, g = d.isLeaf;
      if (!(g || l.shiftKey || l.metaKey || l.ctrlKey)) {
        var b = f.filter(function(h) {
          return h.key === u;
        })[0], m = bt(F(F({}, Hn(u, n.getTreeNodeRequiredProps())), {}, {
          data: b.data
        }));
        n.setExpandedKeys(p ? Jt(v, u) : sn(v, u)), n.onNodeExpand(l, m);
      }
    }), K(Xe(n), "onNodeClick", function(l, d) {
      var s = n.props, v = s.onClick, f = s.expandAction;
      f === "click" && n.triggerExpandActionExpand(l, d), v == null || v(l, d);
    }), K(Xe(n), "onNodeDoubleClick", function(l, d) {
      var s = n.props, v = s.onDoubleClick, f = s.expandAction;
      f === "doubleClick" && n.triggerExpandActionExpand(l, d), v == null || v(l, d);
    }), K(Xe(n), "onNodeSelect", function(l, d) {
      var s = n.state.selectedKeys, v = n.state, f = v.keyEntities, p = v.fieldNames, u = n.props, g = u.onSelect, b = u.multiple, m = d.selected, h = d[p.key], C = !m;
      C ? b ? s = sn(s, h) : s = [h] : s = Jt(s, h);
      var S = s.map(function(E) {
        var x = Kt(f, E);
        return x ? x.node : null;
      }).filter(Boolean);
      n.setUncontrolledState({
        selectedKeys: s
      }), g == null || g(s, {
        event: "select",
        selected: C,
        node: d,
        selectedNodes: S,
        nativeEvent: l.nativeEvent
      });
    }), K(Xe(n), "onNodeCheck", function(l, d, s) {
      var v = n.state, f = v.keyEntities, p = v.checkedKeys, u = v.halfCheckedKeys, g = n.props, b = g.checkStrictly, m = g.onCheck, h = d.key, C, S = {
        event: "check",
        node: d,
        checked: s,
        nativeEvent: l.nativeEvent
      };
      if (b) {
        var E = s ? sn(p, h) : Jt(p, h), x = Jt(u, h);
        C = {
          checked: E,
          halfChecked: x
        }, S.checkedNodes = E.map(function(T) {
          return Kt(f, T);
        }).filter(Boolean).map(function(T) {
          return T.node;
        }), n.setUncontrolledState({
          checkedKeys: E
        });
      } else {
        var w = On([].concat(_e(p), [h]), !0, f), N = w.checkedKeys, I = w.halfCheckedKeys;
        if (!s) {
          var y = new Set(N);
          y.delete(h);
          var M = On(Array.from(y), {
            checked: !1,
            halfCheckedKeys: I
          }, f);
          N = M.checkedKeys, I = M.halfCheckedKeys;
        }
        C = N, S.checkedNodes = [], S.checkedNodesPositions = [], S.halfCheckedKeys = I, N.forEach(function(T) {
          var O = Kt(f, T);
          if (O) {
            var R = O.node, P = O.pos;
            S.checkedNodes.push(R), S.checkedNodesPositions.push({
              node: R,
              pos: P
            });
          }
        }), n.setUncontrolledState({
          checkedKeys: N
        }, !1, {
          halfCheckedKeys: I
        });
      }
      m == null || m(C, S);
    }), K(Xe(n), "onNodeLoad", function(l) {
      var d, s = l.key, v = n.state.keyEntities, f = Kt(v, s);
      if (!(f != null && (d = f.children) !== null && d !== void 0 && d.length)) {
        var p = new Promise(function(u, g) {
          n.setState(function(b) {
            var m = b.loadedKeys, h = m === void 0 ? [] : m, C = b.loadingKeys, S = C === void 0 ? [] : C, E = n.props, x = E.loadData, w = E.onLoad;
            if (!x || h.includes(s) || S.includes(s))
              return null;
            var N = x(l);
            return N.then(function() {
              var I = n.state.loadedKeys, y = sn(I, s);
              w == null || w(y, {
                event: "load",
                node: l
              }), n.setUncontrolledState({
                loadedKeys: y
              }), n.setState(function(M) {
                return {
                  loadingKeys: Jt(M.loadingKeys, s)
                };
              }), u();
            }).catch(function(I) {
              if (n.setState(function(M) {
                return {
                  loadingKeys: Jt(M.loadingKeys, s)
                };
              }), n.loadingRetryTimes[s] = (n.loadingRetryTimes[s] || 0) + 1, n.loadingRetryTimes[s] >= Af) {
                var y = n.state.loadedKeys;
                Qe(!1, "Retry for `loadData` many times but still failed. No more retry."), n.setUncontrolledState({
                  loadedKeys: sn(y, s)
                }), u();
              }
              g(I);
            }), {
              loadingKeys: sn(S, s)
            };
          });
        });
        return p.catch(function() {
        }), p;
      }
    }), K(Xe(n), "onNodeMouseEnter", function(l, d) {
      var s = n.props.onMouseEnter;
      s == null || s({
        event: l,
        node: d
      });
    }), K(Xe(n), "onNodeMouseLeave", function(l, d) {
      var s = n.props.onMouseLeave;
      s == null || s({
        event: l,
        node: d
      });
    }), K(Xe(n), "onNodeContextMenu", function(l, d) {
      var s = n.props.onRightClick;
      s && (l.preventDefault(), s({
        event: l,
        node: d
      }));
    }), K(Xe(n), "onFocus", function() {
      var l = n.props.onFocus;
      n.setState({
        focused: !0
      });
      for (var d = arguments.length, s = new Array(d), v = 0; v < d; v++)
        s[v] = arguments[v];
      l == null || l.apply(void 0, s);
    }), K(Xe(n), "onBlur", function() {
      var l = n.props.onBlur;
      n.setState({
        focused: !1
      }), n.onActiveChange(null);
      for (var d = arguments.length, s = new Array(d), v = 0; v < d; v++)
        s[v] = arguments[v];
      l == null || l.apply(void 0, s);
    }), K(Xe(n), "getTreeNodeRequiredProps", function() {
      var l = n.state, d = l.expandedKeys, s = l.selectedKeys, v = l.loadedKeys, f = l.loadingKeys, p = l.checkedKeys, u = l.halfCheckedKeys, g = l.dragOverNodeKey, b = l.dropPosition, m = l.keyEntities;
      return {
        expandedKeys: d || [],
        selectedKeys: s || [],
        loadedKeys: v || [],
        loadingKeys: f || [],
        checkedKeys: p || [],
        halfCheckedKeys: u || [],
        dragOverNodeKey: g,
        dropPosition: b,
        keyEntities: m
      };
    }), K(Xe(n), "setExpandedKeys", function(l) {
      var d = n.state, s = d.treeData, v = d.fieldNames, f = gr(s, l, v);
      n.setUncontrolledState({
        expandedKeys: l,
        flattenNodes: f
      }, !0);
    }), K(Xe(n), "onNodeExpand", function(l, d) {
      var s = n.state.expandedKeys, v = n.state, f = v.listChanging, p = v.fieldNames, u = n.props, g = u.onExpand, b = u.loadData, m = d.expanded, h = d[p.key];
      if (!f) {
        var C = s.includes(h), S = !m;
        if (Qe(m && C || !m && !C, "Expand state not sync with index check"), s = S ? sn(s, h) : Jt(s, h), n.setExpandedKeys(s), g == null || g(s, {
          node: d,
          expanded: S,
          nativeEvent: l.nativeEvent
        }), S && b) {
          var E = n.onNodeLoad(d);
          E && E.then(function() {
            var x = gr(n.state.treeData, s, p);
            n.setUncontrolledState({
              flattenNodes: x
            });
          }).catch(function() {
            var x = n.state.expandedKeys, w = Jt(x, h);
            n.setExpandedKeys(w);
          });
        }
      }
    }), K(Xe(n), "onListChangeStart", function() {
      n.setUncontrolledState({
        listChanging: !0
      });
    }), K(Xe(n), "onListChangeEnd", function() {
      setTimeout(function() {
        n.setUncontrolledState({
          listChanging: !1
        });
      });
    }), K(Xe(n), "onActiveChange", function(l) {
      var d = n.state.activeKey, s = n.props, v = s.onActiveChange, f = s.itemScrollOffset, p = f === void 0 ? 0 : f;
      d !== l && (n.setState({
        activeKey: l
      }), l !== null && n.scrollTo({
        key: l,
        offset: p
      }), v == null || v(l));
    }), K(Xe(n), "getActiveItem", function() {
      var l = n.state, d = l.activeKey, s = l.flattenNodes;
      return d === null ? null : s.find(function(v) {
        var f = v.key;
        return f === d;
      }) || null;
    }), K(Xe(n), "offsetActiveKey", function(l) {
      var d = n.state, s = d.flattenNodes, v = d.activeKey, f = s.findIndex(function(g) {
        var b = g.key;
        return b === v;
      });
      f === -1 && l < 0 && (f = s.length), f = (f + l + s.length) % s.length;
      var p = s[f];
      if (p) {
        var u = p.key;
        n.onActiveChange(u);
      } else
        n.onActiveChange(null);
    }), K(Xe(n), "onKeyDown", function(l) {
      var d = n.state, s = d.activeKey, v = d.expandedKeys, f = d.checkedKeys, p = d.fieldNames, u = n.props, g = u.onKeyDown, b = u.checkable, m = u.selectable;
      switch (l.which) {
        case Ie.UP: {
          n.offsetActiveKey(-1), l.preventDefault();
          break;
        }
        case Ie.DOWN: {
          n.offsetActiveKey(1), l.preventDefault();
          break;
        }
      }
      var h = n.getActiveItem();
      if (h && h.data) {
        var C = n.getTreeNodeRequiredProps(), S = h.data.isLeaf === !1 || !!(h.data[p.children] || []).length, E = bt(F(F({}, Hn(s, C)), {}, {
          data: h.data,
          active: !0
        }));
        switch (l.which) {
          case Ie.LEFT: {
            S && v.includes(s) ? n.onNodeExpand({}, E) : h.parent && n.onActiveChange(h.parent.key), l.preventDefault();
            break;
          }
          case Ie.RIGHT: {
            S && !v.includes(s) ? n.onNodeExpand({}, E) : h.children && h.children.length && n.onActiveChange(h.children[0].key), l.preventDefault();
            break;
          }
          case Ie.ENTER:
          case Ie.SPACE: {
            b && !E.disabled && E.checkable !== !1 && !E.disableCheckbox ? n.onNodeCheck({}, E, !f.includes(s)) : !b && m && !E.disabled && E.selectable !== !1 && n.onNodeSelect({}, E);
            break;
          }
        }
      }
      g == null || g(l);
    }), K(Xe(n), "setUncontrolledState", function(l) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!n.destroyed) {
        var v = !1, f = !0, p = {};
        Object.keys(l).forEach(function(u) {
          if (n.props.hasOwnProperty(u)) {
            f = !1;
            return;
          }
          v = !0, p[u] = l[u];
        }), v && (!d || f) && n.setState(F(F({}, p), s));
      }
    }), K(Xe(n), "scrollTo", function(l) {
      n.listRef.current.scrollTo(l);
    }), n;
  }
  return Ma(r, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var o = this.props, i = o.activeKey, c = o.itemScrollOffset, l = c === void 0 ? 0 : c;
      i !== void 0 && i !== this.state.activeKey && (this.setState({
        activeKey: i
      }), i !== null && this.scrollTo({
        key: i,
        offset: l
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state, i = o.focused, c = o.flattenNodes, l = o.keyEntities, d = o.draggingNodeKey, s = o.activeKey, v = o.dropLevelOffset, f = o.dropContainerKey, p = o.dropTargetKey, u = o.dropPosition, g = o.dragOverNodeKey, b = o.indent, m = this.props, h = m.prefixCls, C = m.className, S = m.style, E = m.showLine, x = m.focusable, w = m.tabIndex, N = w === void 0 ? 0 : w, I = m.selectable, y = m.showIcon, M = m.icon, T = m.switcherIcon, O = m.draggable, R = m.checkable, P = m.checkStrictly, $ = m.disabled, D = m.motion, _ = m.loadData, z = m.filterTreeNode, B = m.height, W = m.itemHeight, X = m.scrollWidth, Y = m.virtual, ee = m.titleRender, ie = m.dropIndicatorRender, ue = m.onContextMenu, xe = m.onScroll, Z = m.direction, ae = m.rootClassName, me = m.rootStyle, ye = nn(this.props, {
        aria: !0,
        data: !0
      }), L;
      O && (St(O) === "object" ? L = O : typeof O == "function" ? L = {
        nodeDraggable: O
      } : L = {});
      var k = {
        prefixCls: h,
        selectable: I,
        showIcon: y,
        icon: M,
        switcherIcon: T,
        draggable: L,
        draggingNodeKey: d,
        checkable: R,
        checkStrictly: P,
        disabled: $,
        keyEntities: l,
        dropLevelOffset: v,
        dropContainerKey: f,
        dropTargetKey: p,
        dropPosition: u,
        dragOverNodeKey: g,
        indent: b,
        direction: Z,
        dropIndicatorRender: ie,
        loadData: _,
        filterTreeNode: z,
        titleRender: ee,
        onNodeClick: this.onNodeClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeLoad: this.onNodeLoad,
        onNodeMouseEnter: this.onNodeMouseEnter,
        onNodeMouseLeave: this.onNodeMouseLeave,
        onNodeContextMenu: this.onNodeContextMenu,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop
      };
      return /* @__PURE__ */ a.createElement(po.Provider, {
        value: k
      }, /* @__PURE__ */ a.createElement("div", {
        className: Q(h, C, ae, K(K(K({}, "".concat(h, "-show-line"), E), "".concat(h, "-focused"), i), "".concat(h, "-active-focused"), s !== null)),
        style: me
      }, /* @__PURE__ */ a.createElement(dl, Pe({
        ref: this.listRef,
        prefixCls: h,
        style: S,
        data: c,
        disabled: $,
        selectable: I,
        checkable: !!R,
        motion: D,
        dragging: d !== null,
        height: B,
        itemHeight: W,
        virtual: Y,
        focusable: x,
        focused: i,
        tabIndex: N,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: ue,
        onScroll: xe,
        scrollWidth: X
      }, this.getTreeNodeRequiredProps(), ye))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, i) {
      var c = i.prevProps, l = {
        prevProps: o
      };
      function d(N) {
        return !c && o.hasOwnProperty(N) || c && c[N] !== o[N];
      }
      var s, v = i.fieldNames;
      if (d("fieldNames") && (v = Dn(o.fieldNames), l.fieldNames = v), d("treeData") ? s = o.treeData : d("children") && (Qe(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), s = vi(o.children)), s) {
        l.treeData = s;
        var f = oo(s, {
          fieldNames: v
        });
        l.keyEntities = F(K({}, Cn, cl), f.keyEntities), process.env.NODE_ENV !== "production" && dd(s, v);
      }
      var p = l.keyEntities || i.keyEntities;
      if (d("expandedKeys") || c && d("autoExpandParent"))
        l.expandedKeys = o.autoExpandParent || !c && o.defaultExpandParent ? kr(o.expandedKeys, p) : o.expandedKeys;
      else if (!c && o.defaultExpandAll) {
        var u = F({}, p);
        delete u[Cn];
        var g = [];
        Object.keys(u).forEach(function(N) {
          var I = u[N];
          I.children && I.children.length && g.push(I.key);
        }), l.expandedKeys = g;
      } else !c && o.defaultExpandedKeys && (l.expandedKeys = o.autoExpandParent || o.defaultExpandParent ? kr(o.defaultExpandedKeys, p) : o.defaultExpandedKeys);
      if (l.expandedKeys || delete l.expandedKeys, s || l.expandedKeys) {
        var b = gr(s || i.treeData, l.expandedKeys || i.expandedKeys, v);
        l.flattenNodes = b;
      }
      if (o.selectable && (d("selectedKeys") ? l.selectedKeys = ua(o.selectedKeys, o) : !c && o.defaultSelectedKeys && (l.selectedKeys = ua(o.defaultSelectedKeys, o))), o.checkable) {
        var m;
        if (d("checkedKeys") ? m = yr(o.checkedKeys) || {} : !c && o.defaultCheckedKeys ? m = yr(o.defaultCheckedKeys) || {} : s && (m = yr(o.checkedKeys) || {
          checkedKeys: i.checkedKeys,
          halfCheckedKeys: i.halfCheckedKeys
        }), m) {
          var h = m, C = h.checkedKeys, S = C === void 0 ? [] : C, E = h.halfCheckedKeys, x = E === void 0 ? [] : E;
          if (!o.checkStrictly) {
            var w = On(S, !0, p);
            S = w.checkedKeys, x = w.halfCheckedKeys;
          }
          l.checkedKeys = S, l.halfCheckedKeys = x;
        }
      }
      return d("loadedKeys") && (l.loadedKeys = o.loadedKeys), l;
    }
  }]), r;
}(a.Component);
K(go, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: il,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
K(go, "TreeNode", Tn);
const Ff = ({
  treeCls: e,
  treeNodeCls: t,
  directoryNodeSelectedBg: r,
  directoryNodeSelectedColor: n,
  motionDurationMid: o,
  borderRadius: i,
  controlItemBgHover: c
}) => ({
  [`${e}${e}-directory ${t}`]: {
    // >>> Title
    [`${e}-node-content-wrapper`]: {
      position: "static",
      [`> *:not(${e}-drop-indicator)`]: {
        position: "relative"
      },
      "&:hover": {
        background: "transparent"
      },
      // Expand interactive area to whole line
      "&:before": {
        position: "absolute",
        inset: 0,
        transition: `background-color ${o}`,
        content: '""',
        borderRadius: i
      },
      "&:hover:before": {
        background: c
      }
    },
    [`${e}-switcher, ${e}-checkbox, ${e}-draggable-icon`]: {
      zIndex: 1
    },
    // ============= Selected =============
    "&-selected": {
      [`${e}-switcher, ${e}-draggable-icon`]: {
        color: n
      },
      // >>> Title
      [`${e}-node-content-wrapper`]: {
        color: n,
        background: "transparent",
        "&:before, &:hover:before": {
          background: r
        }
      }
    }
  }
}), Wf = new Yr("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), qf = (e, t) => ({
  [`.${e}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${t.motionDurationSlow}`
    }
  }
}), Xf = (e, t) => ({
  [`.${e}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: t.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${U(t.lineWidthBold)} solid ${t.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), Uf = (e, t) => {
  const {
    treeCls: r,
    treeNodeCls: n,
    treeNodePadding: o,
    titleHeight: i,
    indentSize: c,
    nodeSelectedBg: l,
    nodeHoverBg: d,
    colorTextQuaternary: s,
    controlItemBgActiveDisabled: v
  } = t;
  return {
    [r]: Object.assign(Object.assign({}, zt(t)), {
      background: t.colorBgContainer,
      borderRadius: t.borderRadius,
      transition: `background-color ${t.motionDurationSlow}`,
      "&-rtl": {
        direction: "rtl"
      },
      [`&${r}-rtl ${r}-switcher_close ${r}-switcher-icon svg`]: {
        transform: "rotate(90deg)"
      },
      [`&-focused:not(:hover):not(${r}-active-focused)`]: Object.assign({}, Pn(t)),
      // =================== Virtual List ===================
      [`${r}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${r}-block-node`]: {
        [`${r}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${n}.dragging:after`]: {
            position: "absolute",
            inset: 0,
            border: `1px solid ${t.colorPrimary}`,
            opacity: 0,
            animationName: Wf,
            animationDuration: t.motionDurationSlow,
            animationPlayState: "running",
            animationFillMode: "forwards",
            content: '""',
            pointerEvents: "none",
            borderRadius: t.borderRadius
          }
        }
      },
      // ===================== TreeNode =====================
      [n]: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: o,
        lineHeight: U(i),
        position: "relative",
        // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
        "&:before": {
          content: '""',
          position: "absolute",
          zIndex: 1,
          insetInlineStart: 0,
          width: "100%",
          top: "100%",
          height: o
        },
        // Disabled
        [`&-disabled ${r}-node-content-wrapper`]: {
          color: t.colorTextDisabled,
          cursor: "not-allowed",
          "&:hover": {
            background: "transparent"
          }
        },
        [`${r}-checkbox-disabled + ${r}-node-selected,&${n}-disabled${n}-selected ${r}-node-content-wrapper`]: {
          backgroundColor: v
        },
        // we can not set pointer-events to none for checkbox in tree
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
        [`${r}-checkbox-disabled`]: {
          pointerEvents: "unset"
        },
        // not disable
        [`&:not(${n}-disabled)`]: {
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            "&:hover": {
              color: t.nodeHoverColor
            }
          }
        },
        [`&-active ${r}-node-content-wrapper`]: {
          background: t.controlItemBgHover
        },
        [`&:not(${n}-disabled).filter-node ${r}-title`]: {
          color: t.colorPrimary,
          fontWeight: 500
        },
        "&-draggable": {
          cursor: "grab",
          [`${r}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: i,
            textAlign: "center",
            visibility: "visible",
            color: s
          },
          [`&${n}-disabled ${r}-draggable-icon`]: {
            visibility: "hidden"
          }
        }
      },
      // >>> Indent
      [`${r}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: c
        }
      },
      // >>> Drag Handler
      [`${r}-draggable-icon`]: {
        visibility: "hidden"
      },
      // Switcher / Checkbox
      [`${r}-switcher, ${r}-checkbox`]: {
        marginInlineEnd: t.calc(t.calc(i).sub(t.controlInteractiveSize)).div(2).equal()
      },
      // >>> Switcher
      [`${r}-switcher`]: Object.assign(Object.assign({}, qf(e, t)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: i,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${t.motionDurationSlow}`,
        "&-noop": {
          cursor: "unset"
        },
        "&:before": {
          pointerEvents: "none",
          content: '""',
          width: i,
          height: i,
          position: "absolute",
          left: {
            _skip_check_: !0,
            value: 0
          },
          top: 0,
          borderRadius: t.borderRadius,
          transition: `all ${t.motionDurationSlow}`
        },
        [`&:not(${r}-switcher-noop):hover:before`]: {
          backgroundColor: t.colorBgTextHover
        },
        [`&_close ${r}-switcher-icon svg`]: {
          transform: "rotate(-90deg)"
        },
        "&-loading-icon": {
          color: t.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(i).div(2).equal(),
            bottom: t.calc(o).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: t.calc(t.calc(i).div(2).equal()).mul(0.8).equal(),
            height: t.calc(i).div(2).equal(),
            borderBottom: `1px solid ${t.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${r}-node-content-wrapper`]: Object.assign(Object.assign({
        position: "relative",
        minHeight: i,
        paddingBlock: 0,
        paddingInline: t.paddingXS,
        background: "transparent",
        borderRadius: t.borderRadius,
        cursor: "pointer",
        transition: `all ${t.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
      }, Xf(e, t)), {
        "&:hover": {
          backgroundColor: d
        },
        [`&${r}-node-selected`]: {
          color: t.nodeSelectedColor,
          backgroundColor: l
        },
        // Icon
        [`${r}-iconEle`]: {
          display: "inline-block",
          width: i,
          height: i,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      }),
      // https://github.com/ant-design/ant-design/issues/28217
      [`${r}-unselectable ${r}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      [`${n}.drop-container > [draggable]`]: {
        boxShadow: `0 0 0 2px ${t.colorPrimary}`
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${r}-indent-unit`]: {
          position: "relative",
          height: "100%",
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(i).div(2).equal(),
            bottom: t.calc(o).mul(-1).equal(),
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&-end:before": {
            display: "none"
          }
        },
        // ============== Cover Background ==============
        [`${r}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${n}-leaf-last ${r}-switcher-leaf-line:before`]: {
        top: "auto !important",
        bottom: "auto !important",
        height: `${U(t.calc(i).div(2).equal())} !important`
      }
    })
  };
}, Gf = (e, t, r = !0) => {
  const n = `.${e}`, o = `${n}-treenode`, i = t.calc(t.paddingXS).div(2).equal(), c = tn(t, {
    treeCls: n,
    treeNodeCls: o,
    treeNodePadding: i
  });
  return [
    // Basic
    Uf(e, c),
    // Directory
    r && Ff(c)
  ].filter(Boolean);
}, Yf = (e) => {
  const {
    controlHeightSM: t,
    controlItemBgHover: r,
    controlItemBgActive: n
  } = e, o = t;
  return {
    titleHeight: o,
    indentSize: o,
    nodeHoverBg: r,
    nodeHoverColor: e.colorText,
    nodeSelectedBg: n,
    nodeSelectedColor: e.colorText
  };
}, Jf = (e) => {
  const {
    colorTextLightSolid: t,
    colorPrimary: r
  } = e;
  return Object.assign(Object.assign({}, Yf(e)), {
    directoryNodeSelectedColor: t,
    directoryNodeSelectedBg: r
  });
}, Qf = pn("Tree", (e, {
  prefixCls: t
}) => [{
  [e.componentCls]: mi(`${t}-checkbox`, e)
}, Gf(t, e), ps(e)], Jf), ba = 4;
function Zf(e) {
  const {
    dropPosition: t,
    dropLevelOffset: r,
    prefixCls: n,
    indent: o,
    direction: i = "ltr"
  } = e, c = i === "ltr" ? "left" : "right", l = i === "ltr" ? "right" : "left", d = {
    [c]: -r * o + ba,
    [l]: 0
  };
  switch (t) {
    case -1:
      d.top = -3;
      break;
    case 1:
      d.bottom = -3;
      break;
    default:
      d.bottom = -3, d[c] = o + ba;
      break;
  }
  return /* @__PURE__ */ oe.createElement("div", {
    style: d,
    className: `${n}-drop-indicator`
  });
}
const ev = (e) => {
  const {
    prefixCls: t,
    switcherIcon: r,
    treeNodeProps: n,
    showLine: o,
    switcherLoadingIcon: i
  } = e, {
    isLeaf: c,
    expanded: l,
    loading: d
  } = n;
  if (d)
    return /* @__PURE__ */ a.isValidElement(i) ? i : /* @__PURE__ */ a.createElement(ms, {
      className: `${t}-switcher-loading-icon`
    });
  let s;
  if (o && typeof o == "object" && (s = o.showLeafIcon), c) {
    if (!o)
      return null;
    if (typeof s != "boolean" && s) {
      const p = typeof s == "function" ? s(n) : s, u = `${t}-switcher-line-custom-icon`;
      return /* @__PURE__ */ a.isValidElement(p) ? wr(p, {
        className: Q(p.props.className || "", u)
      }) : p;
    }
    return s ? /* @__PURE__ */ a.createElement(lo, {
      className: `${t}-switcher-line-icon`
    }) : /* @__PURE__ */ a.createElement("span", {
      className: `${t}-switcher-leaf-line`
    });
  }
  const v = `${t}-switcher-icon`, f = typeof r == "function" ? r(n) : r;
  return /* @__PURE__ */ a.isValidElement(f) ? wr(f, {
    className: Q(f.props.className || "", v)
  }) : f !== void 0 ? f : o ? l ? /* @__PURE__ */ a.createElement(Mi, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ a.createElement(_i, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ a.createElement(Ni, {
    className: v
  });
}, ho = /* @__PURE__ */ oe.forwardRef((e, t) => {
  var r;
  const {
    getPrefixCls: n,
    direction: o,
    virtual: i,
    tree: c
  } = oe.useContext(Gt), {
    prefixCls: l,
    className: d,
    showIcon: s = !1,
    showLine: v,
    switcherIcon: f,
    switcherLoadingIcon: p,
    blockNode: u = !1,
    children: g,
    checkable: b = !1,
    selectable: m = !0,
    draggable: h,
    motion: C,
    style: S
  } = e, E = n("tree", l), x = n(), w = C ?? Object.assign(Object.assign({}, ns(x)), {
    motionAppear: !1
  }), N = Object.assign(Object.assign({}, e), {
    checkable: b,
    selectable: m,
    showIcon: s,
    motion: w,
    blockNode: u,
    showLine: !!v,
    dropIndicatorRender: Zf
  }), [I, y, M] = Qf(E), [, T] = Mn(), O = T.paddingXS / 2 + (((r = T.Tree) === null || r === void 0 ? void 0 : r.titleHeight) || T.controlHeightSM), R = oe.useMemo(() => {
    if (!h)
      return !1;
    let $ = {};
    switch (typeof h) {
      case "function":
        $.nodeDraggable = h;
        break;
      case "object":
        $ = Object.assign({}, h);
        break;
    }
    return $.icon !== !1 && ($.icon = $.icon || /* @__PURE__ */ oe.createElement(Ti, null)), $;
  }, [h]), P = ($) => /* @__PURE__ */ oe.createElement(ev, {
    prefixCls: E,
    switcherIcon: f,
    switcherLoadingIcon: p,
    treeNodeProps: $,
    showLine: v
  });
  return I(
    // @ts-ignore
    /* @__PURE__ */ oe.createElement(go, Object.assign({
      itemHeight: O,
      ref: t,
      virtual: i
    }, N, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, c == null ? void 0 : c.style), S),
      prefixCls: E,
      className: Q({
        [`${E}-icon-hide`]: !s,
        [`${E}-block-node`]: u,
        [`${E}-unselectable`]: !m,
        [`${E}-rtl`]: o === "rtl"
      }, c == null ? void 0 : c.className, d, y, M),
      direction: o,
      checkable: b && /* @__PURE__ */ oe.createElement("span", {
        className: `${E}-checkbox-inner`
      }),
      selectable: m,
      switcherIcon: P,
      draggable: R
    }), g)
  );
});
process.env.NODE_ENV !== "production" && (ho.displayName = "Tree");
const ya = 0, Cr = 1, Ca = 2;
function bo(e, t, r) {
  const {
    key: n,
    children: o
  } = r;
  function i(c) {
    const l = c[n], d = c[o];
    t(l, c) !== !1 && bo(d || [], t, r);
  }
  e.forEach(i);
}
function tv({
  treeData: e,
  expandedKeys: t,
  startKey: r,
  endKey: n,
  fieldNames: o
}) {
  const i = [];
  let c = ya;
  if (r && r === n)
    return [r];
  if (!r || !n)
    return [];
  function l(d) {
    return d === r || d === n;
  }
  return bo(e, (d) => {
    if (c === Ca)
      return !1;
    if (l(d)) {
      if (i.push(d), c === ya)
        c = Cr;
      else if (c === Cr)
        return c = Ca, !1;
    } else c === Cr && i.push(d);
    return t.includes(d);
  }, Dn(o)), i;
}
function Sr(e, t, r) {
  const n = _e(t), o = [];
  return bo(e, (i, c) => {
    const l = n.indexOf(i);
    return l !== -1 && (o.push(c), n.splice(l, 1)), !!n.length;
  }, Dn(r)), o;
}
var Sa = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function nv(e) {
  const {
    isLeaf: t,
    expanded: r
  } = e;
  return t ? /* @__PURE__ */ a.createElement(lo, null) : r ? /* @__PURE__ */ a.createElement(Pi, null) : /* @__PURE__ */ a.createElement(Di, null);
}
function xa({
  treeData: e,
  children: t
}) {
  return e || vi(t);
}
const rv = (e, t) => {
  var {
    defaultExpandAll: r,
    defaultExpandParent: n,
    defaultExpandedKeys: o
  } = e, i = Sa(e, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const c = a.useRef(null), l = a.useRef(null), d = () => {
    const {
      keyEntities: I
    } = oo(xa(i));
    let y;
    return r ? y = Object.keys(I) : n ? y = kr(i.expandedKeys || o || [], I) : y = i.expandedKeys || o || [], y;
  }, [s, v] = a.useState(i.selectedKeys || i.defaultSelectedKeys || []), [f, p] = a.useState(() => d());
  a.useEffect(() => {
    "selectedKeys" in i && v(i.selectedKeys);
  }, [i.selectedKeys]), a.useEffect(() => {
    "expandedKeys" in i && p(i.expandedKeys);
  }, [i.expandedKeys]);
  const u = (I, y) => {
    var M;
    return "expandedKeys" in i || p(I), (M = i.onExpand) === null || M === void 0 ? void 0 : M.call(i, I, y);
  }, g = (I, y) => {
    var M;
    const {
      multiple: T,
      fieldNames: O
    } = i, {
      node: R,
      nativeEvent: P
    } = y, {
      key: $ = ""
    } = R, D = xa(i), _ = Object.assign(Object.assign({}, y), {
      selected: !0
    }), z = (P == null ? void 0 : P.ctrlKey) || (P == null ? void 0 : P.metaKey), B = P == null ? void 0 : P.shiftKey;
    let W;
    T && z ? (W = I, c.current = $, l.current = W, _.selectedNodes = Sr(D, W, O)) : T && B ? (W = Array.from(new Set([].concat(_e(l.current || []), _e(tv({
      treeData: D,
      expandedKeys: f,
      startKey: $,
      endKey: c.current,
      fieldNames: O
    }))))), _.selectedNodes = Sr(D, W, O)) : (W = [$], c.current = $, l.current = W, _.selectedNodes = Sr(D, W, O)), (M = i.onSelect) === null || M === void 0 || M.call(i, W, _), "selectedKeys" in i || v(W);
  }, {
    getPrefixCls: b,
    direction: m
  } = a.useContext(Gt), {
    prefixCls: h,
    className: C,
    showIcon: S = !0,
    expandAction: E = "click"
  } = i, x = Sa(i, ["prefixCls", "className", "showIcon", "expandAction"]), w = b("tree", h), N = Q(`${w}-directory`, {
    [`${w}-directory-rtl`]: m === "rtl"
  }, C);
  return /* @__PURE__ */ a.createElement(ho, Object.assign({
    icon: nv,
    ref: t,
    blockNode: !0
  }, x, {
    showIcon: S,
    expandAction: E,
    prefixCls: w,
    className: N,
    expandedKeys: f,
    selectedKeys: s,
    onSelect: g,
    onExpand: u
  }));
}, ul = /* @__PURE__ */ a.forwardRef(rv);
process.env.NODE_ENV !== "production" && (ul.displayName = "DirectoryTree");
const yo = ho;
yo.DirectoryTree = ul;
yo.TreeNode = Tn;
const Ea = (e) => {
  const {
    value: t,
    filterSearch: r,
    tablePrefixCls: n,
    locale: o,
    onChange: i
  } = e;
  return r ? /* @__PURE__ */ a.createElement("div", {
    className: `${n}-filter-dropdown-search`
  }, /* @__PURE__ */ a.createElement(hs, {
    prefix: /* @__PURE__ */ a.createElement(gs, null),
    placeholder: o.filterSearchPlaceholder,
    onChange: i,
    value: t,
    // for skip min-width of input
    htmlSize: 1,
    className: `${n}-filter-dropdown-search-input`
  })) : null;
}, ov = (e) => {
  const {
    keyCode: t
  } = e;
  t === Ie.ENTER && e.stopPropagation();
}, fl = /* @__PURE__ */ a.forwardRef((e, t) => /* @__PURE__ */ a.createElement("div", {
  className: e.className,
  onClick: (r) => r.stopPropagation(),
  onKeyDown: ov,
  ref: t
}, e.children));
process.env.NODE_ENV !== "production" && (fl.displayName = "FilterDropdownMenuWrapper");
function In(e) {
  let t = [];
  return (e || []).forEach(({
    value: r,
    children: n
  }) => {
    t.push(r), n && (t = [].concat(_e(t), _e(In(n))));
  }), t;
}
function av(e) {
  return e.some(({
    children: t
  }) => t);
}
function vl(e, t) {
  return typeof t == "string" || typeof t == "number" ? t == null ? void 0 : t.toString().toLowerCase().includes(e.trim().toLowerCase()) : !1;
}
function pl({
  filters: e,
  prefixCls: t,
  filteredKeys: r,
  filterMultiple: n,
  searchValue: o,
  filterSearch: i
}) {
  return e.map((c, l) => {
    const d = String(c.value);
    if (c.children)
      return {
        key: d || l,
        label: c.text,
        popupClassName: `${t}-dropdown-submenu`,
        children: pl({
          filters: c.children,
          prefixCls: t,
          filteredKeys: r,
          filterMultiple: n,
          searchValue: o,
          filterSearch: i
        })
      };
    const s = n ? yn : Xn, v = {
      key: c.value !== void 0 ? d : l,
      label: /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(s, {
        checked: r.includes(d)
      }), /* @__PURE__ */ a.createElement("span", null, c.text))
    };
    return o.trim() ? typeof i == "function" ? i(o, c) ? v : null : vl(o, c.text) ? v : null : v;
  });
}
function xr(e) {
  return e || [];
}
const iv = (e) => {
  var t, r, n, o;
  const {
    tablePrefixCls: i,
    prefixCls: c,
    column: l,
    dropdownPrefixCls: d,
    columnKey: s,
    filterOnClose: v,
    filterMultiple: f,
    filterMode: p = "menu",
    filterSearch: u = !1,
    filterState: g,
    triggerFilter: b,
    locale: m,
    children: h,
    getPopupContainer: C,
    rootClassName: S
  } = e, {
    filterResetToDefaultFilteredValue: E,
    defaultFilteredValue: x,
    filterDropdownProps: w = {},
    // Deprecated
    filterDropdownOpen: N,
    filterDropdownVisible: I,
    onFilterDropdownVisibleChange: y,
    onFilterDropdownOpenChange: M
  } = l, [T, O] = a.useState(!1), R = !!(g && (!((t = g.filteredKeys) === null || t === void 0) && t.length || g.forceFiltered)), P = (V) => {
    var G;
    O(V), (G = w.onOpenChange) === null || G === void 0 || G.call(w, V), M == null || M(V), y == null || y(V);
  };
  if (process.env.NODE_ENV !== "production") {
    const V = rn("Table");
    [["filterDropdownOpen", "filterDropdownProps.open"], ["filterDropdownVisible", "filterDropdownProps.open"], ["onFilterDropdownOpenChange", "filterDropdownProps.onOpenChange"], ["onFilterDropdownVisibleChange", "filterDropdownProps.onOpenChange"]].forEach(([Ce, be]) => {
      V.deprecated(!(Ce in l), Ce, be);
    }), V.deprecated(!("filterCheckall" in m), "filterCheckall", "locale.filterCheckAll");
  }
  const $ = (o = (n = (r = w.open) !== null && r !== void 0 ? r : N) !== null && n !== void 0 ? n : I) !== null && o !== void 0 ? o : T, D = g == null ? void 0 : g.filteredKeys, [_, z] = Kf(xr(D)), B = ({
    selectedKeys: V
  }) => {
    z(V);
  }, W = (V, {
    node: G,
    checked: Ce
  }) => {
    B(f ? {
      selectedKeys: V
    } : {
      selectedKeys: Ce && G.key ? [G.key] : []
    });
  };
  a.useEffect(() => {
    T && B({
      selectedKeys: xr(D)
    });
  }, [D]);
  const [X, Y] = a.useState([]), ee = (V) => {
    Y(V);
  }, [ie, ue] = a.useState(""), xe = (V) => {
    const {
      value: G
    } = V.target;
    ue(G);
  };
  a.useEffect(() => {
    T || ue("");
  }, [T]);
  const Z = (V) => {
    const G = V != null && V.length ? V : null;
    if (G === null && (!g || !g.filteredKeys) || Vn(G, g == null ? void 0 : g.filteredKeys, !0))
      return null;
    b({
      column: l,
      key: s,
      filteredKeys: G
    });
  }, ae = () => {
    P(!1), Z(_());
  }, me = ({
    confirm: V,
    closeDropdown: G
  } = {
    confirm: !1,
    closeDropdown: !1
  }) => {
    V && Z([]), G && P(!1), ue(""), z(E ? (x || []).map((Ce) => String(Ce)) : []);
  }, ye = ({
    closeDropdown: V
  } = {
    closeDropdown: !0
  }) => {
    V && P(!1), Z(_());
  }, L = (V, G) => {
    G.source === "trigger" && (V && D !== void 0 && z(xr(D)), P(V), !V && !l.filterDropdown && v && ae());
  }, k = Q({
    [`${d}-menu-without-submenu`]: !av(l.filters || [])
  }), H = (V) => {
    if (V.target.checked) {
      const G = In(l == null ? void 0 : l.filters).map((Ce) => String(Ce));
      z(G);
    } else
      z([]);
  }, q = ({
    filters: V
  }) => (V || []).map((G, Ce) => {
    const be = String(G.value), $e = {
      title: G.text,
      key: G.value !== void 0 ? be : String(Ce)
    };
    return G.children && ($e.children = q({
      filters: G.children
    })), $e;
  }), A = (V) => {
    var G;
    return Object.assign(Object.assign({}, V), {
      text: V.title,
      value: V.key,
      children: ((G = V.children) === null || G === void 0 ? void 0 : G.map((Ce) => A(Ce))) || []
    });
  };
  let j;
  const {
    direction: fe,
    renderEmpty: te
  } = a.useContext(Gt);
  if (typeof l.filterDropdown == "function")
    j = l.filterDropdown({
      prefixCls: `${d}-custom`,
      setSelectedKeys: (V) => B({
        selectedKeys: V
      }),
      selectedKeys: _(),
      confirm: ye,
      clearFilters: me,
      filters: l.filters,
      visible: $,
      close: () => {
        P(!1);
      }
    });
  else if (l.filterDropdown)
    j = l.filterDropdown;
  else {
    const V = _() || [], G = () => {
      var be, $e;
      const qe = (be = te == null ? void 0 : te("Table.filter")) !== null && be !== void 0 ? be : /* @__PURE__ */ a.createElement(Zt, {
        image: Zt.PRESENTED_IMAGE_SIMPLE,
        description: m.filterEmptyText,
        styles: {
          image: {
            height: 24
          }
        },
        style: {
          margin: 0,
          padding: "16px 0"
        }
      });
      if ((l.filters || []).length === 0)
        return qe;
      if (p === "tree")
        return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ea, {
          filterSearch: u,
          value: ie,
          onChange: xe,
          tablePrefixCls: i,
          locale: m
        }), /* @__PURE__ */ a.createElement("div", {
          className: `${i}-filter-dropdown-tree`
        }, f ? /* @__PURE__ */ a.createElement(yn, {
          checked: V.length === In(l.filters).length,
          indeterminate: V.length > 0 && V.length < In(l.filters).length,
          className: `${i}-filter-dropdown-checkall`,
          onChange: H
        }, ($e = m == null ? void 0 : m.filterCheckall) !== null && $e !== void 0 ? $e : m == null ? void 0 : m.filterCheckAll) : null, /* @__PURE__ */ a.createElement(yo, {
          checkable: !0,
          selectable: !1,
          blockNode: !0,
          multiple: f,
          checkStrictly: !f,
          className: `${d}-menu`,
          onCheck: W,
          checkedKeys: V,
          selectedKeys: V,
          showIcon: !1,
          treeData: q({
            filters: l.filters
          }),
          autoExpandParent: !0,
          defaultExpandAll: !0,
          filterTreeNode: ie.trim() ? (Se) => typeof u == "function" ? u(ie, A(Se)) : vl(ie, Se.title) : void 0
        })));
      const Oe = pl({
        filters: l.filters || [],
        filterSearch: u,
        prefixCls: c,
        filteredKeys: _(),
        filterMultiple: f,
        searchValue: ie
      }), He = Oe.every((Se) => Se === null);
      return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ea, {
        filterSearch: u,
        value: ie,
        onChange: xe,
        tablePrefixCls: i,
        locale: m
      }), He ? qe : /* @__PURE__ */ a.createElement(Cl, {
        selectable: !0,
        multiple: f,
        prefixCls: `${d}-menu`,
        className: k,
        onSelect: B,
        onDeselect: B,
        selectedKeys: V,
        getPopupContainer: C,
        openKeys: X,
        onOpenChange: ee,
        items: Oe
      }));
    }, Ce = () => E ? Vn((x || []).map((be) => String(be)), V, !0) : V.length === 0;
    j = /* @__PURE__ */ a.createElement(a.Fragment, null, G(), /* @__PURE__ */ a.createElement("div", {
      className: `${c}-dropdown-btns`
    }, /* @__PURE__ */ a.createElement(Po, {
      type: "link",
      size: "small",
      disabled: Ce(),
      onClick: () => me()
    }, m.filterReset), /* @__PURE__ */ a.createElement(Po, {
      type: "primary",
      size: "small",
      onClick: ae
    }, m.filterConfirm)));
  }
  l.filterDropdown && (j = /* @__PURE__ */ a.createElement(Sl, {
    selectable: void 0
  }, j)), j = /* @__PURE__ */ a.createElement(fl, {
    className: `${c}-dropdown`
  }, j);
  const Ee = La({
    trigger: ["click"],
    placement: fe === "rtl" ? "bottomLeft" : "bottomRight",
    children: (() => {
      let V;
      return typeof l.filterIcon == "function" ? V = l.filterIcon(R) : l.filterIcon ? V = l.filterIcon : V = /* @__PURE__ */ a.createElement(Ri, null), /* @__PURE__ */ a.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: Q(`${c}-trigger`, {
          active: R
        }),
        onClick: (G) => {
          G.stopPropagation();
        }
      }, V);
    })(),
    getPopupContainer: C
  }, Object.assign(Object.assign({}, w), {
    rootClassName: Q(S, w.rootClassName),
    open: $,
    onOpenChange: L,
    popupRender: () => typeof (w == null ? void 0 : w.dropdownRender) == "function" ? w.dropdownRender(j) : j
  }));
  return /* @__PURE__ */ a.createElement("div", {
    className: `${c}-column`
  }, /* @__PURE__ */ a.createElement("span", {
    className: `${i}-column-title`
  }, h), /* @__PURE__ */ a.createElement(Pa, Object.assign({}, Ee)));
}, Hr = (e, t, r) => {
  let n = [];
  return (e || []).forEach((o, i) => {
    var c;
    const l = zn(i, r), d = o.filterDropdown !== void 0;
    if (o.filters || d || "onFilter" in o)
      if ("filteredValue" in o) {
        let s = o.filteredValue;
        d || (s = (c = s == null ? void 0 : s.map(String)) !== null && c !== void 0 ? c : s), n.push({
          column: o,
          key: vn(o, l),
          filteredKeys: s,
          forceFiltered: o.filtered
        });
      } else
        n.push({
          column: o,
          key: vn(o, l),
          filteredKeys: t && o.defaultFilteredValue ? o.defaultFilteredValue : void 0,
          forceFiltered: o.filtered
        });
    "children" in o && (n = [].concat(_e(n), _e(Hr(o.children, t, l))));
  }), n;
};
function ml(e, t, r, n, o, i, c, l, d) {
  return r.map((s, v) => {
    const f = zn(v, l), {
      filterOnClose: p = !0,
      filterMultiple: u = !0,
      filterMode: g,
      filterSearch: b
    } = s;
    let m = s;
    if (m.filters || m.filterDropdown) {
      const h = vn(m, f), C = n.find(({
        key: S
      }) => h === S);
      m = Object.assign(Object.assign({}, m), {
        title: (S) => /* @__PURE__ */ a.createElement(iv, {
          tablePrefixCls: e,
          prefixCls: `${e}-filter`,
          dropdownPrefixCls: t,
          column: m,
          columnKey: h,
          filterState: C,
          filterOnClose: p,
          filterMultiple: u,
          filterMode: g,
          filterSearch: b,
          triggerFilter: i,
          locale: o,
          getPopupContainer: c,
          rootClassName: d
        }, dr(s.title, S))
      });
    }
    return "children" in m && (m = Object.assign(Object.assign({}, m), {
      children: ml(e, t, m.children, n, o, i, c, f, d)
    })), m;
  });
}
const wa = (e) => {
  const t = {};
  return e.forEach(({
    key: r,
    filteredKeys: n,
    column: o
  }) => {
    const i = r, {
      filters: c,
      filterDropdown: l
    } = o;
    if (l)
      t[i] = n || null;
    else if (Array.isArray(n)) {
      const d = In(c);
      t[i] = d.filter((s) => n.includes(String(s)));
    } else
      t[i] = null;
  }), t;
}, jr = (e, t, r) => t.reduce((o, i) => {
  const {
    column: {
      onFilter: c,
      filters: l
    },
    filteredKeys: d
  } = i;
  return c && d && d.length ? o.map((s) => Object.assign({}, s)).filter((s) => d.some((v) => {
    const f = In(l), p = f.findIndex((g) => String(g) === String(v)), u = p !== -1 ? f[p] : v;
    return s[r] && (s[r] = jr(s[r], t, r)), c(u, s);
  })) : o;
}, e), gl = (e) => e.flatMap((t) => "children" in t ? [t].concat(_e(gl(t.children || []))) : [t]), lv = (e) => {
  const {
    prefixCls: t,
    dropdownPrefixCls: r,
    mergedColumns: n,
    onFilterChange: o,
    getPopupContainer: i,
    locale: c,
    rootClassName: l
  } = e, d = rn("Table"), s = a.useMemo(() => gl(n || []), [n]), [v, f] = a.useState(() => Hr(s, !0)), p = a.useMemo(() => {
    const m = Hr(s, !1);
    if (m.length === 0)
      return m;
    let h = !0, C = !0;
    if (m.forEach(({
      filteredKeys: S
    }) => {
      S !== void 0 ? h = !1 : C = !1;
    }), h) {
      const S = (s || []).map((E, x) => vn(E, zn(x)));
      return v.filter(({
        key: E
      }) => S.includes(E)).map((E) => {
        const x = s[S.findIndex((w) => w === E.key)];
        return Object.assign(Object.assign({}, E), {
          column: Object.assign(Object.assign({}, E.column), x),
          forceFiltered: x.filtered
        });
      });
    }
    return process.env.NODE_ENV !== "production" && d(C, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`."), m;
  }, [s, v]), u = a.useMemo(() => wa(p), [p]), g = (m) => {
    const h = p.filter(({
      key: C
    }) => C !== m.key);
    h.push(m), f(h), o(wa(h), h);
  };
  return [(m) => ml(t, r, m, p, c, g, i, void 0, l), p, u];
}, sv = (e, t, r) => {
  const n = a.useRef({});
  function o(i) {
    var c;
    if (!n.current || n.current.data !== e || n.current.childrenColumnName !== t || n.current.getRowKey !== r) {
      let d = function(s) {
        s.forEach((v, f) => {
          const p = r(v, f);
          l.set(p, v), v && typeof v == "object" && t in v && d(v[t] || []);
        });
      };
      const l = /* @__PURE__ */ new Map();
      d(e), n.current = {
        data: e,
        childrenColumnName: t,
        kvMap: l,
        getRowKey: r
      };
    }
    return (c = n.current.kvMap) === null || c === void 0 ? void 0 : c.get(i);
  }
  return [o];
};
var cv = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const hl = 10;
function dv(e, t) {
  const r = {
    current: e.current,
    pageSize: e.pageSize
  };
  return Object.keys(t && typeof t == "object" ? t : {}).forEach((o) => {
    const i = e[o];
    typeof i != "function" && (r[o] = i);
  }), r;
}
function uv(e, t, r) {
  const n = r && typeof r == "object" ? r : {}, {
    total: o = 0
  } = n, i = cv(n, ["total"]), [c, l] = dn(() => ({
    current: "defaultCurrent" in i ? i.defaultCurrent : 1,
    pageSize: "defaultPageSize" in i ? i.defaultPageSize : hl
  })), d = La(c, i, {
    total: o > 0 ? o : e
  }), s = Math.ceil((o || e) / d.pageSize);
  d.current > s && (d.current = s || 1);
  const v = (p, u) => {
    l({
      current: p ?? 1,
      pageSize: u || d.pageSize
    });
  }, f = (p, u) => {
    var g;
    r && ((g = r.onChange) === null || g === void 0 || g.call(r, p, u)), v(p, u), t(p, u || (d == null ? void 0 : d.pageSize));
  };
  return r === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, d), {
    onChange: f
  }), v];
}
const Qn = "ascend", Er = "descend", nr = (e) => typeof e.sorter == "object" && typeof e.sorter.multiple == "number" ? e.sorter.multiple : !1, $a = (e) => typeof e == "function" ? e : e && typeof e == "object" && e.compare ? e.compare : !1, fv = (e, t) => t ? e[e.indexOf(t) + 1] : e[0], Vr = (e, t, r) => {
  let n = [];
  const o = (i, c) => {
    n.push({
      column: i,
      key: vn(i, c),
      multiplePriority: nr(i),
      sortOrder: i.sortOrder
    });
  };
  return (e || []).forEach((i, c) => {
    const l = zn(c, r);
    i.children ? ("sortOrder" in i && o(i, l), n = [].concat(_e(n), _e(Vr(i.children, t, l)))) : i.sorter && ("sortOrder" in i ? o(i, l) : t && i.defaultSortOrder && n.push({
      column: i,
      key: vn(i, l),
      multiplePriority: nr(i),
      sortOrder: i.defaultSortOrder
    }));
  }), n;
}, bl = (e, t, r, n, o, i, c, l) => (t || []).map((s, v) => {
  const f = zn(v, l);
  let p = s;
  if (p.sorter) {
    const u = p.sortDirections || o, g = p.showSorterTooltip === void 0 ? c : p.showSorterTooltip, b = vn(p, f), m = r.find(({
      key: y
    }) => y === b), h = m ? m.sortOrder : null, C = fv(u, h);
    let S;
    if (s.sortIcon)
      S = s.sortIcon({
        sortOrder: h
      });
    else {
      const y = u.includes(Qn) && /* @__PURE__ */ a.createElement(Ii, {
        className: Q(`${e}-column-sorter-up`, {
          active: h === Qn
        })
      }), M = u.includes(Er) && /* @__PURE__ */ a.createElement(Oi, {
        className: Q(`${e}-column-sorter-down`, {
          active: h === Er
        })
      });
      S = /* @__PURE__ */ a.createElement("span", {
        className: Q(`${e}-column-sorter`, {
          [`${e}-column-sorter-full`]: !!(y && M)
        })
      }, /* @__PURE__ */ a.createElement("span", {
        className: `${e}-column-sorter-inner`,
        "aria-hidden": "true"
      }, y, M));
    }
    const {
      cancelSort: E,
      triggerAsc: x,
      triggerDesc: w
    } = i || {};
    let N = E;
    C === Er ? N = w : C === Qn && (N = x);
    const I = typeof g == "object" ? Object.assign({
      title: N
    }, g) : {
      title: N
    };
    p = Object.assign(Object.assign({}, p), {
      className: Q(p.className, {
        [`${e}-column-sort`]: h
      }),
      title: (y) => {
        const M = `${e}-column-sorters`, T = /* @__PURE__ */ a.createElement("span", {
          className: `${e}-column-title`
        }, dr(s.title, y)), O = /* @__PURE__ */ a.createElement("div", {
          className: M
        }, T, S);
        return g ? typeof g != "boolean" && (g == null ? void 0 : g.target) === "sorter-icon" ? /* @__PURE__ */ a.createElement("div", {
          className: `${M} ${e}-column-sorters-tooltip-target-sorter`
        }, T, /* @__PURE__ */ a.createElement(Mo, Object.assign({}, I), S)) : /* @__PURE__ */ a.createElement(Mo, Object.assign({}, I), O) : O;
      },
      onHeaderCell: (y) => {
        var M;
        const T = ((M = s.onHeaderCell) === null || M === void 0 ? void 0 : M.call(s, y)) || {}, O = T.onClick, R = T.onKeyDown;
        T.onClick = (D) => {
          n({
            column: s,
            key: b,
            sortOrder: C,
            multiplePriority: nr(s)
          }), O == null || O(D);
        }, T.onKeyDown = (D) => {
          D.keyCode === Ie.ENTER && (n({
            column: s,
            key: b,
            sortOrder: C,
            multiplePriority: nr(s)
          }), R == null || R(D));
        };
        const P = kf(s.title, {}), $ = P == null ? void 0 : P.toString();
        return h && (T["aria-sort"] = h === "ascend" ? "ascending" : "descending"), T["aria-label"] = $ || "", T.className = Q(T.className, `${e}-column-has-sorters`), T.tabIndex = 0, s.ellipsis && (T.title = (P ?? "").toString()), T;
      }
    });
  }
  return "children" in p && (p = Object.assign(Object.assign({}, p), {
    children: bl(e, p.children, r, n, o, i, c, f)
  })), p;
}), Na = (e) => {
  const {
    column: t,
    sortOrder: r
  } = e;
  return {
    column: t,
    order: r,
    field: t.dataIndex,
    columnKey: t.key
  };
}, Oa = (e) => {
  const t = e.filter(({
    sortOrder: r
  }) => r).map(Na);
  if (t.length === 0 && e.length) {
    const r = e.length - 1;
    return Object.assign(Object.assign({}, Na(e[r])), {
      column: void 0,
      order: void 0,
      field: void 0,
      columnKey: void 0
    });
  }
  return t.length <= 1 ? t[0] || {} : t;
}, Ar = (e, t, r) => {
  const n = t.slice().sort((c, l) => l.multiplePriority - c.multiplePriority), o = e.slice(), i = n.filter(({
    column: {
      sorter: c
    },
    sortOrder: l
  }) => $a(c) && l);
  return i.length ? o.sort((c, l) => {
    for (let d = 0; d < i.length; d += 1) {
      const s = i[d], {
        column: {
          sorter: v
        },
        sortOrder: f
      } = s, p = $a(v);
      if (p && f) {
        const u = p(c, l, f);
        if (u !== 0)
          return f === Qn ? u : -u;
      }
    }
    return 0;
  }).map((c) => {
    const l = c[r];
    return l ? Object.assign(Object.assign({}, c), {
      [r]: Ar(l, t, r)
    }) : c;
  }) : o;
}, vv = (e) => {
  const {
    prefixCls: t,
    mergedColumns: r,
    sortDirections: n,
    tableLocale: o,
    showSorterTooltip: i,
    onSorterChange: c
  } = e, [l, d] = a.useState(() => Vr(r, !0)), s = (b, m) => {
    const h = [];
    return b.forEach((C, S) => {
      const E = zn(S, m);
      if (h.push(vn(C, E)), Array.isArray(C.children)) {
        const x = s(C.children, E);
        h.push.apply(h, _e(x));
      }
    }), h;
  }, v = a.useMemo(() => {
    let b = !0;
    const m = Vr(r, !1);
    if (!m.length) {
      const E = s(r);
      return l.filter(({
        key: x
      }) => E.includes(x));
    }
    const h = [];
    function C(E) {
      b ? h.push(E) : h.push(Object.assign(Object.assign({}, E), {
        sortOrder: null
      }));
    }
    let S = null;
    return m.forEach((E) => {
      S === null ? (C(E), E.sortOrder && (E.multiplePriority === !1 ? b = !1 : S = !0)) : (S && E.multiplePriority !== !1 || (b = !1), C(E));
    }), h;
  }, [r, l]), f = a.useMemo(() => {
    var b, m;
    const h = v.map(({
      column: C,
      sortOrder: S
    }) => ({
      column: C,
      order: S
    }));
    return {
      sortColumns: h,
      // Legacy
      sortColumn: (b = h[0]) === null || b === void 0 ? void 0 : b.column,
      sortOrder: (m = h[0]) === null || m === void 0 ? void 0 : m.order
    };
  }, [v]), p = (b) => {
    let m;
    b.multiplePriority === !1 || !v.length || v[0].multiplePriority === !1 ? m = [b] : m = [].concat(_e(v.filter(({
      key: h
    }) => h !== b.key)), [b]), d(m), c(Oa(m), m);
  };
  return [(b) => bl(t, b, v, p, n, o, i), v, f, () => Oa(v)];
}, yl = (e, t) => e.map((n) => {
  const o = Object.assign({}, n);
  return o.title = dr(n.title, t), "children" in o && (o.children = yl(o.children, t)), o;
}), pv = (e) => [a.useCallback((r) => yl(r, e), [e])], mv = el((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: n
  } = t;
  return r !== n;
}), gv = ol((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: n
  } = t;
  return r !== n;
}), hv = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    lineType: n,
    tableBorderColor: o,
    tableHeaderBg: i,
    tablePaddingVertical: c,
    tablePaddingHorizontal: l,
    calc: d
  } = e, s = `${U(r)} ${n} ${o}`, v = (f, p, u) => ({
    [`&${t}-${f}`]: {
      [`> ${t}-container`]: {
        [`> ${t}-content, > ${t}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${t}-expanded-row-fixed`]: {
              margin: `${U(d(p).mul(-1).equal())}
              ${U(d(d(u).add(r)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${t}-wrapper`]: {
      [`${t}${t}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${t}-title`]: {
          border: s,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${t}-container`]: {
          borderInlineStart: s,
          borderTop: s,
          [`
            > ${t}-content,
            > ${t}-header,
            > ${t}-body,
            > ${t}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: s
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: s
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${t}-cell-fix-right-first::after`]: {
                  borderInlineEnd: s
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${t}-expanded-row-fixed`]: {
                  margin: `${U(d(c).mul(-1).equal())} ${U(d(d(l).add(r)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: r,
                    bottom: 0,
                    borderInlineEnd: s,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${t}-scroll-horizontal`]: {
          [`> ${t}-container > ${t}-body`]: {
            "> table > tbody": {
              [`
                > tr${t}-expanded-row,
                > tr${t}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, v("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle)), v("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${t}-footer`]: {
          border: s,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${t}-cell`]: {
        [`${t}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${U(r)} 0 ${U(r)} ${i}`
        }
      },
      [`${t}-bordered ${t}-cell-scrollbar`]: {
        borderInlineEnd: s
      }
    }
  };
}, bv = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-cell-ellipsis`]: Object.assign(Object.assign({}, Zn), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${t}-cell-fix-left-last,
          &${t}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${t}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${t}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, yv = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-tbody > tr${t}-placeholder`]: {
        textAlign: "center",
        color: e.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: e.colorBgContainer
        }
      }
    }
  };
}, Cv = (e) => {
  const {
    componentCls: t,
    antCls: r,
    motionDurationSlow: n,
    lineWidth: o,
    paddingXS: i,
    lineType: c,
    tableBorderColor: l,
    tableExpandIconBg: d,
    tableExpandColumnWidth: s,
    borderRadius: v,
    tablePaddingVertical: f,
    tablePaddingHorizontal: p,
    tableExpandedRowBg: u,
    paddingXXS: g,
    expandIconMarginTop: b,
    expandIconSize: m,
    expandIconHalfInner: h,
    expandIconScale: C,
    calc: S
  } = e, E = `${U(o)} ${c} ${l}`, x = S(g).sub(o).equal();
  return {
    [`${t}-wrapper`]: {
      [`${t}-expand-icon-col`]: {
        width: s
      },
      [`${t}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${t}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${t}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${t}-row-expand-icon`]: Object.assign(Object.assign({}, Ml(e)), {
        position: "relative",
        float: "left",
        width: m,
        height: m,
        color: "inherit",
        lineHeight: U(m),
        background: d,
        border: E,
        borderRadius: v,
        transform: `scale(${C})`,
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${n} ease-out`,
          content: '""'
        },
        "&::before": {
          top: h,
          insetInlineEnd: x,
          insetInlineStart: x,
          height: o
        },
        "&::after": {
          top: x,
          bottom: x,
          insetInlineStart: h,
          width: o,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${t}-row-indent + ${t}-row-expand-icon`]: {
        marginTop: b,
        marginInlineEnd: i
      },
      [`tr${t}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: u
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${r}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "100%"
          }
        }
      },
      // With fixed
      [`${t}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${U(S(f).mul(-1).equal())} ${U(S(p).mul(-1).equal())}`,
        padding: `${U(f)} ${U(p)}`
      }
    }
  };
}, Sv = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: n,
    tableFilterDropdownWidth: o,
    tableFilterDropdownSearchWidth: i,
    paddingXXS: c,
    paddingXS: l,
    colorText: d,
    lineWidth: s,
    lineType: v,
    tableBorderColor: f,
    headerIconColor: p,
    fontSizeSM: u,
    tablePaddingHorizontal: g,
    borderRadius: b,
    motionDurationSlow: m,
    colorIcon: h,
    colorPrimary: C,
    tableHeaderFilterActiveBg: S,
    colorTextDisabled: E,
    tableFilterDropdownBg: x,
    tableFilterDropdownHeight: w,
    controlItemBgHover: N,
    controlItemBgActive: I,
    boxShadowSecondary: y,
    filterDropdownMenuBg: M,
    calc: T
  } = e, O = `${r}-dropdown`, R = `${t}-filter-dropdown`, P = `${r}-tree`, $ = `${U(s)} ${v} ${f}`;
  return [
    {
      [`${t}-wrapper`]: {
        [`${t}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${t}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: T(c).mul(-1).equal(),
          marginInline: `${U(c)} ${U(T(g).div(2).mul(-1).equal())}`,
          padding: `0 ${U(c)}`,
          color: p,
          fontSize: u,
          borderRadius: b,
          cursor: "pointer",
          transition: `all ${m}`,
          "&:hover": {
            color: h,
            background: S
          },
          "&.active": {
            color: C
          }
        }
      }
    },
    {
      // Dropdown
      [`${r}-dropdown`]: {
        [R]: Object.assign(Object.assign({}, zt(e)), {
          minWidth: o,
          backgroundColor: x,
          borderRadius: b,
          boxShadow: y,
          overflow: "hidden",
          // Reset menu
          [`${O}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: w,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: M,
            "&:empty::after": {
              display: "block",
              padding: `${U(l)} 0`,
              color: E,
              fontSize: u,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${R}-tree`]: {
            paddingBlock: `${U(l)} 0`,
            paddingInline: l,
            [P]: {
              padding: 0
            },
            [`${P}-treenode ${P}-node-content-wrapper:hover`]: {
              backgroundColor: N
            },
            [`${P}-treenode-checkbox-checked ${P}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: I
              }
            }
          },
          [`${R}-search`]: {
            padding: l,
            borderBottom: $,
            "&-input": {
              input: {
                minWidth: i
              },
              [n]: {
                color: E
              }
            }
          },
          [`${R}-checkall`]: {
            width: "100%",
            marginBottom: c,
            marginInlineStart: c
          },
          // Operation
          [`${R}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${U(T(l).sub(s).equal())} ${U(l)}`,
            overflow: "hidden",
            borderTop: $
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${r}-dropdown ${R}, ${R}-submenu`]: {
        // Checkbox
        [`${r}-checkbox-wrapper + span`]: {
          paddingInlineStart: l,
          color: d
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, xv = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    colorSplit: n,
    motionDurationSlow: o,
    zIndexTableFixed: i,
    tableBg: c,
    zIndexTableSticky: l,
    calc: d
  } = e, s = n;
  return {
    [`${t}-wrapper`]: {
      [`
        ${t}-cell-fix-left,
        ${t}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: i,
        background: c
      },
      [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: d(r).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: d(r).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: d(l).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${o}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${t}-ping-left`]: {
        [`&:not(${t}-has-fix-left) ${t}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${s}`
        },
        [`
          ${t}-cell-fix-left-first::after,
          ${t}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${s}`
        },
        [`${t}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${t}-ping-right`]: {
        [`&:not(${t}-has-fix-right) ${t}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${s}`
        },
        [`
          ${t}-cell-fix-right-first::after,
          ${t}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${s}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${t}-fixed-column-gapped`]: {
        [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after,
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
}, Ev = (e) => {
  const {
    componentCls: t,
    antCls: r,
    margin: n
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${t}-pagination${r}-pagination`]: {
        margin: `${U(n)} 0`
      },
      [`${t}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: e.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, wv = (e) => {
  const {
    componentCls: t,
    tableRadius: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      [t]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${t}-title, ${t}-header`]: {
          borderRadius: `${U(r)} ${U(r)} 0 0`
        },
        [`${t}-title + ${t}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${t}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: r,
          borderStartEndRadius: r,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: r
            },
            "> *:last-child": {
              borderStartEndRadius: r
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${U(r)} ${U(r)}`
        }
      }
    }
  };
}, $v = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${t}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${t}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${t}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${t}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${t}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, Nv = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: n,
    fontSizeIcon: o,
    padding: i,
    paddingXS: c,
    headerIconColor: l,
    headerIconHoverColor: d,
    tableSelectionColumnWidth: s,
    tableSelectedRowBg: v,
    tableSelectedRowHoverBg: f,
    tableRowHoverBg: p,
    tablePaddingHorizontal: u,
    calc: g
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Selections ==========================
      [`${t}-selection-col`]: {
        width: s,
        [`&${t}-selection-col-with-dropdown`]: {
          width: g(s).add(o).add(g(i).div(4)).equal()
        }
      },
      [`${t}-bordered ${t}-selection-col`]: {
        width: g(s).add(g(c).mul(2)).equal(),
        [`&${t}-selection-col-with-dropdown`]: {
          width: g(s).add(o).add(g(i).div(4)).add(g(c).mul(2)).equal()
        }
      },
      [`
        table tr th${t}-selection-column,
        table tr td${t}-selection-column,
        ${t}-selection-column
      `]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS,
        textAlign: "center",
        [`${r}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${t}-selection-column${t}-cell-fix-left`]: {
        zIndex: g(e.zIndexTableFixed).add(1).equal({
          unit: !1
        })
      },
      [`table tr th${t}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${t}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${t}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: U(g(u).div(4).equal()),
        [n]: {
          color: l,
          fontSize: o,
          verticalAlign: "baseline",
          "&:hover": {
            color: d
          }
        }
      },
      // ============================= Rows =============================
      [`${t}-tbody`]: {
        [`${t}-row`]: {
          [`&${t}-row-selected`]: {
            [`> ${t}-cell`]: {
              background: v,
              "&-row-hover": {
                background: f
              }
            }
          },
          [`> ${t}-cell-row-hover`]: {
            background: p
          }
        }
      }
    }
  };
}, Ov = (e) => {
  const {
    componentCls: t,
    tableExpandColumnWidth: r,
    calc: n
  } = e, o = (i, c, l, d) => ({
    [`${t}${t}-${i}`]: {
      fontSize: d,
      [`
        ${t}-title,
        ${t}-footer,
        ${t}-cell,
        ${t}-thead > tr > th,
        ${t}-tbody > tr > th,
        ${t}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${U(c)} ${U(l)}`
      },
      [`${t}-filter-trigger`]: {
        marginInlineEnd: U(n(l).div(2).mul(-1).equal())
      },
      [`${t}-expanded-row-fixed`]: {
        margin: `${U(n(c).mul(-1).equal())} ${U(n(l).mul(-1).equal())}`
      },
      [`${t}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${t}-wrapper:only-child ${t}`]: {
          marginBlock: U(n(c).mul(-1).equal()),
          marginInline: `${U(n(r).sub(l).equal())} ${U(n(l).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${t}-selection-extra`]: {
        paddingInlineStart: U(n(l).div(4).equal())
      }
    }
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, o("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle, e.tableFontSizeMiddle)), o("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall, e.tableFontSizeSmall))
  };
}, Iv = (e) => {
  const {
    componentCls: t,
    marginXXS: r,
    fontSizeIcon: n,
    headerIconColor: o,
    headerIconHoverColor: i
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-thead th${t}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        // why left 0s? Avoid column header move with transition when left is changed
        // https://github.com/ant-design/ant-design/issues/50588
        transition: `all ${e.motionDurationSlow}, left 0s`,
        "&:hover": {
          background: e.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: e.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${t}-cell-fix-left:hover,
          &${t}-cell-fix-right:hover
        `]: {
          background: e.tableFixedHeaderSortActiveBg
        }
      },
      [`${t}-thead th${t}-column-sort`]: {
        background: e.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${t}-column-sort`]: {
        background: e.tableBodySortBg
      },
      [`${t}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1,
        minWidth: 0
      },
      [`${t}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${t}-column-sorters-tooltip-target-sorter`]: {
        "&::after": {
          content: "none"
        }
      },
      [`${t}-column-sorter`]: {
        marginInlineStart: r,
        color: o,
        fontSize: 0,
        transition: `color ${e.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: n,
          "&.active": {
            color: e.colorPrimary
          }
        },
        [`${t}-column-sorter-up + ${t}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${t}-column-sorters:hover ${t}-column-sorter`]: {
        color: i
      }
    }
  };
}, Rv = (e) => {
  const {
    componentCls: t,
    opacityLoading: r,
    tableScrollThumbBg: n,
    tableScrollThumbBgHover: o,
    tableScrollThumbSize: i,
    tableScrollBg: c,
    zIndexTableSticky: l,
    stickyScrollBarBorderRadius: d,
    lineWidth: s,
    lineType: v,
    tableBorderColor: f
  } = e, p = `${U(s)} ${v} ${f}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: l,
          background: e.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${U(i)} !important`,
          zIndex: l,
          display: "flex",
          alignItems: "center",
          background: c,
          borderTop: p,
          opacity: r,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: i,
            backgroundColor: n,
            borderRadius: d,
            transition: `all ${e.motionDurationSlow}, transform 0s`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: o
            }
          }
        }
      }
    }
  };
}, Ia = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    tableBorderColor: n,
    calc: o
  } = e, i = `${U(r)} ${e.lineType} ${n}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-summary`]: {
        position: "relative",
        zIndex: e.zIndexTableFixed,
        background: e.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: i
          }
        }
      },
      [`div${t}-summary`]: {
        boxShadow: `0 ${U(o(r).mul(-1).equal())} 0 ${n}`
      }
    }
  };
}, Pv = (e) => {
  const {
    componentCls: t,
    motionDurationMid: r,
    lineWidth: n,
    lineType: o,
    tableBorderColor: i,
    calc: c
  } = e, l = `${U(n)} ${o} ${i}`, d = `${t}-expanded-row-cell`;
  return {
    [`${t}-wrapper`]: {
      // ========================== Row ==========================
      [`${t}-tbody-virtual`]: {
        [`${t}-tbody-virtual-holder-inner`]: {
          [`
            & > ${t}-row, 
            & > div:not(${t}-row) > ${t}-row
          `]: {
            display: "flex",
            boxSizing: "border-box",
            width: "100%"
          }
        },
        [`${t}-cell`]: {
          borderBottom: l,
          transition: `background ${r}`
        },
        [`${t}-expanded-row`]: {
          [`${d}${d}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${U(n)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${t}-bordered`]: {
        [`${t}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: l,
            position: "absolute"
          },
          [`${t}-cell`]: {
            borderInlineEnd: l,
            [`&${t}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: c(n).mul(-1).equal(),
              borderInlineStart: l
            }
          }
        },
        // Empty placeholder
        [`&${t}-virtual`]: {
          [`${t}-placeholder ${t}-cell`]: {
            borderInlineEnd: l,
            borderBottom: l
          }
        }
      }
    }
  };
}, Dv = (e) => {
  const {
    componentCls: t,
    fontWeightStrong: r,
    tablePaddingVertical: n,
    tablePaddingHorizontal: o,
    tableExpandColumnWidth: i,
    lineWidth: c,
    lineType: l,
    tableBorderColor: d,
    tableFontSize: s,
    tableBg: v,
    tableRadius: f,
    tableHeaderTextColor: p,
    motionDurationMid: u,
    tableHeaderBg: g,
    tableHeaderCellSplitColor: b,
    tableFooterTextColor: m,
    tableFooterBg: h,
    calc: C
  } = e, S = `${U(c)} ${l} ${d}`;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%"
    }, _l()), {
      [t]: Object.assign(Object.assign({}, zt(e)), {
        fontSize: s,
        background: v,
        borderRadius: `${U(f)} ${U(f)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${e.tableScrollThumbBg} ${e.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${U(f)} ${U(f)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${t}-cell,
          ${t}-thead > tr > th,
          ${t}-tbody > tr > th,
          ${t}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${U(n)} ${U(o)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${t}-title`]: {
        padding: `${U(n)} ${U(o)}`
      },
      // ============================ Header ============================
      [`${t}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: p,
          fontWeight: r,
          textAlign: "start",
          background: g,
          borderBottom: S,
          transition: `background ${u} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${t}-selection-column):not(${t}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: b,
            transform: "translateY(-50%)",
            transition: `background-color ${u}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${t}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${u}, border-color ${u}`,
            borderBottom: S,
            // ========================= Nest Table ===========================
            [`
              > ${t}-wrapper:only-child,
              > ${t}-expanded-row-fixed > ${t}-wrapper:only-child
            `]: {
              [t]: {
                marginBlock: U(C(n).mul(-1).equal()),
                marginInline: `${U(C(i).sub(o).equal())}
                ${U(C(o).mul(-1).equal())}`,
                [`${t}-tbody > tr:last-child > td`]: {
                  borderBottomWidth: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: p,
            fontWeight: r,
            textAlign: "start",
            background: g,
            borderBottom: S,
            transition: `background ${u} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${t}-footer`]: {
        padding: `${U(n)} ${U(o)}`,
        color: m,
        background: h
      }
    })
  };
}, Tv = (e) => {
  const {
    colorFillAlter: t,
    colorBgContainer: r,
    colorTextHeading: n,
    colorFillSecondary: o,
    colorFillContent: i,
    controlItemBgActive: c,
    controlItemBgActiveHover: l,
    padding: d,
    paddingSM: s,
    paddingXS: v,
    colorBorderSecondary: f,
    borderRadiusLG: p,
    controlHeight: u,
    colorTextPlaceholder: g,
    fontSize: b,
    fontSizeSM: m,
    lineHeight: h,
    lineWidth: C,
    colorIcon: S,
    colorIconHover: E,
    opacityLoading: x,
    controlInteractiveSize: w
  } = e, N = new cn(o).onBackground(r).toHexString(), I = new cn(i).onBackground(r).toHexString(), y = new cn(t).onBackground(r).toHexString(), M = new cn(S), T = new cn(E), O = w / 2 - C, R = O * 2 + C * 3;
  return {
    headerBg: y,
    headerColor: n,
    headerSortActiveBg: N,
    headerSortHoverBg: I,
    bodySortBg: y,
    rowHoverBg: y,
    rowSelectedBg: c,
    rowSelectedHoverBg: l,
    rowExpandedBg: t,
    cellPaddingBlock: d,
    cellPaddingInline: d,
    cellPaddingBlockMD: s,
    cellPaddingInlineMD: v,
    cellPaddingBlockSM: v,
    cellPaddingInlineSM: v,
    borderColor: f,
    headerBorderRadius: p,
    footerBg: y,
    footerColor: n,
    cellFontSize: b,
    cellFontSizeMD: b,
    cellFontSizeSM: b,
    headerSplitColor: f,
    fixedHeaderSortActiveBg: N,
    headerFilterHoverBg: i,
    filterDropdownMenuBg: r,
    filterDropdownBg: r,
    expandIconBg: r,
    selectionColumnWidth: u,
    stickyScrollBarBg: g,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (b * h - C * 3) / 2 - Math.ceil((m * 1.4 - C * 3) / 2),
    headerIconColor: M.clone().setA(M.a * x).toRgbString(),
    headerIconHoverColor: T.clone().setA(T.a * x).toRgbString(),
    expandIconHalfInner: O,
    expandIconSize: R,
    expandIconScale: w / R
  };
}, Ra = 2, Mv = pn("Table", (e) => {
  const {
    colorTextHeading: t,
    colorSplit: r,
    colorBgContainer: n,
    controlInteractiveSize: o,
    headerBg: i,
    headerColor: c,
    headerSortActiveBg: l,
    headerSortHoverBg: d,
    bodySortBg: s,
    rowHoverBg: v,
    rowSelectedBg: f,
    rowSelectedHoverBg: p,
    rowExpandedBg: u,
    cellPaddingBlock: g,
    cellPaddingInline: b,
    cellPaddingBlockMD: m,
    cellPaddingInlineMD: h,
    cellPaddingBlockSM: C,
    cellPaddingInlineSM: S,
    borderColor: E,
    footerBg: x,
    footerColor: w,
    headerBorderRadius: N,
    cellFontSize: I,
    cellFontSizeMD: y,
    cellFontSizeSM: M,
    headerSplitColor: T,
    fixedHeaderSortActiveBg: O,
    headerFilterHoverBg: R,
    filterDropdownBg: P,
    expandIconBg: $,
    selectionColumnWidth: D,
    stickyScrollBarBg: _,
    calc: z
  } = e, B = tn(e, {
    tableFontSize: I,
    tableBg: n,
    tableRadius: N,
    tablePaddingVertical: g,
    tablePaddingHorizontal: b,
    tablePaddingVerticalMiddle: m,
    tablePaddingHorizontalMiddle: h,
    tablePaddingVerticalSmall: C,
    tablePaddingHorizontalSmall: S,
    tableBorderColor: E,
    tableHeaderTextColor: c,
    tableHeaderBg: i,
    tableFooterTextColor: w,
    tableFooterBg: x,
    tableHeaderCellSplitColor: T,
    tableHeaderSortBg: l,
    tableHeaderSortHoverBg: d,
    tableBodySortBg: s,
    tableFixedHeaderSortActiveBg: O,
    tableHeaderFilterActiveBg: R,
    tableFilterDropdownBg: P,
    tableRowHoverBg: v,
    tableSelectedRowBg: f,
    tableSelectedRowHoverBg: p,
    zIndexTableFixed: Ra,
    zIndexTableSticky: z(Ra).add(1).equal({
      unit: !1
    }),
    tableFontSizeMiddle: y,
    tableFontSizeSmall: M,
    tableSelectionColumnWidth: D,
    tableExpandIconBg: $,
    tableExpandColumnWidth: z(o).add(z(e.padding).mul(2)).equal(),
    tableExpandedRowBg: u,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: _,
    tableScrollThumbBgHover: t,
    tableScrollBg: r
  });
  return [Dv(B), Ev(B), Ia(B), Iv(B), Sv(B), hv(B), wv(B), Cv(B), Ia(B), yv(B), Nv(B), xv(B), Rv(B), bv(B), Ov(B), $v(B), Pv(B)];
}, Tv, {
  unitless: {
    expandIconScale: !0
  }
}), _v = [], kv = (e, t) => {
  var r, n;
  const {
    prefixCls: o,
    className: i,
    rootClassName: c,
    style: l,
    size: d,
    bordered: s,
    dropdownPrefixCls: v,
    dataSource: f,
    pagination: p,
    rowSelection: u,
    rowKey: g = "key",
    rowClassName: b,
    columns: m,
    children: h,
    childrenColumnName: C,
    onChange: S,
    getPopupContainer: E,
    loading: x,
    expandIcon: w,
    expandable: N,
    expandedRowRender: I,
    expandIconColumnIndex: y,
    indentSize: M,
    scroll: T,
    sortDirections: O,
    locale: R,
    showSorterTooltip: P = {
      target: "full-header"
    },
    virtual: $
  } = e, D = rn("Table");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && D(!(typeof g == "function" && g.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
  const _ = a.useMemo(() => m || fo(h), [m, h]), z = a.useMemo(() => _.some((ge) => ge.responsive), [_]), B = za(z), W = a.useMemo(() => {
    const ge = new Set(Object.keys(B).filter((Me) => B[Me]));
    return _.filter((Me) => !Me.responsive || Me.responsive.some((Be) => ge.has(Be)));
  }, [_, B]), X = qn(e, ["className", "style", "columns"]), {
    locale: Y = Bl,
    direction: ee,
    table: ie,
    renderEmpty: ue,
    getPrefixCls: xe,
    getPopupContainer: Z
  } = a.useContext(Gt), ae = or(d), me = Object.assign(Object.assign({}, Y.Table), R), ye = f || _v, L = xe("table", o), k = xe("dropdown", v), [, H] = Mn(), q = _n(L), [A, j, fe] = Mv(L, q), te = Object.assign(Object.assign({
    childrenColumnName: C,
    expandIconColumnIndex: y
  }, N), {
    expandIcon: (r = N == null ? void 0 : N.expandIcon) !== null && r !== void 0 ? r : (n = ie == null ? void 0 : ie.expandable) === null || n === void 0 ? void 0 : n.expandIcon
  }), {
    childrenColumnName: Ne = "children"
  } = te, Ee = a.useMemo(() => ye.some((ge) => ge == null ? void 0 : ge[Ne]) ? "nest" : I || N != null && N.expandedRowRender ? "row" : null, [ye]), V = {
    body: a.useRef(null)
  }, G = _f(L), Ce = a.useRef(null), be = a.useRef(null);
  Tf(t, () => Object.assign(Object.assign({}, be.current), {
    nativeElement: Ce.current
  }));
  const $e = a.useMemo(() => typeof g == "function" ? g : (ge) => ge == null ? void 0 : ge[g], [g]), [qe] = sv(ye, Ne, $e), Oe = {}, He = (ge, Me, Be = !1) => {
    var We, nt, ht, Et;
    const rt = Object.assign(Object.assign({}, Oe), ge);
    Be && ((We = Oe.resetPagination) === null || We === void 0 || We.call(Oe), !((nt = rt.pagination) === null || nt === void 0) && nt.current && (rt.pagination.current = 1), p && ((ht = p.onChange) === null || ht === void 0 || ht.call(p, 1, (Et = rt.pagination) === null || Et === void 0 ? void 0 : Et.pageSize))), T && T.scrollToFirstRowOnChange !== !1 && V.body.current && Cs(0, {
      getContainer: () => V.body.current
    }), S == null || S(rt.pagination, rt.filters, rt.sorter, {
      currentDataSource: jr(Ar(ye, rt.sorterStates, Ne), rt.filterStates, Ne),
      action: Me
    });
  }, Se = (ge, Me) => {
    He({
      sorter: ge,
      sorterStates: Me
    }, "sort", !1);
  }, [he, ne, J, ke] = vv({
    prefixCls: L,
    mergedColumns: W,
    onSorterChange: Se,
    sortDirections: O || ["ascend", "descend"],
    tableLocale: me,
    showSorterTooltip: P
  }), Te = a.useMemo(() => Ar(ye, ne, Ne), [ye, ne]);
  Oe.sorter = ke(), Oe.sorterStates = ne;
  const ve = (ge, Me) => {
    He({
      filters: ge,
      filterStates: Me
    }, "filter", !0);
  }, [tt, De, at] = lv({
    prefixCls: L,
    locale: me,
    dropdownPrefixCls: k,
    mergedColumns: W,
    onFilterChange: ve,
    getPopupContainer: E || Z,
    rootClassName: Q(c, q)
  }), je = jr(Te, De, Ne);
  Oe.filters = at, Oe.filterStates = De;
  const dt = a.useMemo(() => {
    const ge = {};
    return Object.keys(at).forEach((Me) => {
      at[Me] !== null && (ge[Me] = at[Me]);
    }), Object.assign(Object.assign({}, J), {
      filters: ge
    });
  }, [J, at]), [ut] = pv(dt), xt = (ge, Me) => {
    He({
      pagination: Object.assign(Object.assign({}, Oe.pagination), {
        current: ge,
        pageSize: Me
      })
    }, "paginate");
  }, [Ue, Tt] = uv(je.length, xt, p);
  Oe.pagination = p === !1 ? {} : dv(Ue, p), Oe.resetPagination = Tt;
  const it = a.useMemo(() => {
    if (p === !1 || !Ue.pageSize)
      return je;
    const {
      current: ge = 1,
      total: Me,
      pageSize: Be = hl
    } = Ue;
    return process.env.NODE_ENV !== "production" && D(ge > 0, "usage", "`current` should be positive number."), je.length < Me ? je.length > Be ? (process.env.NODE_ENV !== "production" && D(!1, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode."), je.slice((ge - 1) * Be, ge * Be)) : je : je.slice((ge - 1) * Be, ge * Be);
  }, [!!p, je, Ue == null ? void 0 : Ue.current, Ue == null ? void 0 : Ue.pageSize, Ue == null ? void 0 : Ue.total]), [lt, ft] = Pf({
    prefixCls: L,
    data: je,
    pageData: it,
    getRowKey: $e,
    getRecordByKey: qe,
    expandType: Ee,
    childrenColumnName: Ne,
    locale: me,
    getPopupContainer: E || Z
  }, u), ot = (ge, Me, Be) => {
    let We;
    return typeof b == "function" ? We = Q(b(ge, Me, Be)) : We = Q(b), Q({
      [`${L}-row-selected`]: ft.has($e(ge, Me))
    }, We);
  };
  te.__PARENT_RENDER_ICON__ = te.expandIcon, te.expandIcon = te.expandIcon || w || Mf(me), Ee === "nest" && te.expandIconColumnIndex === void 0 ? te.expandIconColumnIndex = u ? 1 : 0 : te.expandIconColumnIndex > 0 && u && (te.expandIconColumnIndex -= 1), typeof te.indentSize != "number" && (te.indentSize = typeof M == "number" ? M : 15);
  const Ae = a.useCallback((ge) => ut(lt(tt(he(ge)))), [he, tt, lt]);
  let vt, pt;
  if (p !== !1 && (Ue != null && Ue.total)) {
    let ge;
    Ue.size ? ge = Ue.size : ge = ae === "small" || ae === "middle" ? "small" : void 0;
    const Me = (nt) => /* @__PURE__ */ a.createElement(xi, Object.assign({}, Ue, {
      className: Q(`${L}-pagination ${L}-pagination-${nt}`, Ue.className),
      size: ge
    })), Be = ee === "rtl" ? "left" : "right", {
      position: We
    } = Ue;
    if (We !== null && Array.isArray(We)) {
      const nt = We.find((rt) => rt.includes("top")), ht = We.find((rt) => rt.includes("bottom")), Et = We.every((rt) => `${rt}` == "none");
      !nt && !ht && !Et && (pt = Me(Be)), nt && (vt = Me(nt.toLowerCase().replace("top", ""))), ht && (pt = Me(ht.toLowerCase().replace("bottom", "")));
    } else
      pt = Me(Be);
  }
  let le;
  typeof x == "boolean" ? le = {
    spinning: x
  } : typeof x == "object" && (le = Object.assign({
    spinning: !0
  }, x));
  const re = Q(fe, q, `${L}-wrapper`, ie == null ? void 0 : ie.className, {
    [`${L}-wrapper-rtl`]: ee === "rtl"
  }, i, c, j), se = Object.assign(Object.assign({}, ie == null ? void 0 : ie.style), l), de = typeof (R == null ? void 0 : R.emptyText) < "u" ? R.emptyText : (ue == null ? void 0 : ue("Table")) || /* @__PURE__ */ a.createElement(ti, {
    componentName: "Table"
  }), Le = $ ? gv : mv, Ge = {}, mt = a.useMemo(() => {
    const {
      fontSize: ge,
      lineHeight: Me,
      lineWidth: Be,
      padding: We,
      paddingXS: nt,
      paddingSM: ht
    } = H, Et = Math.floor(ge * Me);
    switch (ae) {
      case "middle":
        return ht * 2 + Et + Be;
      case "small":
        return nt * 2 + Et + Be;
      default:
        return We * 2 + Et + Be;
    }
  }, [H, ae]);
  return $ && (Ge.listItemHeight = mt), A(/* @__PURE__ */ a.createElement("div", {
    ref: Ce,
    className: re,
    style: se
  }, /* @__PURE__ */ a.createElement(io, Object.assign({
    spinning: !1
  }, le), vt, /* @__PURE__ */ a.createElement(Le, Object.assign({}, Ge, X, {
    ref: be,
    columns: W,
    direction: ee,
    expandable: te,
    prefixCls: L,
    className: Q({
      [`${L}-middle`]: ae === "middle",
      [`${L}-small`]: ae === "small",
      [`${L}-bordered`]: s,
      [`${L}-empty`]: ye.length === 0
    }, fe, q, j),
    data: it,
    rowKey: $e,
    rowClassName: ot,
    emptyText: de,
    // Internal
    internalHooks: Gn,
    internalRefs: V,
    transformColumns: Ae,
    getContainerWidth: G
  })), pt)));
}, Kv = /* @__PURE__ */ a.forwardRef(kv), Bv = (e, t) => {
  const r = a.useRef(0);
  return r.current += 1, /* @__PURE__ */ a.createElement(Kv, Object.assign({}, e, {
    ref: t,
    _renderTimes: r.current
  }));
}, Bt = /* @__PURE__ */ a.forwardRef(Bv);
Bt.SELECTION_COLUMN = Qt;
Bt.EXPAND_COLUMN = Ut;
Bt.SELECTION_ALL = Kr;
Bt.SELECTION_INVERT = Br;
Bt.SELECTION_NONE = zr;
Bt.Column = yf;
Bt.ColumnGroup = Cf;
Bt.Summary = Li;
process.env.NODE_ENV !== "production" && (Bt.displayName = "Table");
const zv = {
  pageSize: 10,
  showSizeChanger: !1
}, Lv = {
  sm: "small",
  md: "middle",
  lg: "large"
}, Hv = wl(Bt)`
  && {
    .ant-spin-nested-loading {
      .ant-spin-spinning {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .ant-table-footer {
      background-color: transparent;
      padding: 0 !important;
    }
  }
`, jv = Da(
  ({
    data: e,
    loading: t,
    emptyText: r,
    pagination: n,
    getRowProps: o,
    getHeaderProps: i,
    size: c = "md",
    ...l
  }, d) => /* @__PURE__ */ Co(
    Hv,
    {
      ...l,
      onRow: o,
      onHeaderRow: i,
      pagination: n === !0 ? { ...zv } : n,
      ref: d,
      dataSource: e,
      loading: t && {
        spinning: !0,
        indicator: /* @__PURE__ */ Co(El, {})
      },
      size: Lv[c],
      ...r ? { locale: { emptyText: r } } : {}
    }
  )
);
Object.assign(jv, {
  displayName: "Table",
  Column: Bt.Column,
  ColumnGroup: Bt.ColumnGroup,
  EXPAND_COLUMN: Bt.EXPAND_COLUMN,
  SELECTION_COLUMN: Bt.SELECTION_COLUMN
});
export {
  jv as T
};
